var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 730,
    height: 729,
    viewBox: "0 0 730 729",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M365.057 267.442C311.197 267.442 267.809 311.329 267.809 364.691C267.809 418.552 311.695 461.94 365.057 461.94C418.918 461.94 462.306 418.053 462.306 364.691C462.306 310.83 418.918 267.442 365.057 267.442ZM365.057 452.963C316.682 452.963 276.785 413.565 276.785 364.691C276.785 316.316 316.184 276.419 365.057 276.419C413.433 276.419 453.33 315.817 453.33 364.691C453.33 413.066 413.433 452.963 365.057 452.963Z",
    fill: "url(#paint0_linear_58_4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M411.936 318.81C410.939 319.308 409.941 320.306 408.944 321.303C409.941 320.306 410.44 319.308 411.438 318.311C416.425 309.833 404.456 297.365 406.45 294.373C404.954 296.866 387.998 293.375 383.51 301.853C383.011 302.851 382.512 304.347 382.014 305.344C382.512 303.848 382.512 302.851 382.512 301.355C382.512 291.879 366.055 286.393 366.055 283.401C366.055 286.393 349.597 291.879 349.597 301.355C349.597 302.851 349.597 303.848 350.096 305.344C349.597 304.347 349.099 302.851 348.6 301.853C343.613 293.375 327.155 297.365 325.659 294.373C327.155 296.866 315.685 309.833 320.672 318.311C321.171 319.308 322.168 320.306 323.166 321.303C322.168 320.306 321.171 319.807 320.173 318.81C311.695 313.823 299.227 325.792 296.235 323.797C298.729 325.293 295.238 342.249 303.716 346.738C304.713 347.236 306.209 347.735 307.207 348.234C305.711 347.735 304.713 347.735 303.217 347.735C293.742 347.735 288.256 364.192 285.263 364.192C288.256 364.192 293.742 380.65 303.217 380.65C304.713 380.65 305.711 380.65 307.207 380.151C306.209 380.65 304.713 381.149 303.716 381.647C295.238 386.635 299.227 403.092 296.235 404.588C298.729 403.092 311.695 414.562 320.173 409.575C321.171 409.077 322.168 408.079 323.166 407.082C322.168 408.079 321.669 409.077 320.672 410.074C315.685 418.552 327.654 431.02 325.659 434.012C327.155 431.519 344.111 435.01 348.6 426.531C349.099 425.534 349.597 424.038 350.096 423.041C349.597 424.537 349.597 425.534 349.597 427.03C349.597 436.506 366.055 441.992 366.055 444.984C366.055 441.992 382.512 436.506 382.512 427.03C382.512 425.534 382.512 424.537 382.014 423.041C382.512 424.038 383.011 425.534 383.51 426.531C388.497 435.01 404.954 431.02 406.45 434.012C404.954 431.519 416.425 418.552 411.438 410.074C410.939 409.077 409.941 408.079 408.944 407.082C409.941 408.079 410.939 408.578 411.936 409.575C420.414 414.562 432.882 402.593 435.874 404.588C433.381 403.092 436.872 386.136 428.394 381.647C427.396 381.149 425.9 380.65 424.903 380.151C426.399 380.65 427.396 380.65 428.893 380.65C438.368 380.65 443.854 364.192 446.846 364.192C443.854 364.192 438.368 347.735 428.893 347.735C427.396 347.735 426.399 347.735 424.903 348.234C425.9 347.735 427.396 347.236 428.394 346.738C436.872 341.75 432.882 325.293 435.874 323.797C432.882 325.792 419.916 313.823 411.936 318.81ZM365.057 407.58C341.618 407.58 322.168 388.131 322.168 364.691C322.168 341.252 341.618 321.802 365.057 321.802C388.497 321.802 407.947 341.252 407.947 364.691C407.947 388.131 388.497 407.58 365.057 407.58ZM407.448 322.301C404.954 325.293 403.458 328.784 402.959 332.275C401.463 330.28 399.468 328.285 397.474 326.789C400.965 326.29 404.456 324.794 407.448 322.301ZM380.517 306.841C379.52 310.83 380.019 314.321 381.515 317.812C379.021 316.815 376.528 316.316 374.034 315.817C377.026 313.823 379.52 310.332 380.517 306.841ZM356.081 315.817C353.587 316.316 351.093 316.815 348.6 317.812C350.096 314.321 350.595 310.83 349.597 306.841C350.595 310.332 353.088 313.823 356.081 315.817ZM332.641 326.789C330.646 328.285 328.651 330.28 327.155 332.275C326.657 328.784 325.16 324.794 322.667 322.301C325.659 324.794 329.15 326.29 332.641 326.789ZM318.178 347.735C317.181 350.229 316.682 352.722 316.184 355.216C314.189 352.223 311.196 349.73 307.207 348.732C311.196 350.229 314.687 349.73 318.178 347.735ZM307.207 380.151C310.698 379.154 314.189 376.66 316.184 373.668C316.682 376.162 317.181 378.655 318.178 381.149C314.687 379.653 311.196 379.154 307.207 380.151ZM322.667 407.082C325.16 404.089 326.657 400.598 327.155 397.107C328.651 399.102 330.646 401.097 332.641 402.593C329.15 403.092 325.659 404.588 322.667 407.082ZM349.597 422.542C350.595 418.552 350.096 415.061 348.6 411.57C351.093 412.568 353.587 413.066 356.081 413.565C353.088 415.56 350.595 419.051 349.597 422.542ZM374.034 413.565C376.528 413.066 379.021 412.568 381.515 411.57C380.019 415.061 379.52 418.552 380.517 422.542C379.52 419.051 377.026 415.56 374.034 413.565ZM397.474 402.593C399.468 401.097 401.463 399.102 402.959 397.107C403.458 400.598 404.954 404.588 407.448 407.082C404.456 404.588 400.965 403.092 397.474 402.593ZM411.936 381.149C412.934 378.655 413.432 376.162 413.931 373.668C415.926 376.66 418.918 379.154 422.908 380.151C418.918 379.154 415.427 379.653 411.936 381.149ZM422.908 349.231C419.417 350.229 415.926 352.722 413.931 355.714C413.432 353.221 412.934 350.727 411.936 348.234C415.427 349.73 418.918 350.229 422.908 349.231Z",
    fill: "url(#paint1_linear_58_4)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M399.967 88.4046C400.466 88.4046 400.965 88.4046 400.965 87.9059C401.463 87.4072 401.463 86.4098 400.466 85.9111C399.967 85.4124 398.97 85.4124 398.471 86.4098C397.972 86.9085 397.972 87.9059 398.97 88.4046C399.469 88.4046 399.469 88.4046 399.967 88.4046Z",
    fill: "url(#paint2_linear_58_4)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M405.952 93.8905C406.451 93.8905 406.451 93.8905 406.949 93.3918C407.448 92.8931 407.448 91.8957 406.949 91.397C406.451 90.8983 405.453 90.8983 404.954 91.397C404.456 91.8957 404.456 92.8931 404.954 93.3918C405.453 93.8905 405.952 93.8905 405.952 93.8905Z",
    fill: "url(#paint3_linear_58_4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M391.988 83.9163H392.486C392.985 83.9163 393.484 83.4175 393.982 82.9188C394.481 82.4201 393.982 81.4227 393.484 80.924C392.985 80.4253 391.988 80.924 391.489 81.4227C390.99 82.9188 391.489 83.4175 391.988 83.9163Z",
    fill: "url(#paint4_linear_58_4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M314.189 105.361C313.69 104.862 312.693 105.361 312.194 105.86C311.695 106.358 312.194 107.356 312.693 107.855H313.192C313.69 107.855 314.189 107.356 314.189 106.857C315.186 106.358 315.186 105.86 314.189 105.361Z",
    fill: "url(#paint5_linear_58_4)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M308.703 121.32C307.705 121.32 307.207 121.818 307.207 122.317C307.207 122.816 307.705 123.813 308.204 123.813C308.703 123.813 309.7 123.315 309.7 122.816C310.199 121.818 309.7 121.32 308.703 121.32Z",
    fill: "url(#paint6_linear_58_4)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M317.181 98.8777C316.682 99.3764 316.682 100.374 317.68 100.873C318.178 100.873 318.178 101.371 318.677 101.371C319.176 101.371 319.674 101.371 319.674 100.873C320.173 100.374 320.173 99.3764 319.176 98.8777C318.178 97.8803 317.68 97.8803 317.181 98.8777Z",
    fill: "url(#paint7_linear_58_4)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M415.926 107.356H416.425C416.923 106.857 417.422 106.358 416.923 105.361C416.923 104.364 415.926 104.364 415.427 104.364C414.929 104.862 414.43 105.361 414.928 106.358C414.928 106.857 415.427 107.356 415.926 107.356Z",
    fill: "url(#paint8_linear_58_4)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M419.417 114.836C419.417 114.836 419.916 114.836 419.417 114.836C420.414 114.338 420.913 113.839 420.913 112.842C420.414 112.343 419.916 111.844 418.918 111.844C418.42 112.343 417.921 112.842 417.921 113.839C418.42 114.338 418.918 114.836 419.417 114.836Z",
    fill: "url(#paint9_linear_58_4)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M411.438 99.8751C411.936 99.8751 411.936 99.8751 412.435 99.3764C412.934 98.8777 413.432 97.8802 412.934 97.3815C412.435 96.8828 411.438 96.8828 410.939 96.8828C410.44 97.3815 410.44 98.379 410.44 98.8777C410.939 99.8751 411.438 99.8751 411.438 99.8751Z",
    fill: "url(#paint10_linear_58_4)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M310.698 112.842C309.7 112.343 309.202 112.842 308.703 113.839C308.204 114.338 308.703 115.335 309.7 115.834H310.199C310.698 115.834 311.197 115.335 311.695 114.837C312.194 113.839 311.695 113.34 310.698 112.842Z",
    fill: "url(#paint11_linear_58_4)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M344.61 81.4227C345.607 80.924 346.106 80.4253 346.106 79.4278C345.607 78.9291 345.109 78.4304 344.111 78.4304C343.612 78.9291 343.114 79.4278 343.114 80.4253C343.612 80.924 344.111 81.4227 344.61 81.4227Z",
    fill: "url(#paint12_linear_58_4)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M337.129 84.9138H337.628C338.127 84.4151 338.626 83.9163 338.127 82.9189C337.628 82.4202 337.129 81.9215 336.132 82.4202C335.633 82.9189 335.135 83.4176 335.633 84.4151C336.132 84.4151 336.631 84.9138 337.129 84.9138Z",
    fill: "url(#paint13_linear_58_4)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M330.147 89.4022C330.646 89.4022 330.646 89.4022 331.145 88.9035C331.644 88.4048 332.142 87.4074 331.644 86.9087C331.145 86.4099 330.147 85.9112 329.649 86.4099C329.15 86.9087 328.651 87.9061 329.15 88.4048C329.15 88.9035 329.649 89.4022 330.147 89.4022Z",
    fill: "url(#paint14_linear_58_4)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M323.664 94.888C324.163 94.888 324.163 94.888 324.662 94.3893C325.16 93.8906 325.16 92.8931 324.662 92.3944C324.163 91.8957 323.165 91.8957 322.667 92.3944C322.168 92.8931 322.168 93.8906 322.667 94.3893C322.667 94.3893 323.165 94.888 323.664 94.888Z",
    fill: "url(#paint15_linear_58_4)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M352.59 78.9291C353.587 78.9291 354.086 77.9317 354.086 77.4329C354.086 76.4355 353.088 75.9368 352.59 76.4355C351.592 76.4355 351.093 77.4329 351.592 77.9317C351.093 78.4304 351.592 78.9291 352.59 78.9291Z",
    fill: "url(#paint16_linear_58_4)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M360.569 77.9317C361.566 77.9317 362.065 76.9343 362.065 76.4356C362.065 75.4382 361.068 74.9395 360.569 74.9395C359.571 74.9395 359.073 75.4382 359.073 76.4356C359.073 77.433 360.07 77.9317 360.569 77.9317Z",
    fill: "url(#paint17_linear_58_4)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M419.916 121.818C419.916 122.317 420.414 122.816 421.412 122.816C421.412 122.816 421.412 122.816 421.91 122.816C422.908 122.816 423.407 121.818 422.908 121.32C422.908 120.322 421.91 119.824 421.412 120.322C420.414 120.322 419.916 120.821 419.916 121.818Z",
    fill: "url(#paint18_linear_58_4)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M377.027 78.4304C377.027 78.9292 377.027 78.9292 377.027 78.4304C378.024 78.4304 378.523 77.9317 378.523 77.433C378.523 76.4356 378.024 75.9369 377.525 75.9369C376.528 75.9369 376.029 76.4356 376.029 76.9343C375.53 77.9317 376.029 78.4304 377.027 78.4304Z",
    fill: "url(#paint19_linear_58_4)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M369.047 77.9317C370.044 77.9317 370.543 77.433 370.543 76.4356C370.543 75.4382 370.044 74.9395 369.047 74.9395C368.05 74.9395 367.551 75.4382 367.551 76.4356C367.551 76.9343 368.05 77.433 369.047 77.9317Z",
    fill: "url(#paint20_linear_58_4)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M384.507 80.924C385.006 80.924 385.006 80.924 384.507 80.924C385.505 80.924 386.004 80.4253 386.502 79.9266C387.001 79.4279 386.502 78.4305 385.505 77.9318C385.006 77.9318 384.009 77.9318 383.51 78.9292C383.51 79.9266 384.009 80.4253 384.507 80.924Z",
    fill: "url(#paint21_linear_58_4)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M293.242 127.304C293.242 127.304 293.242 126.806 293.242 127.304C294.24 126.806 294.24 125.808 293.741 125.309C293.243 124.811 292.245 124.811 291.746 125.309C291.248 125.808 291.248 126.806 291.746 127.304C291.746 127.304 292.744 127.304 293.242 127.304Z",
    fill: "url(#paint22_linear_58_4)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M287.258 121.32C287.258 120.821 287.258 120.821 287.258 121.32C288.256 120.322 288.256 119.325 287.258 118.826C286.76 118.327 285.762 118.327 285.263 118.826C284.765 119.325 284.765 120.322 285.263 120.821C286.261 121.32 286.76 121.32 287.258 121.32Z",
    fill: "url(#paint23_linear_58_4)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M279.278 116.333C279.777 116.831 280.276 116.831 280.775 116.333L281.273 115.834C281.772 115.335 281.273 114.338 280.775 113.839C280.276 113.34 279.278 113.839 278.78 114.338C278.281 114.836 278.281 115.834 279.278 116.333Z",
    fill: "url(#paint24_linear_58_4)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M196.991 141.268C196.493 140.77 195.495 141.268 194.996 141.767C194.498 142.266 194.996 143.263 195.495 143.762C195.994 143.762 196.493 143.762 196.991 143.762L197.49 143.263C197.989 142.266 197.49 141.767 196.991 141.268Z",
    fill: "url(#paint25_linear_58_4)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M271.798 112.343C272.297 112.343 272.795 112.343 273.294 112.343C273.793 112.343 273.793 111.844 273.793 111.844C274.292 111.345 273.793 110.348 272.795 109.849C272.297 109.351 271.299 109.849 270.801 110.847C270.801 111.345 271.299 111.844 271.798 112.343Z",
    fill: "url(#paint26_linear_58_4)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M264.317 109.849C264.816 109.849 264.816 109.849 265.315 109.849C265.813 109.849 265.813 109.351 265.813 108.852C265.813 107.854 265.315 107.356 264.816 107.356C263.819 107.356 263.32 107.854 263.32 108.353C262.821 108.852 263.32 109.351 264.317 109.849Z",
    fill: "url(#paint27_linear_58_4)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M191.505 159.721C192.004 159.721 192.004 159.721 192.503 159.721C193.002 159.721 193.002 159.222 193.002 158.723C193.002 157.726 192.503 157.227 192.004 157.227C191.007 157.227 190.508 157.726 190.508 158.224C190.508 159.222 191.007 159.721 191.505 159.721Z",
    fill: "url(#paint28_linear_58_4)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M193.002 151.741C193.5 151.741 193.999 151.741 193.999 151.741C194.498 151.741 194.498 151.242 194.498 150.744C194.498 150.245 194.498 149.248 193.5 149.248C192.503 149.248 192.004 149.248 192.004 150.245C192.004 150.744 192.503 151.741 193.002 151.741Z",
    fill: "url(#paint29_linear_58_4)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M194.498 181.664C193.999 182.163 193.5 182.661 193.5 183.659C193.999 184.158 194.498 184.656 195.495 184.656C195.994 184.157 196.493 183.659 195.994 182.661C195.994 182.163 194.997 181.664 194.498 181.664Z",
    fill: "url(#paint30_linear_58_4)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M192.503 168.199C193.002 167.7 193.002 167.7 193.002 166.702C193.002 165.705 192.503 165.206 191.505 165.206C190.508 165.206 190.009 165.705 190.009 166.702C190.009 167.7 190.508 168.199 191.505 168.199C192.004 168.199 192.004 168.199 192.503 168.199Z",
    fill: "url(#paint31_linear_58_4)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M239.88 108.852C240.379 108.852 240.379 108.852 239.88 108.852C240.878 108.353 240.878 107.854 240.878 107.356C240.878 106.358 239.88 105.86 239.382 106.358C238.384 106.358 237.885 107.356 238.384 107.854C238.384 108.852 239.382 109.351 239.88 108.852Z",
    fill: "url(#paint32_linear_58_4)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M200.981 133.788C200.482 133.289 199.485 133.788 198.986 134.286C198.487 134.785 198.986 135.782 199.485 136.281C199.984 136.78 200.482 136.78 200.981 136.281L201.48 135.782C201.48 135.284 201.48 134.286 200.981 133.788Z",
    fill: "url(#paint33_linear_58_4)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M217.938 118.327C218.436 117.829 218.935 116.831 218.436 116.333C217.937 115.834 216.94 115.335 216.441 115.834C215.943 116.333 215.444 117.33 215.943 117.829C216.441 118.826 217.439 118.826 217.938 118.327Z",
    fill: "url(#paint34_linear_58_4)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M224.919 114.338C225.418 113.839 225.916 113.34 225.418 112.343C224.919 111.844 224.42 111.345 223.423 111.844C222.924 112.343 222.425 112.842 222.924 113.839C223.423 114.338 223.922 114.836 224.919 114.338Z",
    fill: "url(#paint35_linear_58_4)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M211.454 123.813C212.452 123.315 212.452 122.317 211.953 121.818C211.454 121.32 210.457 121.32 209.958 121.818C209.459 122.317 209.459 123.315 209.958 123.813C209.958 123.813 210.955 123.813 211.454 123.813Z",
    fill: "url(#paint36_linear_58_4)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M232.4 110.847C233.398 110.348 233.398 109.849 233.398 108.852C232.899 107.855 232.4 107.855 231.403 107.855C230.904 108.353 230.405 108.852 230.405 109.849C230.904 110.847 231.403 111.346 232.4 110.847Z",
    fill: "url(#paint37_linear_58_4)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M248.359 107.854H248.858C249.356 107.356 249.356 106.857 249.356 106.358C249.356 105.361 248.858 104.862 247.86 104.862C246.863 104.862 246.364 105.361 246.364 106.358C246.863 107.356 247.361 107.854 248.359 107.854Z",
    fill: "url(#paint38_linear_58_4)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M203.973 127.304C203.475 127.803 203.475 128.8 203.973 129.299C204.472 129.798 204.971 129.798 205.47 129.299C205.47 129.299 205.968 129.299 205.968 128.8C206.467 128.302 206.467 127.304 205.968 126.806C205.47 126.806 204.472 126.806 203.973 127.304Z",
    fill: "url(#paint39_linear_58_4)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M256.338 108.353C256.837 108.353 256.837 108.353 257.335 108.353C257.834 108.353 257.834 107.854 257.834 107.356C257.834 106.358 257.335 105.86 256.338 105.86C255.341 105.86 254.842 106.358 254.842 107.356C254.842 107.356 255.341 108.353 256.338 108.353Z",
    fill: "url(#paint40_linear_58_4)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M193.999 174.682C193.999 173.685 193.002 173.186 192.503 173.685C191.505 173.685 191.007 174.682 191.505 175.181C191.505 176.178 192.503 176.677 193.002 176.178H193.5C193.999 176.178 193.999 175.679 193.999 174.682Z",
    fill: "url(#paint41_linear_58_4)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M135.65 200.615C136.149 199.617 136.149 199.119 136.149 198.62C135.65 198.121 134.652 197.623 134.154 198.121C133.655 198.62 133.156 199.618 133.655 200.116C133.655 201.114 134.652 201.114 135.65 200.615Z",
    fill: "url(#paint42_linear_58_4)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M142.632 197.124C143.131 197.124 143.131 196.625 143.131 196.625C143.131 196.127 143.629 195.628 143.131 195.129C142.632 194.63 142.133 194.132 141.136 194.63C140.637 195.129 140.138 195.628 140.637 196.625C141.136 197.124 141.634 197.124 142.632 197.124Z",
    fill: "url(#paint43_linear_58_4)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M150.113 194.132C150.611 194.132 150.611 193.633 151.11 193.633C151.11 193.134 151.11 193.134 151.11 192.636C151.11 191.638 150.113 191.638 149.115 191.638C148.118 191.638 148.118 192.636 148.118 193.633C148.616 194.132 149.614 194.63 150.113 194.132Z",
    fill: "url(#paint44_linear_58_4)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M129.166 205.602C129.665 204.605 129.665 204.106 129.166 203.607C128.668 203.108 127.67 203.108 127.171 203.607C126.673 204.106 126.673 205.103 127.171 205.602C127.67 206.101 128.169 206.101 129.166 205.602Z",
    fill: "url(#paint45_linear_58_4)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M107.223 249.987C107.722 249.987 108.221 249.489 108.719 249.489V248.99C108.719 247.993 108.221 247.494 107.223 247.494C106.226 247.494 105.727 247.993 105.727 248.99C106.226 248.99 106.724 249.987 107.223 249.987Z",
    fill: "url(#paint46_linear_58_4)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M182.03 195.628C182.529 195.628 183.526 195.628 183.526 195.129C184.025 194.631 183.526 193.633 182.529 193.134C182.03 192.636 181.032 193.134 180.534 194.132C181.032 194.631 181.531 195.129 182.03 195.628Z",
    fill: "url(#paint47_linear_58_4)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M166.071 192.636C166.57 192.636 167.068 192.137 167.567 192.137V191.638C167.567 190.641 167.068 190.142 166.071 190.142C165.074 190.142 164.575 190.641 164.575 191.638C165.074 191.638 165.572 192.137 166.071 192.636Z",
    fill: "url(#paint48_linear_58_4)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M158.092 192.636C158.591 192.636 159.089 192.137 159.089 192.137C159.089 191.638 159.089 191.638 159.089 191.139C159.089 190.142 158.092 189.643 157.593 189.643C156.596 189.643 156.097 190.641 156.596 191.139C156.596 192.137 157.593 192.636 158.092 192.636Z",
    fill: "url(#paint49_linear_58_4)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M108.221 241.509C108.719 241.509 109.218 241.509 109.717 241.011V240.512C109.717 239.515 109.218 239.016 108.719 239.016C107.722 239.016 107.223 239.515 107.223 240.013C106.725 240.512 107.223 241.509 108.221 241.509Z",
    fill: "url(#paint50_linear_58_4)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M174.549 193.134C175.048 193.134 175.546 193.134 176.045 192.636V192.137C176.045 191.14 175.546 190.641 175.048 190.641C174.05 190.641 173.552 191.14 173.552 191.638C173.053 192.636 173.552 193.134 174.549 193.134Z",
    fill: "url(#paint51_linear_58_4)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M121.686 287.89C122.184 287.89 122.184 287.391 121.686 287.89C122.184 286.892 122.184 286.393 121.686 285.895C121.187 285.396 120.189 285.396 119.691 285.895C119.192 286.393 119.192 287.391 119.691 287.89C120.189 288.388 121.187 288.388 121.686 287.89Z",
    fill: "url(#paint52_linear_58_4)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M110.714 264.45C110.714 263.951 109.717 263.453 109.218 263.453C108.221 263.453 108.221 264.45 108.221 264.949C108.221 265.946 109.218 265.946 110.216 265.946C110.714 265.946 110.714 265.448 111.213 265.448C110.714 265.448 110.714 264.949 110.714 264.45Z",
    fill: "url(#paint53_linear_58_4)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M128.169 293.376C128.668 292.378 128.668 291.879 128.169 291.381C127.67 290.882 126.673 290.882 126.174 291.381C125.675 291.879 125.675 292.877 126.174 293.376C126.673 294.373 127.67 293.874 128.169 293.376Z",
    fill: "url(#paint54_linear_58_4)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M109.218 257.468C109.218 257.468 109.218 256.969 109.218 256.471C109.218 255.473 108.22 254.975 107.722 254.975C106.724 254.975 106.226 255.972 106.226 256.471C106.226 257.468 107.223 257.967 107.722 257.967C108.22 257.967 108.719 257.967 109.218 257.468Z",
    fill: "url(#paint55_linear_58_4)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M123.182 211.587C123.182 211.587 123.182 211.088 123.182 211.587C123.681 210.589 123.681 210.091 123.182 209.592C122.683 209.093 121.686 209.093 121.187 209.592C120.688 210.091 120.688 211.088 121.187 211.587C121.686 212.085 122.683 212.085 123.182 211.587Z",
    fill: "url(#paint56_linear_58_4)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M116.699 281.406C116.699 281.406 117.197 280.908 116.699 281.406C117.197 280.409 117.197 279.91 117.197 279.411C116.699 278.913 115.701 278.414 115.203 278.913C114.704 279.411 114.205 280.409 114.704 280.908C115.203 281.406 116.2 281.905 116.699 281.406Z",
    fill: "url(#paint57_linear_58_4)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M110.714 273.427C111.213 273.926 111.711 274.424 112.709 274.424C113.207 274.424 113.207 273.926 113.207 273.926C113.207 273.427 113.706 272.928 113.207 272.43C112.709 271.931 112.21 271.432 111.213 271.432C110.714 271.931 110.215 272.43 110.714 273.427Z",
    fill: "url(#paint58_linear_58_4)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M109.717 233.53C110.216 233.53 111.213 233.53 111.213 233.031C111.213 233.031 111.213 233.031 111.213 232.533C111.213 232.034 111.213 231.037 110.216 230.538C109.218 230.538 108.719 230.538 108.221 231.535C108.719 232.533 109.218 233.031 109.717 233.53Z",
    fill: "url(#paint59_linear_58_4)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M112.709 225.55C113.208 226.049 114.205 225.55 114.704 225.052C115.202 224.553 114.704 223.556 114.205 223.057C113.706 222.558 112.709 223.057 112.21 223.556C111.711 224.553 111.711 225.052 112.709 225.55Z",
    fill: "url(#paint60_linear_58_4)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M116.699 218.07C117.197 218.569 118.195 218.07 118.693 217.571C119.192 217.073 118.693 216.075 118.195 215.576C117.696 215.078 116.699 215.576 116.2 216.075C115.701 217.073 115.701 218.07 116.699 218.07Z",
    fill: "url(#paint61_linear_58_4)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2953 345.74C79.794 345.74 80.7914 345.74 81.2901 344.743V344.244C81.2901 343.745 80.7914 343.247 80.2927 342.748C79.794 342.249 78.7966 342.748 78.2979 343.745C78.2979 344.743 78.7966 345.74 79.2953 345.74Z",
    fill: "url(#paint62_linear_58_4)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2872 338.26C82.7859 338.758 83.7834 338.26 84.2821 337.761V337.262C84.2821 336.763 83.7834 336.265 83.2847 335.766C82.7859 335.267 81.7885 335.766 81.2898 336.265C81.2898 336.763 81.7885 337.761 82.2872 338.26Z",
    fill: "url(#paint63_linear_58_4)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3002 353.72C78.2976 353.72 78.7963 353.221 78.7963 352.722C78.7963 352.722 78.7963 352.722 78.7963 352.223C78.7963 351.725 78.2976 350.727 77.7989 350.727C76.8014 350.727 76.3027 351.226 76.3027 351.725C76.3027 353.221 76.8014 353.72 77.3002 353.72Z",
    fill: "url(#paint64_linear_58_4)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8016 362.198C77.799 362.198 78.2977 361.699 78.2977 360.701C78.2977 359.704 77.799 359.205 76.8016 359.205C75.8041 359.205 75.3054 359.704 75.3054 360.701C75.3054 361.699 75.8041 362.198 76.8016 362.198Z",
    fill: "url(#paint65_linear_58_4)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M106.226 417.056C106.724 417.555 107.722 417.056 108.221 416.557V416.058C108.221 415.56 107.722 415.061 107.223 415.061C106.724 414.562 105.727 415.061 105.228 415.56C105.228 416.058 105.727 417.056 106.226 417.056Z",
    fill: "url(#paint66_linear_58_4)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M101.239 412.568C101.239 412.069 101.737 412.069 101.737 411.57C101.737 411.072 101.737 410.573 101.239 410.573C100.74 410.074 99.7426 410.074 99.2438 411.072C98.7451 411.57 98.7451 412.568 99.7426 413.066C99.7426 413.066 100.74 413.066 101.239 412.568Z",
    fill: "url(#paint67_linear_58_4)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7707 330.779C88.7707 330.28 89.2694 330.28 89.2694 329.781C89.2694 329.283 89.2694 328.784 88.7707 328.784C88.272 328.285 87.2745 328.285 86.7758 329.283C86.2771 329.781 86.2771 330.779 87.2745 331.277C87.2745 331.277 88.272 331.277 88.7707 330.779Z",
    fill: "url(#paint68_linear_58_4)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2977 369.18C78.2977 368.182 77.3003 367.684 76.8016 367.684C75.8041 367.684 75.3054 368.681 75.3054 369.18C75.3054 370.177 75.8041 370.676 76.8016 370.676C77.799 370.177 78.2977 369.678 78.2977 369.18Z",
    fill: "url(#paint69_linear_58_4)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7578 324.296C94.2565 323.797 94.2565 323.797 94.2565 323.298C94.2565 322.8 94.2565 322.799 93.7578 322.301C93.2591 321.802 92.2617 321.802 91.763 322.301C91.2642 322.799 91.2642 323.797 91.763 324.296C92.2617 325.293 93.2591 325.293 93.7578 324.296Z",
    fill: "url(#paint70_linear_58_4)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7423 319.308C100.241 318.81 100.241 318.81 100.241 318.311C100.241 317.812 100.241 317.812 99.7423 317.313C99.2436 316.815 98.2462 316.316 97.7475 316.815C97.2488 317.313 97.2488 318.311 97.2488 318.81C98.2462 319.308 99.2436 319.807 99.7423 319.308Z",
    fill: "url(#paint71_linear_58_4)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2747 400.599C87.7734 401.097 88.7708 401.596 89.2695 401.097C89.7682 400.599 89.7682 400.599 89.7682 400.1C89.7682 399.601 89.7682 399.601 89.2695 399.102C88.7708 398.604 87.7734 398.105 87.2747 398.604C86.776 399.102 86.776 400.1 87.2747 400.599Z",
    fill: "url(#paint72_linear_58_4)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2822 394.115C84.7809 393.617 84.7809 393.118 84.7809 392.619V392.121C84.2822 391.622 83.7835 391.123 82.7861 391.622C82.2874 392.121 81.7887 392.619 82.2874 393.617C82.7861 394.115 83.7835 394.614 84.2822 394.115Z",
    fill: "url(#paint73_linear_58_4)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2954 377.159C79.2954 376.162 78.298 375.663 77.7993 375.663C76.8019 375.663 76.3031 376.66 76.8018 377.159C76.8018 378.157 77.7993 378.655 78.298 378.157C78.7967 378.655 79.2954 377.658 79.2954 377.159Z",
    fill: "url(#paint74_linear_58_4)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7938 383.642C79.2951 384.141 78.7964 384.64 78.7964 385.637C79.2951 386.136 79.7938 386.635 80.7912 386.635C81.29 386.635 81.7887 386.136 81.7887 385.139V384.64C81.2899 384.141 80.7912 383.642 79.7938 383.642Z",
    fill: "url(#paint75_linear_58_4)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M106.724 314.82C107.223 314.321 107.223 314.321 107.223 313.823V313.324C106.724 312.825 106.226 312.327 105.228 312.825C104.729 312.825 104.729 313.324 104.729 314.321C105.228 314.82 106.226 315.319 106.724 314.82Z",
    fill: "url(#paint76_linear_58_4)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M122.683 422.542C123.681 422.542 124.179 422.043 124.179 421.544C124.179 421.046 123.681 420.048 123.182 420.048C122.185 420.048 121.686 420.547 121.686 421.046C121.187 421.544 121.686 422.542 122.683 422.542Z",
    fill: "url(#paint77_linear_58_4)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M114.205 420.547C114.704 421.046 115.701 420.547 116.2 419.55V419.051C116.2 418.552 115.701 418.054 115.202 417.555C114.704 417.056 113.706 417.555 113.208 418.552C113.208 419.55 113.706 420.547 114.205 420.547Z",
    fill: "url(#paint78_linear_58_4)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M114.205 311.828C114.704 311.828 115.202 311.329 115.202 310.332V309.833C114.704 308.835 114.205 308.835 113.208 308.835C112.709 309.334 112.21 309.833 112.21 310.83C112.709 311.329 113.706 311.828 114.205 311.828Z",
    fill: "url(#paint79_linear_58_4)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7556 407.082C95.2543 406.583 95.2543 406.583 95.2543 406.084C95.2543 405.586 95.2543 405.586 94.7556 405.087C94.2569 404.588 93.2595 404.588 92.7608 405.087C92.262 405.586 92.262 406.583 92.7608 407.082C93.2595 407.581 94.2569 407.581 94.7556 407.082Z",
    fill: "url(#paint80_linear_58_4)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M122.184 309.833C122.683 309.833 123.182 309.334 123.182 308.337C123.182 308.337 123.182 308.337 123.182 307.838C123.182 306.841 122.184 306.342 121.686 306.841C120.688 306.841 120.19 307.838 120.688 308.337C120.688 309.334 121.187 309.833 122.184 309.833Z",
    fill: "url(#paint81_linear_58_4)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M123.68 520.29C124.179 519.791 124.179 519.292 124.179 518.295C124.179 518.295 124.179 518.295 124.179 517.796C123.68 517.297 122.683 517.297 122.184 517.796C121.686 518.295 121.686 519.292 122.184 519.791C122.184 520.788 123.182 520.788 123.68 520.29Z",
    fill: "url(#paint82_linear_58_4)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M121.187 443.987C121.686 443.488 121.686 442.989 121.187 442.49C121.187 442.49 121.187 441.992 120.688 441.992C120.19 441.493 119.192 441.493 118.693 441.992C118.195 442.49 118.195 443.488 118.693 443.987C119.691 444.984 120.688 444.485 121.187 443.987Z",
    fill: "url(#paint83_linear_58_4)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M110.714 458.449C111.213 458.948 112.21 458.449 112.709 457.951C112.709 457.452 112.709 456.953 112.709 456.454C112.709 455.956 112.21 455.956 112.21 455.956C111.712 455.457 110.714 455.956 110.216 456.953C109.717 457.452 110.216 458.449 110.714 458.449Z",
    fill: "url(#paint84_linear_58_4)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M127.171 438.501C127.67 438.002 127.67 437.503 127.67 436.506C127.171 436.007 126.174 436.007 125.675 436.506C125.177 437.004 125.177 438.002 125.675 438.501C125.675 438.999 126.673 438.999 127.171 438.501Z",
    fill: "url(#paint85_linear_58_4)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M108.221 481.39V480.891C107.722 480.392 107.223 480.392 106.724 480.392C105.727 480.392 105.228 480.891 105.228 481.888C105.228 482.886 105.727 483.385 106.724 483.385C107.722 482.886 108.221 482.387 108.221 481.39Z",
    fill: "url(#paint86_linear_58_4)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M109.218 489.369C108.719 488.372 108.22 488.372 107.722 488.372C106.724 488.372 106.225 489.369 106.724 489.868C106.724 490.865 107.722 491.364 108.22 490.865C109.218 491.364 109.716 490.367 109.218 489.369Z",
    fill: "url(#paint87_linear_58_4)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M114.205 506.824C114.704 506.325 115.203 505.827 114.704 504.829C114.205 504.331 113.706 503.832 112.709 504.331C112.21 504.829 111.712 505.328 112.21 506.325C112.21 506.824 113.208 507.323 114.205 506.824Z",
    fill: "url(#paint88_linear_58_4)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M118.195 513.806C118.694 513.307 119.192 512.809 118.694 511.811C118.195 511.313 117.197 510.814 116.699 511.313C116.2 511.811 115.701 512.809 116.2 513.307C116.699 514.305 117.696 514.305 118.195 513.806Z",
    fill: "url(#paint89_linear_58_4)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M114.704 450.968C115.202 451.467 116.2 450.968 116.699 450.47C117.197 449.971 117.197 449.472 116.699 448.974L116.2 448.475C115.701 447.976 114.704 448.475 114.205 448.974C113.706 449.971 113.706 450.47 114.704 450.968Z",
    fill: "url(#paint90_linear_58_4)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M111.213 497.349C110.714 496.85 110.215 496.351 109.717 496.85C108.719 497.349 108.719 497.847 108.719 498.845C109.218 499.344 109.717 499.842 110.714 499.842C111.213 498.845 111.712 498.346 111.213 497.349Z",
    fill: "url(#paint91_linear_58_4)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M142.133 534.752C142.632 535.251 143.629 534.752 144.128 534.254C144.128 533.755 144.128 533.256 144.128 532.758L143.629 532.259C143.13 531.76 142.133 532.259 141.634 532.758C141.136 533.755 141.634 534.254 142.133 534.752Z",
    fill: "url(#paint92_linear_58_4)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M108.221 466.429C109.218 466.429 109.717 465.93 110.215 465.431C110.215 464.932 110.215 464.932 110.215 464.434C110.215 463.935 109.717 463.935 109.218 463.935C108.221 463.935 107.722 464.434 107.223 464.932C107.223 465.431 107.722 466.429 108.221 466.429Z",
    fill: "url(#paint93_linear_58_4)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M167.069 539.739C168.066 539.739 168.565 539.24 168.565 538.243V537.744C168.066 537.245 168.066 537.245 167.069 537.245C166.071 537.245 165.573 537.744 165.573 538.742C166.071 539.24 166.57 539.739 167.069 539.739Z",
    fill: "url(#paint94_linear_58_4)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M158.59 539.241C159.588 539.241 160.087 538.742 160.087 538.243C160.087 537.744 160.087 537.744 160.087 537.246C160.087 536.747 159.588 536.747 159.089 536.747C158.092 536.747 157.593 537.246 157.593 537.744C157.593 538.243 158.092 539.241 158.59 539.241Z",
    fill: "url(#paint95_linear_58_4)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M150.112 537.744C151.11 537.744 151.608 537.744 152.107 536.747C152.107 536.248 152.107 535.749 152.107 535.749C152.107 535.251 151.608 535.251 151.11 535.251C150.611 535.251 149.614 535.251 149.614 536.248C149.115 536.747 149.614 537.246 150.112 537.744Z",
    fill: "url(#paint96_linear_58_4)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M176.046 538.243C177.043 538.243 177.542 537.246 177.043 536.747V536.248C176.544 535.75 176.046 535.251 175.547 535.75C174.549 535.75 174.051 536.747 174.549 537.246C174.549 538.243 175.048 538.742 176.046 538.243Z",
    fill: "url(#paint97_linear_58_4)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M184.025 536.248C184.524 535.75 185.022 535.251 185.022 534.254C184.524 533.755 184.025 533.256 183.027 533.755C182.529 534.254 182.03 534.752 182.03 535.75C182.529 535.75 183.526 536.248 184.025 536.248Z",
    fill: "url(#paint98_linear_58_4)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M107.223 474.907C108.221 474.907 108.719 474.408 108.719 473.411C108.719 472.912 108.719 472.912 108.719 472.413C108.719 471.914 108.221 471.914 107.722 471.914C106.725 471.914 106.226 472.413 106.226 473.411C105.727 473.909 106.226 474.907 107.223 474.907Z",
    fill: "url(#paint99_linear_58_4)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M134.652 530.763C135.151 531.261 136.148 530.763 136.647 530.264C137.146 529.765 137.146 529.266 136.647 528.768L136.148 528.269C135.65 527.77 134.652 528.269 134.154 528.768C133.655 529.765 134.154 530.264 134.652 530.763Z",
    fill: "url(#paint100_linear_58_4)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M129.665 525.775C130.164 525.277 130.164 524.778 129.665 524.279C129.665 524.279 129.665 523.78 129.166 523.78C128.668 523.282 127.67 523.282 127.171 523.78C126.673 524.279 126.673 525.277 127.171 525.775C128.668 526.274 129.166 526.274 129.665 525.775Z",
    fill: "url(#paint101_linear_58_4)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M225.418 615.045C224.421 614.546 223.922 615.045 223.423 615.543C222.924 616.042 223.423 617.04 223.922 617.538C224.421 618.037 225.418 617.538 225.917 617.04C226.415 616.541 225.917 615.543 225.418 615.045Z",
    fill: "url(#paint102_linear_58_4)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M281.274 615.045C281.772 614.546 282.271 613.549 281.772 613.05L281.274 612.551C280.775 612.053 280.276 612.551 279.778 612.551C279.279 613.05 278.78 614.048 279.279 614.546C279.778 615.045 280.775 615.544 281.274 615.045Z",
    fill: "url(#paint103_linear_58_4)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M265.814 622.027C266.811 622.027 266.811 621.029 266.811 620.531C266.811 620.032 266.312 620.032 266.312 619.533C265.814 619.533 265.814 619.533 265.315 619.533C264.816 619.533 264.317 620.531 264.317 621.029C263.819 621.528 264.816 622.027 265.814 622.027Z",
    fill: "url(#paint104_linear_58_4)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M273.793 619.035C274.292 618.536 274.791 618.037 274.791 617.04C274.791 616.541 274.292 616.541 274.292 616.541C273.793 616.541 273.294 616.042 272.796 616.541C272.297 617.04 271.798 617.538 271.798 618.536C272.297 619.035 272.796 619.533 273.793 619.035Z",
    fill: "url(#paint105_linear_58_4)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M294.24 603.574C294.739 603.075 294.739 602.078 294.24 601.579C293.742 601.081 292.744 601.579 292.245 602.078C291.747 602.577 291.747 603.574 292.245 604.073C292.744 604.073 293.742 604.073 294.24 603.574Z",
    fill: "url(#paint106_linear_58_4)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M288.256 609.559C288.754 609.06 288.754 608.063 288.256 607.564C288.256 607.564 288.256 607.564 287.757 607.065C287.258 606.567 286.759 607.065 286.261 607.065C285.762 607.564 285.762 608.562 286.261 609.06C286.759 610.058 287.258 610.556 288.256 609.559Z",
    fill: "url(#paint107_linear_58_4)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M218.436 611.055C217.937 610.556 216.94 611.055 216.441 611.554C215.942 612.052 216.441 613.05 216.94 613.549C217.439 614.047 218.436 613.549 218.935 613.05C218.935 612.551 218.935 611.554 218.436 611.055Z",
    fill: "url(#paint108_linear_58_4)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M211.454 606.068C210.955 605.569 209.958 606.068 209.459 606.567C208.961 607.065 208.961 608.063 209.459 608.562C209.958 609.06 210.955 609.06 211.454 608.562C212.452 608.063 212.452 607.065 211.454 606.068C211.953 606.567 211.454 606.567 211.454 606.068Z",
    fill: "url(#paint109_linear_58_4)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M205.47 600.582C204.971 600.084 204.472 600.582 203.973 600.582C203.475 601.081 203.475 602.078 203.973 602.577C204.472 603.076 205.47 603.076 205.968 602.577C206.467 602.078 206.467 601.58 205.47 600.582C205.968 600.582 205.968 600.582 205.47 600.582Z",
    fill: "url(#paint110_linear_58_4)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M248.857 621.029C247.86 621.029 247.361 621.528 247.361 622.525C247.361 623.523 247.86 624.022 248.857 624.022C249.855 624.022 250.353 623.523 250.353 622.525C250.353 622.027 249.855 621.528 249.855 621.029C249.356 621.029 248.857 621.029 248.857 621.029Z",
    fill: "url(#paint111_linear_58_4)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M200.981 593.6C200.482 593.101 199.984 593.101 199.485 593.6C198.986 594.099 198.487 595.096 198.986 595.595C199.485 596.094 200.482 596.592 200.981 596.094C201.48 595.595 201.48 595.096 200.981 593.6C200.981 594.099 200.981 594.099 200.981 593.6Z",
    fill: "url(#paint112_linear_58_4)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M233.397 618.037C232.899 618.037 232.899 618.037 233.397 618.037C232.4 617.538 231.403 618.037 231.403 619.035C231.403 620.032 231.403 620.531 232.4 621.029C232.899 621.029 233.896 621.029 234.395 620.032C233.896 619.035 233.896 618.536 233.397 618.037Z",
    fill: "url(#paint113_linear_58_4)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M241.377 620.032C240.878 620.032 240.878 620.032 241.377 620.032C240.379 619.533 239.382 620.032 239.382 621.029C239.382 622.027 239.881 622.526 240.379 622.526C241.377 622.526 241.875 622.027 241.875 621.528C241.875 621.029 241.875 620.531 241.377 620.032Z",
    fill: "url(#paint114_linear_58_4)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M194.498 579.636C194.498 579.138 193.999 579.138 193.999 578.639C193.5 578.639 193.5 578.639 193.002 578.639C192.004 578.639 192.004 579.636 192.004 580.634C192.004 581.631 193.002 581.631 193.999 581.631C194.498 581.133 194.996 580.135 194.498 579.636Z",
    fill: "url(#paint115_linear_58_4)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M192.004 556.696C193.002 556.696 193.5 556.197 193.5 555.698C193.5 555.2 193.5 554.701 193.002 554.202H192.503C191.506 554.202 191.007 554.701 191.007 555.2C191.007 555.698 191.506 556.197 192.004 556.696Z",
    fill: "url(#paint116_linear_58_4)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M196.991 586.618C196.493 586.618 195.994 586.12 195.495 586.618C194.996 587.117 194.498 587.616 194.996 588.613C195.495 589.112 195.994 589.611 196.991 589.112C197.49 588.613 197.989 588.115 197.49 587.117C197.49 586.618 196.991 586.618 196.991 586.618Z",
    fill: "url(#paint117_linear_58_4)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M191.506 564.675C192.503 564.675 193.002 564.176 193.002 563.179C193.002 562.68 192.503 562.181 192.503 561.683H192.004C191.007 561.683 190.508 562.181 190.508 563.179C190.009 564.176 190.508 564.675 191.506 564.675Z",
    fill: "url(#paint118_linear_58_4)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M193.999 548.217C194.498 548.716 195.495 548.217 195.994 547.22C195.994 546.721 195.994 545.724 195.495 545.724C194.997 545.225 193.999 545.724 193.501 546.721C193.002 547.22 193.501 548.217 193.999 548.217Z",
    fill: "url(#paint119_linear_58_4)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M193.002 571.657C193.002 571.158 192.503 570.66 192.503 570.66C192.004 570.66 192.004 570.66 191.505 570.66C190.508 570.66 190.009 571.657 190.009 572.156C190.009 573.153 191.007 573.652 191.505 573.153C192.503 573.153 193.002 572.156 193.002 571.657Z",
    fill: "url(#paint120_linear_58_4)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M257.335 623.523C258.333 623.523 258.831 622.525 258.831 622.027C258.831 621.528 258.333 621.029 258.333 621.029C258.333 621.029 257.834 621.029 257.335 621.029C256.338 621.029 255.839 622.027 255.839 622.525C255.839 623.024 256.338 623.523 257.335 623.523Z",
    fill: "url(#paint121_linear_58_4)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M369.546 651.451C368.548 651.451 368.05 652.448 368.05 652.947C368.05 653.944 369.047 654.443 369.546 654.443C370.543 654.443 371.042 653.944 371.042 652.947C370.543 651.95 370.044 651.451 369.546 651.451Z",
    fill: "url(#paint122_linear_58_4)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M415.926 624.022C416.425 624.52 417.422 624.022 417.921 623.523C418.419 623.024 417.921 622.027 417.422 621.528H416.923C416.425 621.528 415.926 622.027 415.926 622.526C414.928 622.526 414.928 623.523 415.926 624.022Z",
    fill: "url(#paint123_linear_58_4)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M310.199 607.564C310.199 607.065 309.7 606.567 308.703 606.567C308.703 606.567 308.703 606.567 308.204 606.567C307.207 606.567 306.708 607.564 307.207 608.063C307.207 609.06 308.204 609.559 308.703 609.06C309.7 609.06 310.199 608.561 310.199 607.564Z",
    fill: "url(#paint124_linear_58_4)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M419.417 616.541C420.414 617.04 420.913 616.541 421.412 615.543C421.911 615.045 421.412 614.047 420.414 613.549H419.916C419.417 613.549 418.918 614.047 418.42 614.546C417.921 615.045 418.42 616.042 419.417 616.541Z",
    fill: "url(#paint125_linear_58_4)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M412.934 630.505C413.432 630.006 413.432 629.009 412.435 628.51C411.936 628.51 411.936 628.011 411.438 628.011C410.939 628.011 410.44 628.011 410.44 628.51C409.941 629.009 409.941 630.006 410.939 630.505C411.936 631.502 412.435 631.502 412.934 630.505Z",
    fill: "url(#paint126_linear_58_4)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M421.412 608.063C422.409 608.063 422.908 607.564 422.908 607.065C422.908 606.068 422.409 605.569 421.91 605.569C421.412 605.569 420.414 606.068 420.414 606.567C419.915 607.564 420.414 608.063 421.412 608.063Z",
    fill: "url(#paint127_linear_58_4)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M406.45 634.495C405.952 634.495 405.952 634.495 405.453 634.993C404.954 635.492 404.954 636.49 405.453 636.988C405.952 637.487 406.949 637.487 407.448 636.988C407.946 636.49 407.946 635.492 407.448 634.993C407.448 634.993 406.949 634.495 406.45 634.495Z",
    fill: "url(#paint128_linear_58_4)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M392.985 644.469H392.487C391.988 644.968 391.489 645.466 391.988 646.464C392.487 646.963 392.985 647.461 393.983 646.963C394.481 646.464 394.98 645.965 394.481 644.968C393.983 644.968 393.484 644.469 392.985 644.469Z",
    fill: "url(#paint129_linear_58_4)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M385.505 647.96C385.505 647.96 385.006 647.96 385.505 647.96C384.507 648.458 384.009 648.957 384.009 649.955C384.507 650.453 385.006 650.952 386.003 650.952C386.502 650.453 387.001 649.955 387.001 648.957C386.502 648.458 386.003 647.96 385.505 647.96Z",
    fill: "url(#paint130_linear_58_4)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M399.967 639.98C399.469 639.98 399.469 639.98 398.97 640.479C398.471 640.978 397.973 641.975 398.471 642.474C398.97 642.973 399.967 643.472 400.466 642.973C400.965 642.474 401.463 641.477 400.965 640.978C400.965 640.479 400.466 639.98 399.967 639.98Z",
    fill: "url(#paint131_linear_58_4)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M338.127 645.466H337.628C337.13 645.466 336.631 645.965 336.132 646.464C335.633 646.962 336.132 647.96 336.631 648.459C337.13 648.957 338.127 648.459 338.626 647.96C339.124 646.464 338.626 645.965 338.127 645.466Z",
    fill: "url(#paint132_linear_58_4)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M345.608 648.458C345.109 648.458 345.109 648.458 345.608 648.458C344.61 648.458 344.112 648.957 343.613 649.456C343.114 649.955 343.613 650.952 344.61 651.451C345.109 651.451 346.106 651.451 346.605 650.453C346.605 649.456 346.106 648.957 345.608 648.458Z",
    fill: "url(#paint133_linear_58_4)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M353.088 650.453C352.091 650.453 351.592 650.952 351.592 651.451C351.592 652.448 352.091 652.947 352.589 652.947C353.587 652.947 354.086 652.448 354.086 651.95C354.584 651.451 354.086 650.952 353.088 650.453Z",
    fill: "url(#paint134_linear_58_4)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M361.068 651.451C360.07 651.451 359.572 651.95 359.572 652.947C359.572 653.944 360.07 654.443 361.068 654.443C362.065 654.443 362.564 653.944 362.564 652.947C362.564 652.448 362.065 651.451 361.068 651.451Z",
    fill: "url(#paint135_linear_58_4)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M377.525 650.453C376.528 650.453 376.029 651.451 376.029 651.95C376.029 652.947 377.027 653.446 377.525 652.947C378.523 652.947 379.022 651.95 378.523 651.451C379.022 650.453 378.024 650.453 377.525 650.453Z",
    fill: "url(#paint136_linear_58_4)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M330.148 640.978C329.649 640.978 329.15 640.978 329.15 641.476C328.651 641.975 328.651 642.973 329.649 643.471C330.148 643.97 331.145 643.97 331.644 642.973C332.142 642.474 332.142 641.476 331.145 640.978C330.646 640.978 330.646 640.978 330.148 640.978Z",
    fill: "url(#paint137_linear_58_4)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M314.189 622.027H313.69C313.191 622.525 312.693 623.024 313.191 624.022C313.69 624.52 314.189 625.019 315.186 624.52C315.685 624.022 316.184 623.523 315.685 622.525C315.186 622.525 314.688 622.027 314.189 622.027Z",
    fill: "url(#paint138_linear_58_4)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M318.179 629.009C317.68 629.009 317.68 629.009 317.181 629.508C316.682 630.006 316.184 631.004 316.682 631.502C317.181 632.001 318.179 632.001 318.677 632.001C319.176 631.502 319.176 630.505 319.176 630.006C319.176 629.508 318.677 629.009 318.179 629.009Z",
    fill: "url(#paint139_linear_58_4)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M310.698 614.546C310.698 614.546 310.199 614.546 310.698 614.546C309.7 615.045 309.202 615.543 309.202 616.541C309.7 617.039 310.199 617.538 311.197 617.538C311.695 617.039 312.194 616.541 312.194 615.543C311.695 615.045 311.197 614.546 310.698 614.546Z",
    fill: "url(#paint140_linear_58_4)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M323.664 635.492C323.165 635.492 323.165 635.492 322.667 635.991C322.168 636.489 322.168 637.487 322.667 637.986C323.165 638.484 324.163 638.484 324.662 637.986C325.16 637.487 325.16 636.489 324.662 635.991C324.662 635.492 324.163 635.492 323.664 635.492Z",
    fill: "url(#paint141_linear_58_4)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M450.836 613.05C450.337 612.551 449.838 612.551 449.34 613.05L448.841 613.549C448.342 614.047 448.841 615.045 449.34 615.544C449.838 616.042 450.836 615.544 451.335 615.045C451.833 614.546 451.833 613.549 450.836 613.05Z",
    fill: "url(#paint142_linear_58_4)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M489.735 620.531C488.738 621.029 488.738 621.528 488.738 622.027C488.738 623.024 489.735 623.523 490.234 623.024C491.231 623.024 491.73 622.027 491.231 621.528C491.73 620.531 490.733 620.032 489.735 620.531Z",
    fill: "url(#paint143_linear_58_4)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M473.777 621.029C473.278 621.029 473.278 621.029 472.779 621.029C472.281 621.029 472.281 621.528 472.281 622.027C472.281 623.024 472.779 623.523 473.777 623.523C474.774 623.523 475.273 623.024 475.273 622.027C475.273 622.027 474.774 621.029 473.777 621.029Z",
    fill: "url(#paint144_linear_58_4)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M481.756 621.528H481.258C480.759 622.027 480.759 622.526 480.759 623.024C480.759 624.022 481.257 624.52 482.255 624.52C483.252 624.52 483.751 624.022 483.751 623.024C483.252 622.027 482.754 621.528 481.756 621.528Z",
    fill: "url(#paint145_linear_58_4)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M505.196 615.045C504.697 615.543 504.198 616.042 504.697 617.04C505.196 617.538 505.694 618.037 506.692 617.538C507.19 617.04 507.689 616.541 507.19 615.543C506.692 615.045 505.694 614.546 505.196 615.045Z",
    fill: "url(#paint146_linear_58_4)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M497.714 618.037C497.714 618.536 497.714 618.536 497.714 618.037C496.717 618.536 496.717 619.035 496.717 620.032C497.216 621.029 497.714 621.029 498.712 621.029C499.211 620.531 499.709 620.032 499.709 619.035C499.211 618.536 498.712 618.037 497.714 618.037Z",
    fill: "url(#paint147_linear_58_4)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M442.857 608.063C442.857 608.063 442.358 608.561 442.857 608.063C441.859 609.06 441.859 610.058 442.857 610.556C443.355 611.055 444.353 611.055 444.851 610.556C445.35 610.058 445.35 609.06 444.851 608.561C443.854 608.063 443.355 608.063 442.857 608.063Z",
    fill: "url(#paint148_linear_58_4)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M465.797 619.533C465.298 619.533 465.298 619.533 464.8 619.533C464.301 619.533 464.301 620.032 464.301 620.531C464.301 621.528 464.8 622.027 465.298 622.027C466.296 622.027 466.795 621.528 466.795 621.029C467.293 620.531 466.795 620.032 465.797 619.533Z",
    fill: "url(#paint149_linear_58_4)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M512.178 611.055C511.679 611.554 511.18 612.551 511.679 613.05C512.178 613.549 513.175 614.047 513.674 613.549C514.173 613.05 514.671 612.053 514.173 611.554C513.674 610.556 512.676 610.556 512.178 611.055Z",
    fill: "url(#paint150_linear_58_4)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M458.316 617.04C457.818 617.04 457.319 617.04 456.82 617.04C456.322 617.04 456.322 617.538 456.322 617.538C455.823 618.037 456.322 619.035 457.319 619.533C457.818 620.032 458.815 619.533 459.314 618.536C459.314 618.037 458.815 617.538 458.316 617.04Z",
    fill: "url(#paint151_linear_58_4)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M526.142 601.58C526.64 601.081 526.64 600.083 526.142 599.585C525.643 599.086 525.144 599.086 524.645 599.585C524.645 599.585 524.147 599.585 524.147 600.083C523.648 600.582 523.648 601.58 524.147 602.078C524.645 602.577 525.643 602.577 526.142 601.58Z",
    fill: "url(#paint152_linear_58_4)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M536.115 554.202C536.115 555.199 537.113 555.698 537.612 555.199C538.609 555.199 539.108 554.202 538.609 553.703C538.609 552.706 537.612 552.207 537.113 552.706H536.614C536.115 553.205 536.115 553.703 536.115 554.202Z",
    fill: "url(#paint153_linear_58_4)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M538.609 569.163C538.111 569.163 538.111 569.163 537.612 569.163C537.113 569.163 537.113 569.662 537.113 570.161C537.113 571.158 537.612 571.657 538.111 571.657C539.108 571.657 539.607 571.158 539.607 570.659C539.607 570.161 539.108 569.662 538.609 569.163Z",
    fill: "url(#paint154_linear_58_4)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M537.612 561.184C537.113 561.683 537.113 561.683 537.113 562.68C537.113 563.678 537.612 564.176 538.609 564.176C539.607 564.176 540.106 563.678 540.106 562.68C540.106 561.683 539.607 561.184 538.609 561.184C538.111 561.184 538.111 561.184 537.612 561.184Z",
    fill: "url(#paint155_linear_58_4)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M436.872 602.078C435.875 602.577 435.875 603.574 436.373 604.073C436.872 604.572 437.869 604.572 438.368 604.073C438.867 603.574 438.867 602.577 438.368 602.078C438.368 602.078 437.371 602.078 436.872 602.078Z",
    fill: "url(#paint156_linear_58_4)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M537.113 577.641C536.614 577.641 536.116 577.641 536.116 577.641C535.617 577.641 535.617 578.14 535.617 578.639C535.617 579.137 535.617 580.135 536.614 580.135C537.612 580.135 538.11 580.135 538.11 579.137C538.11 578.639 537.612 577.641 537.113 577.641Z",
    fill: "url(#paint157_linear_58_4)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M518.661 605.569C517.663 606.068 517.663 607.065 518.162 607.564C518.661 608.063 519.658 608.063 520.157 607.564C520.656 607.065 520.656 606.068 520.157 605.569C520.157 605.569 519.159 605.569 518.661 605.569Z",
    fill: "url(#paint158_linear_58_4)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M529.133 595.595C529.632 596.094 530.63 595.595 531.128 595.096C531.627 594.598 531.128 593.6 530.63 593.102C530.131 592.603 529.632 592.603 529.133 593.102L528.635 593.6C528.136 594.099 528.635 595.096 529.133 595.595Z",
    fill: "url(#paint159_linear_58_4)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M533.124 588.115C533.622 588.613 534.62 588.115 535.119 587.616C535.617 587.117 535.119 586.12 534.62 585.621C534.121 585.621 533.622 585.621 533.124 585.621L532.625 586.12C532.126 587.117 532.625 587.616 533.124 588.115Z",
    fill: "url(#paint160_linear_58_4)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M535.617 547.22C536.116 546.721 536.614 546.223 536.614 545.225C536.116 544.726 535.617 544.228 534.62 544.228C534.121 544.726 533.622 545.225 534.121 546.223C534.121 547.22 535.118 547.719 535.617 547.22Z",
    fill: "url(#paint161_linear_58_4)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M613.416 510.814C612.918 510.315 611.92 510.814 611.421 511.313C610.923 511.811 611.421 512.809 611.92 513.307C612.419 513.806 613.416 513.307 613.915 512.809C614.414 512.31 614.414 511.313 613.416 510.814Z",
    fill: "url(#paint162_linear_58_4)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M600.948 523.78C600.449 524.778 600.449 525.277 600.948 525.775C601.447 526.274 602.444 526.274 602.943 525.775C603.442 525.277 603.442 524.279 602.943 523.78C602.444 523.282 601.945 523.282 600.948 523.78Z",
    fill: "url(#paint163_linear_58_4)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M587.483 532.259C586.984 532.259 586.984 532.758 586.984 532.758C586.984 533.256 586.486 533.755 586.984 534.254C587.483 534.752 587.982 535.251 588.979 534.752C589.478 534.254 589.977 533.755 589.478 532.758C588.979 532.259 587.982 531.76 587.483 532.259Z",
    fill: "url(#paint164_linear_58_4)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M594.465 528.269C594.465 528.768 594.465 528.768 594.465 528.269C593.966 529.266 593.966 529.765 593.966 530.264C594.465 530.762 595.462 531.261 595.961 530.762C596.46 530.264 596.959 529.266 596.46 528.768C595.961 528.269 595.462 528.269 594.465 528.269Z",
    fill: "url(#paint165_linear_58_4)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M606.933 517.796C606.933 517.796 606.933 518.295 606.933 517.796C606.434 518.794 606.434 519.292 606.933 519.791C607.432 520.29 608.429 520.29 608.928 519.791C609.426 519.292 609.426 518.295 608.928 517.796C608.429 517.297 607.432 517.297 606.933 517.796Z",
    fill: "url(#paint166_linear_58_4)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M572.023 536.747C571.524 536.747 571.026 537.246 571.026 537.246C571.026 537.744 571.026 537.744 571.026 538.243C571.026 539.24 572.023 539.739 572.522 539.739C573.519 539.739 574.018 538.742 573.519 538.243C573.519 537.246 572.522 536.747 572.023 536.747Z",
    fill: "url(#paint167_linear_58_4)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M580.002 535.251C579.504 535.251 579.504 535.75 579.005 535.75C579.005 536.248 579.005 536.248 579.005 536.747C579.005 537.745 580.002 537.745 581 537.745C581.997 537.745 581.997 536.747 581.997 535.75C581.498 535.251 580.501 534.752 580.002 535.251Z",
    fill: "url(#paint168_linear_58_4)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M563.545 536.747C563.046 536.747 562.547 537.246 562.049 537.246V537.744C562.049 538.742 562.547 539.241 563.545 539.241C564.542 539.241 565.041 538.742 565.041 537.744C565.041 537.744 564.542 536.747 563.545 536.747Z",
    fill: "url(#paint169_linear_58_4)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M555.565 536.248C555.067 536.248 554.568 536.248 554.069 536.747V537.246C554.069 538.243 554.568 538.742 555.067 538.742C556.064 538.742 556.563 538.243 556.563 537.744C557.061 536.747 556.563 536.248 555.565 536.248Z",
    fill: "url(#paint170_linear_58_4)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M620.897 471.914C620.897 471.914 620.897 472.413 620.897 472.912C620.897 473.909 621.894 474.408 622.393 474.408C623.39 474.408 623.889 473.41 623.889 472.912C623.889 471.914 622.892 471.416 622.393 471.416C621.894 471.416 621.395 471.416 620.897 471.914Z",
    fill: "url(#paint171_linear_58_4)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M621.894 487.873C621.395 487.873 620.897 487.873 620.398 488.372V488.871C620.398 489.868 620.897 490.367 621.395 490.367C622.393 490.367 622.892 489.868 622.892 489.369C623.39 488.871 622.892 487.873 621.894 487.873Z",
    fill: "url(#paint172_linear_58_4)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M617.406 503.832C616.907 503.333 615.909 503.832 615.411 504.331C614.912 504.829 615.411 505.827 615.909 506.326C616.408 506.824 617.406 506.326 617.904 505.827C618.403 504.829 618.403 503.832 617.406 503.832Z",
    fill: "url(#paint173_linear_58_4)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M620.398 495.853C619.899 495.853 618.902 495.853 618.902 496.351C618.902 496.351 618.902 496.351 618.902 496.85C618.902 497.349 618.902 498.346 619.899 498.845C620.896 498.845 621.395 498.845 621.894 497.848C621.395 496.85 620.896 496.351 620.398 495.853Z",
    fill: "url(#paint174_linear_58_4)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M601.946 436.007C601.447 437.005 601.447 437.503 601.946 438.002C602.444 438.501 603.442 438.501 603.941 438.002C604.439 437.503 604.439 436.506 603.941 436.007C603.442 435.01 602.444 435.508 601.946 436.007Z",
    fill: "url(#paint175_linear_58_4)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M619.4 464.932C619.4 465.431 620.398 465.93 620.897 465.93C621.894 465.93 621.894 464.932 621.894 464.434C621.894 463.436 620.897 463.436 620.398 463.436C619.899 463.436 619.899 463.935 619.4 463.935C619.4 463.935 619.4 464.434 619.4 464.932Z",
    fill: "url(#paint176_linear_58_4)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M622.891 479.395C622.393 479.395 621.894 479.894 621.395 479.894V480.393C621.395 481.39 621.894 481.889 622.891 481.889C623.889 481.889 624.388 481.39 624.388 480.393C623.889 480.393 623.39 479.395 622.891 479.395Z",
    fill: "url(#paint177_linear_58_4)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M607.93 441.493C607.431 442.49 607.431 442.989 607.93 443.488C608.429 443.987 609.426 443.987 609.925 443.488C610.424 442.989 610.424 441.992 609.925 441.493C609.426 440.994 608.928 440.994 607.93 441.493Z",
    fill: "url(#paint178_linear_58_4)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M619.401 455.956C618.902 455.457 618.404 454.958 617.406 454.958C616.907 454.958 616.907 455.457 616.907 455.457C616.907 455.956 616.409 456.454 616.907 456.953C617.406 457.452 617.905 457.95 618.902 457.95C619.401 457.452 619.9 456.953 619.401 455.956Z",
    fill: "url(#paint179_linear_58_4)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M613.416 447.976C613.416 447.976 612.917 448.475 613.416 447.976C612.917 448.974 612.917 449.472 612.917 449.971C613.416 450.47 614.414 450.968 614.912 450.47C615.411 449.971 615.91 448.974 615.411 448.475C614.912 447.976 613.915 447.478 613.416 447.976Z",
    fill: "url(#paint180_linear_58_4)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M547.586 533.755C547.087 533.755 546.09 533.755 546.09 534.253C545.591 534.752 546.09 535.749 547.087 536.248C547.586 536.747 548.583 536.248 549.082 535.251C549.082 534.752 548.583 534.253 547.586 533.755Z",
    fill: "url(#paint181_linear_58_4)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M623.391 414.562C622.892 415.061 622.892 415.061 622.892 415.56V416.058C623.391 416.557 623.889 417.056 624.887 416.557C625.385 416.058 625.884 415.56 625.385 414.562C624.887 414.562 623.889 414.064 623.391 414.562Z",
    fill: "url(#paint182_linear_58_4)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M651.817 360.203C651.817 361.2 652.814 361.699 653.313 361.699C654.31 361.699 654.809 360.702 654.809 360.203C654.809 359.205 654.31 358.707 653.313 358.707C652.316 358.707 651.817 359.704 651.817 360.203Z",
    fill: "url(#paint183_linear_58_4)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M630.372 410.074C629.873 410.573 629.873 410.573 629.873 411.072C629.873 411.57 629.873 411.57 630.372 412.069C630.871 412.568 631.868 413.066 632.367 412.568C632.866 412.069 632.866 411.072 632.866 410.573C631.868 409.575 630.871 409.575 630.372 410.074Z",
    fill: "url(#paint184_linear_58_4)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M636.357 404.588C635.858 405.087 635.858 405.087 635.858 405.586C635.858 406.084 635.858 406.084 636.357 406.583C636.856 407.082 637.853 407.082 638.352 406.583C638.85 406.084 638.85 405.087 638.352 404.588C637.853 404.089 636.856 404.089 636.357 404.588Z",
    fill: "url(#paint185_linear_58_4)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M645.333 335.267C644.835 335.766 644.835 336.265 644.835 336.763V337.262C645.333 337.761 645.832 338.26 646.83 337.761C647.328 337.262 647.827 336.763 647.328 335.766C647.328 335.267 646.331 334.769 645.333 335.267Z",
    fill: "url(#paint186_linear_58_4)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M642.84 328.784C642.341 328.285 641.344 327.787 640.845 328.285C640.346 328.784 640.346 328.784 640.346 329.283C640.346 329.781 640.346 329.781 640.845 330.28C641.344 330.779 642.341 331.278 642.84 330.779C643.339 330.28 643.339 329.283 642.84 328.784Z",
    fill: "url(#paint187_linear_58_4)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M650.819 352.223C650.819 353.221 651.817 353.72 652.315 353.72C653.313 353.72 653.812 352.722 653.313 352.223C653.313 351.226 652.315 350.727 651.817 351.226C650.819 350.727 650.819 351.226 650.819 352.223Z",
    fill: "url(#paint188_linear_58_4)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M615.909 308.836C615.411 308.337 614.413 308.836 613.915 309.833V310.332C613.915 310.83 614.413 311.329 614.912 311.828C615.411 312.327 616.408 311.828 616.907 310.83C616.907 309.833 616.408 308.836 615.909 308.836Z",
    fill: "url(#paint189_linear_58_4)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M650.321 345.242C650.82 344.743 651.318 344.244 651.318 343.247C650.82 342.748 650.321 342.249 649.324 342.249C648.825 342.249 648.326 342.748 648.326 343.745V344.244C648.825 345.242 649.324 345.74 650.321 345.242Z",
    fill: "url(#paint190_linear_58_4)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M607.431 306.841C606.434 306.841 605.935 307.34 605.935 307.838C605.935 308.337 606.434 309.334 606.933 309.334C607.93 309.334 608.429 308.836 608.429 308.337C608.927 307.34 608.429 306.841 607.431 306.841Z",
    fill: "url(#paint191_linear_58_4)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M623.889 311.828C623.39 311.329 622.393 311.828 621.894 312.327V312.825C621.894 313.324 622.393 313.823 622.891 313.823C623.39 314.322 624.388 313.823 624.886 313.324C624.886 313.324 624.388 312.327 623.889 311.828Z",
    fill: "url(#paint192_linear_58_4)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M628.876 316.815C628.876 317.314 628.377 317.314 628.377 317.812C628.377 318.311 628.377 318.81 628.876 318.81C629.375 319.308 630.372 319.308 630.871 318.311C631.37 317.812 631.37 316.815 630.372 316.316C630.372 316.316 629.375 316.316 628.876 316.815Z",
    fill: "url(#paint193_linear_58_4)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M607.931 419.55C607.432 419.55 606.933 420.048 606.933 421.046C606.933 421.046 606.933 421.046 606.933 421.544C606.933 422.542 607.931 423.041 608.429 422.542C609.427 422.542 609.925 421.544 609.427 421.046C609.427 420.048 608.928 419.55 607.931 419.55Z",
    fill: "url(#paint194_linear_58_4)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M635.359 322.301C634.86 322.8 634.86 322.8 634.86 323.298C634.86 323.797 634.86 323.797 635.359 324.296C635.858 324.794 636.855 324.794 637.354 324.296C637.853 323.797 637.853 322.8 637.354 322.301C636.855 321.802 635.858 321.802 635.359 322.301Z",
    fill: "url(#paint195_linear_58_4)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M615.91 417.555C615.411 417.555 614.912 418.054 614.912 419.051V419.55C615.411 420.048 615.91 420.547 616.907 420.547C617.406 420.048 617.904 419.55 617.904 418.552C617.406 418.054 616.408 417.555 615.91 417.555Z",
    fill: "url(#paint196_linear_58_4)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M653.313 367.185C652.316 367.185 651.817 367.684 651.817 368.681C651.817 369.678 652.316 370.177 653.313 370.177C654.31 370.177 654.809 369.678 654.809 368.681C654.809 367.684 654.31 367.185 653.313 367.185Z",
    fill: "url(#paint197_linear_58_4)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M647.827 391.123C647.329 390.624 646.331 391.123 645.833 391.622V392.12C645.833 392.619 646.331 393.118 646.83 393.617C647.329 394.115 648.326 393.617 648.825 393.118C648.825 392.121 648.326 391.622 647.827 391.123Z",
    fill: "url(#paint198_linear_58_4)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M641.344 398.604C641.344 399.102 640.845 399.102 640.845 399.601C640.845 400.1 640.845 400.598 641.344 400.598C641.843 401.097 642.84 401.097 643.339 400.1C643.838 399.601 643.838 398.604 642.84 398.105C642.84 397.606 641.843 398.105 641.344 398.604Z",
    fill: "url(#paint199_linear_58_4)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M652.814 375.164C651.817 375.164 651.318 375.663 651.318 376.162C651.318 376.162 651.318 376.162 651.318 376.66C651.318 377.159 651.817 378.156 652.316 378.156C653.313 378.156 653.812 377.658 653.812 377.159C653.812 376.162 653.313 375.663 652.814 375.164Z",
    fill: "url(#paint200_linear_58_4)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M650.819 383.642C650.321 383.642 649.323 383.642 648.824 384.64V385.139C648.824 385.637 649.323 386.136 649.822 386.635C650.321 387.133 651.318 386.635 651.817 385.637C651.817 384.64 651.318 383.642 650.819 383.642Z",
    fill: "url(#paint201_linear_58_4)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M619.401 270.933C618.902 270.435 617.904 270.933 617.406 271.432C617.406 271.931 617.406 272.43 617.406 272.928C617.406 273.427 617.904 273.427 617.904 273.427C618.403 273.926 619.401 273.427 619.899 272.43C620.398 271.931 619.899 270.933 619.401 270.933Z",
    fill: "url(#paint202_linear_58_4)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M615.411 278.414C614.912 277.915 613.915 278.414 613.416 278.913C612.917 279.411 612.917 279.91 613.416 280.409L613.914 280.908C614.413 281.406 615.411 280.908 615.909 280.409C616.408 279.411 616.408 278.414 615.411 278.414Z",
    fill: "url(#paint203_linear_58_4)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M602.943 290.882C602.444 291.381 602.444 291.879 602.444 292.877C602.943 293.375 603.94 293.375 604.439 292.877C604.938 292.378 604.938 291.381 604.439 290.882C604.439 290.383 603.442 290.383 602.943 290.882Z",
    fill: "url(#paint204_linear_58_4)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M608.928 285.396C608.429 285.895 608.429 286.393 608.928 286.892C608.928 286.892 608.928 287.391 609.426 287.391C609.925 287.89 610.922 287.89 611.421 287.391C611.92 286.892 611.92 285.895 611.421 285.396C609.925 284.399 609.426 284.897 608.928 285.396Z",
    fill: "url(#paint205_linear_58_4)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M599.951 203.607C599.452 204.106 599.452 204.605 599.951 205.103C599.951 205.103 599.951 205.602 600.449 205.602C600.948 206.101 601.946 206.101 602.444 205.602C602.943 205.103 602.943 204.106 602.444 203.607C601.447 203.108 600.449 203.108 599.951 203.607Z",
    fill: "url(#paint206_linear_58_4)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M606.434 209.093C605.935 209.592 605.935 210.091 605.935 211.088C605.935 211.088 605.935 211.088 605.935 211.587C606.434 212.085 607.431 212.085 607.93 211.587C608.429 211.088 608.429 210.091 607.93 209.592C607.93 208.594 606.933 208.594 606.434 209.093Z",
    fill: "url(#paint207_linear_58_4)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M621.894 247.993V248.491C622.393 248.99 622.891 248.99 623.39 248.99C624.388 248.99 624.886 248.491 624.886 247.494C624.886 246.496 624.388 245.998 623.39 245.998C622.393 246.496 621.894 246.995 621.894 247.993Z",
    fill: "url(#paint208_linear_58_4)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M618.902 232.034C619.401 232.532 619.9 233.031 620.398 232.532C621.396 232.034 621.396 231.535 621.396 230.538C620.897 230.039 620.398 229.54 619.401 229.54C618.902 230.538 618.403 231.036 618.902 232.034Z",
    fill: "url(#paint209_linear_58_4)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M615.909 222.559C615.411 223.057 614.912 223.556 615.411 224.553C615.909 225.052 616.408 225.551 617.406 225.052C617.904 224.553 618.403 224.055 617.904 223.057C617.406 222.558 616.907 222.06 615.909 222.559Z",
    fill: "url(#paint210_linear_58_4)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M620.896 239.515C620.896 240.013 620.896 240.013 620.896 239.515C621.395 240.512 621.894 240.512 622.392 240.512C623.39 240.512 623.889 239.515 623.39 239.016C623.39 238.019 622.392 237.52 621.894 238.019C620.896 238.019 620.398 239.016 620.896 239.515Z",
    fill: "url(#paint211_linear_58_4)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M622.891 254.476C621.894 254.476 621.395 254.975 621.395 255.972C621.395 256.471 621.395 256.471 621.395 256.969C621.395 257.468 621.894 257.468 622.393 257.468C623.39 257.468 623.889 256.969 623.889 255.972C624.388 255.473 623.889 254.476 622.891 254.476Z",
    fill: "url(#paint212_linear_58_4)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M595.462 198.62C594.964 198.121 593.966 198.62 593.468 199.119C592.969 199.618 592.969 200.116 593.468 200.615L593.966 201.114C594.465 201.612 595.462 201.114 595.961 200.615C595.961 199.618 595.961 199.119 595.462 198.62Z",
    fill: "url(#paint213_linear_58_4)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M621.894 262.954C620.897 262.954 620.398 263.453 620.398 263.952C620.398 264.45 620.398 264.45 620.398 264.949C620.398 265.448 620.897 265.448 621.395 265.448C622.393 265.448 622.892 264.949 622.892 264.45C622.892 263.952 622.393 262.954 621.894 262.954Z",
    fill: "url(#paint214_linear_58_4)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M611.421 215.576C610.922 216.075 610.424 216.574 610.922 217.571C611.421 218.07 612.419 218.569 612.917 218.07C613.416 217.571 613.915 216.574 613.416 216.075C613.416 215.078 612.419 215.078 611.421 215.576Z",
    fill: "url(#paint215_linear_58_4)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M587.982 194.63C587.483 194.132 586.486 194.63 585.987 195.129C585.987 195.628 585.987 196.127 585.987 196.625L586.486 197.124C586.984 197.623 587.982 197.124 588.481 196.625C588.979 195.628 588.481 194.63 587.982 194.63Z",
    fill: "url(#paint216_linear_58_4)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M562.547 189.643C561.55 189.643 561.051 190.142 561.051 191.139V191.638C561.55 192.137 561.55 192.137 562.547 192.137C563.545 192.137 564.044 191.638 564.044 190.641C564.044 190.142 563.545 189.643 562.547 189.643Z",
    fill: "url(#paint217_linear_58_4)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M546.09 193.134C545.591 193.633 545.093 194.132 545.093 195.129C545.591 195.628 546.09 196.127 547.087 195.628C547.586 195.129 548.085 194.631 548.085 193.633C547.586 193.134 546.589 193.134 546.09 193.134Z",
    fill: "url(#paint218_linear_58_4)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M554.069 190.641C553.072 190.641 552.573 191.638 553.072 192.137V192.636C553.571 193.134 554.069 193.633 554.568 193.134C555.565 193.134 556.064 192.137 555.565 191.638C555.565 191.14 555.067 190.641 554.069 190.641Z",
    fill: "url(#paint219_linear_58_4)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M571.524 190.142C570.527 190.142 570.028 190.641 570.028 191.14C570.028 191.638 570.028 191.638 570.028 192.137C570.028 192.636 570.527 192.636 571.026 192.636C572.023 192.636 572.522 192.137 572.522 191.638C572.522 190.641 572.023 190.142 571.524 190.142Z",
    fill: "url(#paint220_linear_58_4)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M579.504 191.638C578.506 191.638 578.007 191.638 577.509 192.636C577.509 193.134 577.509 193.633 577.509 193.633C577.509 194.132 578.007 194.132 578.506 194.132C579.005 194.132 580.002 194.132 580.002 193.134C581 192.636 580.501 192.137 579.504 191.638Z",
    fill: "url(#paint221_linear_58_4)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M448.841 114.338C448.342 114.837 447.844 115.834 448.342 116.333L448.841 116.831C449.34 117.33 449.838 116.831 450.337 116.831C450.836 116.333 451.335 115.335 450.836 114.837C450.337 114.338 449.34 113.839 448.841 114.338Z",
    fill: "url(#paint222_linear_58_4)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M472.779 105.86C471.782 105.86 471.283 106.857 471.283 107.356C471.283 107.854 471.782 108.353 471.782 108.353C471.782 108.353 472.28 108.353 472.779 108.353C473.777 108.353 474.275 107.356 474.275 106.857C474.275 106.358 473.777 105.86 472.779 105.86Z",
    fill: "url(#paint223_linear_58_4)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M435.875 125.808C435.376 126.307 435.376 127.304 435.875 127.803C436.373 128.302 437.371 127.803 437.869 127.304C438.368 126.806 438.368 125.808 437.869 125.309C437.371 125.309 436.373 125.309 435.875 125.808Z",
    fill: "url(#paint224_linear_58_4)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M464.301 107.356C463.304 107.356 463.304 108.353 463.304 108.852C463.304 109.351 463.802 109.351 463.802 109.849C464.301 109.849 464.301 109.849 464.8 109.849C465.299 109.849 465.797 108.852 465.797 108.353C465.797 107.854 465.299 107.356 464.301 107.356Z",
    fill: "url(#paint225_linear_58_4)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M456.321 110.348C455.823 110.847 455.324 111.346 455.324 112.343C455.324 112.842 455.823 112.842 455.823 112.842C456.321 112.842 456.82 113.34 457.319 112.842C457.817 112.343 458.316 111.844 458.316 110.847C457.817 110.348 457.319 109.849 456.321 110.348Z",
    fill: "url(#paint226_linear_58_4)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M441.859 119.325C441.36 119.824 441.36 120.821 441.859 121.32C441.859 121.32 441.859 121.32 442.358 121.818C442.857 122.317 443.355 121.818 443.854 121.818C444.353 121.32 444.353 120.322 443.854 119.824C443.355 118.826 442.358 118.826 441.859 119.325Z",
    fill: "url(#paint227_linear_58_4)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M524.147 128.8C524.645 129.299 525.144 128.8 525.643 128.8C526.141 128.302 526.141 127.304 525.643 126.805C525.144 126.307 524.147 126.307 523.648 126.805C523.648 127.304 523.648 127.803 524.147 128.8Z",
    fill: "url(#paint228_linear_58_4)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M529.134 135.284C529.633 135.782 530.131 135.782 530.63 135.284C531.129 134.785 531.627 133.787 531.129 133.289C530.63 132.79 529.633 132.291 529.134 132.79C528.635 133.289 528.635 134.286 529.134 135.284Z",
    fill: "url(#paint229_linear_58_4)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M518.661 122.816C519.159 123.315 520.157 122.816 520.656 122.317C521.154 121.818 521.154 120.821 520.656 120.322C520.157 119.824 519.159 119.824 518.661 120.322C517.663 121.32 517.663 122.317 518.661 122.816C518.162 122.816 518.661 122.816 518.661 122.816Z",
    fill: "url(#paint230_linear_58_4)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M511.679 117.829C512.178 118.327 513.175 117.829 513.674 117.33C514.173 116.831 513.674 115.834 513.175 115.335C512.676 114.837 511.679 115.335 511.18 115.834C511.18 116.831 511.18 117.829 511.679 117.829Z",
    fill: "url(#paint231_linear_58_4)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M535.617 149.746C535.617 150.245 536.116 150.245 536.116 150.744C536.614 150.744 536.614 150.744 537.113 150.744C538.111 150.744 538.111 149.746 538.111 148.749C538.111 147.751 537.113 147.751 536.116 147.751C535.617 148.25 535.118 149.248 535.617 149.746Z",
    fill: "url(#paint232_linear_58_4)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M496.717 110.847C497.216 111.346 497.216 111.346 496.717 110.847C497.715 111.346 498.712 110.847 498.712 109.849C498.712 108.852 498.712 108.353 497.715 107.855C497.216 107.855 496.218 107.855 495.72 108.852C496.218 109.849 496.218 110.847 496.717 110.847Z",
    fill: "url(#paint233_linear_58_4)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M481.257 108.353C482.255 108.353 482.753 107.854 482.753 106.857C482.753 105.86 482.255 105.361 481.257 105.361C480.26 105.361 479.761 105.86 479.761 106.857C479.761 107.356 480.26 107.854 480.26 108.353C480.759 108.353 481.257 108.353 481.257 108.353Z",
    fill: "url(#paint234_linear_58_4)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M536.115 181.165C535.617 180.667 534.619 181.165 534.12 182.163C534.12 182.661 534.12 183.659 534.619 183.659C535.118 184.158 536.115 183.659 536.614 182.661C537.113 182.163 536.614 181.165 536.115 181.165Z",
    fill: "url(#paint235_linear_58_4)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M537.113 157.726C537.113 158.224 537.612 158.723 537.612 158.723C538.111 158.723 538.111 158.723 538.609 158.723C539.607 158.723 540.106 157.726 540.106 157.227C540.106 156.23 539.108 155.731 538.609 156.23C537.612 156.23 537.113 157.227 537.113 157.726Z",
    fill: "url(#paint236_linear_58_4)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M488.738 109.351C488.738 109.351 489.237 109.351 488.738 109.351C489.736 109.849 490.733 109.351 490.733 108.353C490.733 107.356 490.234 106.857 489.736 106.857C488.738 106.857 488.24 107.356 488.24 107.854C488.24 108.353 488.239 108.852 488.738 109.351Z",
    fill: "url(#paint237_linear_58_4)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M538.11 172.687C537.113 172.687 536.614 173.186 536.614 173.685C536.614 174.183 536.614 174.682 537.113 175.181H537.612C538.609 175.181 539.108 174.682 539.108 174.183C539.108 173.685 538.609 173.186 538.11 172.687Z",
    fill: "url(#paint238_linear_58_4)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M538.609 164.708C537.612 164.708 537.113 165.206 537.113 166.204C537.113 166.703 537.612 167.201 537.612 167.7H538.111C539.108 167.7 539.607 167.201 539.607 166.204C540.105 165.206 539.607 164.708 538.609 164.708Z",
    fill: "url(#paint239_linear_58_4)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M533.124 142.764C533.622 142.764 534.121 143.263 534.62 142.764C535.119 142.266 535.617 141.767 535.119 140.769C534.62 140.271 534.121 139.772 533.124 140.271C532.625 140.769 532.126 141.268 532.625 142.266L533.124 142.764Z",
    fill: "url(#paint240_linear_58_4)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M504.697 114.338C505.694 114.836 506.193 114.338 506.692 113.839C507.19 113.34 506.692 112.343 506.193 111.844C505.694 111.345 504.697 111.844 504.198 112.343C503.699 112.842 504.198 113.839 504.697 114.338Z",
    fill: "url(#paint241_linear_58_4)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M728.12 459.447C722.135 457.95 717.647 444.485 712.161 430.521C703.683 407.082 691.714 375.164 665.781 364.691C691.714 353.72 703.683 322.301 712.161 298.861C717.647 284.399 722.135 271.432 728.12 269.936C729.117 269.437 729.616 268.939 729.616 267.941V267.442C729.117 266.445 728.12 265.448 726.624 265.946C720.639 267.442 710.166 258.466 698.197 248.99C678.747 233.031 652.814 211.587 624.886 215.078C641.843 192.636 636.357 159.222 632.367 134.785C629.874 119.325 627.38 105.86 631.868 101.87C632.367 101.371 632.367 100.873 632.367 100.374C632.367 99.8751 632.367 99.3764 631.868 98.8777C630.871 97.8802 629.375 97.8802 628.377 98.8777C623.889 103.366 609.925 100.873 595.462 98.379C570.527 93.8905 537.612 88.4047 515.17 105.86C518.661 77.9318 497.216 51.9987 481.257 32.5489C471.283 20.5798 462.805 10.1069 464.301 4.12235V3.62364C464.301 2.62621 463.802 1.62879 462.805 1.62879C461.808 1.13008 460.311 2.1275 459.813 3.12492C458.317 9.10947 444.851 13.5979 430.887 19.0837C407.448 27.5618 375.53 39.5309 365.057 65.464C354.086 37.5361 322.667 26.0657 299.227 17.5876C284.765 12.1017 271.798 7.61333 270.302 1.62879C269.803 0.631363 268.806 -0.366062 267.31 0.132651C266.312 0.631363 265.814 1.13008 265.814 2.1275V2.62621C267.31 8.61076 258.333 19.0837 248.857 31.0528C232.899 50.5026 211.454 76.4356 214.945 104.364C192.503 87.4073 159.089 92.8931 134.652 96.8828C119.192 99.3764 105.727 101.87 101.737 97.3815C100.74 96.3841 99.2437 96.3841 98.2463 97.3815C97.7476 97.8802 97.7476 98.379 97.7476 98.8777C97.7476 99.3764 97.7476 99.8751 98.2463 100.374C102.735 104.862 100.241 118.826 97.7476 133.289C93.2592 158.224 87.7734 191.139 105.228 213.581C77.3004 210.09 51.3674 231.535 31.9176 247.494C19.9485 257.468 9.47553 265.946 3.49099 264.45C2.49356 263.951 0.997425 264.949 0.498712 265.946V266.445C0.498712 267.442 0.997425 268.44 1.99485 268.44C7.9794 269.936 12.4678 283.401 17.9536 297.365C26.4317 320.805 38.4008 352.722 64.3339 363.195C38.4008 374.167 26.4317 405.586 17.9536 429.025C12.4678 443.488 7.9794 456.454 1.99485 457.95C0.498712 459.945 0 460.943 0 461.94V462.439C0.498712 463.436 1.49614 464.434 2.99227 463.935C8.97682 462.439 19.4498 471.416 31.4189 480.891C49.3725 495.853 72.812 515.302 98.2463 515.302C100.241 515.302 102.735 515.302 104.73 514.804C87.7734 537.246 93.2592 570.659 97.7476 595.096C100.241 610.556 102.735 624.022 98.2463 628.011C97.7476 628.51 97.7476 629.009 97.7476 629.507C97.7476 630.006 97.7476 630.505 98.2463 631.004C99.2437 632.001 100.74 632.001 101.737 631.004C106.226 626.515 120.19 629.009 134.652 631.502C146.621 633.497 160.585 635.991 174.051 635.991C189.012 635.991 203.475 632.998 214.945 624.022C211.454 651.949 232.899 677.883 248.857 697.332C258.832 709.301 267.31 719.774 265.814 725.759V726.258C265.814 727.255 266.312 728.253 267.31 728.253H267.808C268.806 728.253 269.803 727.754 269.803 726.756C271.299 720.772 284.765 716.283 298.729 710.798C322.168 702.32 354.086 690.35 364.559 664.417C375.53 690.35 406.949 702.32 430.389 710.798C444.851 716.283 457.818 720.772 459.314 726.756C459.813 727.754 460.311 728.253 461.309 728.253H461.808C462.805 727.754 463.304 727.255 463.304 726.258V725.759C461.808 719.774 470.784 709.301 480.26 697.332C496.219 677.883 517.663 651.949 514.172 624.022C526.141 632.998 540.604 635.492 555.067 635.492C568.532 635.492 582.496 632.998 594.465 631.004C609.925 628.51 623.39 626.016 627.38 630.505C628.377 631.502 629.874 631.502 630.871 630.505C631.37 630.006 631.37 629.507 631.37 629.009C631.37 628.51 631.37 628.011 630.871 627.513C626.383 623.024 628.876 609.06 631.37 594.598C635.858 569.662 641.344 536.747 623.889 514.305C625.884 514.305 627.879 514.804 629.874 514.804C655.807 514.804 679.246 495.354 697.2 480.393C709.169 470.418 719.642 461.94 725.626 463.436C726.624 463.935 728.12 462.938 728.619 461.94V461.441C730.115 460.943 729.616 459.945 728.12 459.447ZM695.704 251.484C705.678 259.962 714.156 266.944 721.138 268.939C716.151 274.424 712.66 284.897 708.171 296.866C699.195 321.802 687.724 352.223 661.292 361.2C660.794 350.229 657.801 339.756 652.316 330.28L664.783 339.257C664.783 339.756 664.783 340.254 664.783 340.753C664.783 344.244 667.776 347.735 671.765 347.735C675.755 347.735 678.747 344.743 678.747 340.753C678.747 337.262 675.755 333.771 671.765 333.771C670.269 333.771 668.773 334.27 667.776 335.267L652.814 324.296C654.31 321.802 655.807 319.308 657.303 316.815L677.251 324.296C677.251 327.787 680.244 330.779 683.735 330.779C687.226 330.779 690.218 327.787 690.218 323.797C690.218 320.306 687.226 316.815 683.735 316.815C681.74 316.815 679.745 317.812 678.747 319.308L659.298 311.828C660.794 308.337 661.292 304.846 661.791 301.355L686.727 303.848C687.724 306.841 690.218 308.836 693.21 308.836C696.701 308.836 700.192 305.843 700.192 301.854C700.192 298.363 697.2 294.872 693.21 294.872C690.716 294.872 688.223 296.368 687.226 298.861L662.29 296.368C662.29 292.877 661.791 289.386 661.292 285.895L693.709 277.417C695.205 279.91 697.698 281.406 701.189 281.406C705.678 281.406 709.668 277.417 709.668 272.928C709.668 268.44 705.678 264.45 701.189 264.45C696.701 264.45 692.711 267.941 692.711 272.928L660.295 281.406C659.298 278.414 657.802 275.422 656.305 272.928L676.753 257.967C678.747 259.463 681.74 259.463 683.735 258.466C686.727 256.471 688.223 252.481 686.228 248.99C684.233 245.998 680.243 244.502 676.753 246.496C674.259 247.993 672.763 251.484 673.76 253.977L653.313 268.44C651.318 265.448 648.825 262.954 645.832 260.959L659.298 244.003C661.292 244.502 663.287 244.502 664.783 243.504C667.776 241.509 668.773 237.52 667.277 234.527C665.282 231.535 661.292 230.039 658.3 232.034C655.308 234.029 654.31 238.018 655.807 241.011L642.341 257.967C639.848 256.471 637.354 254.975 634.861 253.977L642.84 236.522C644.336 236.522 645.334 236.522 646.83 235.525C649.822 233.53 651.318 229.54 649.323 226.049C647.328 223.057 643.339 221.561 639.848 223.556C636.856 225.551 635.359 229.54 637.354 233.031C637.853 233.53 637.853 234.029 638.352 234.527L631.868 248.99C631.868 238.517 629.375 227.545 623.889 217.072C650.321 213.581 675.755 234.527 695.704 251.484ZM655.308 442.49C652.316 454.958 643.339 464.932 630.372 470.418C628.377 454.958 620.897 439.997 608.429 430.023C623.889 427.529 637.354 419.051 646.83 406.583C655.308 417.555 658.3 430.521 655.308 442.49ZM617.406 510.315C601.447 538.243 567.535 549.714 540.604 536.747C540.105 535.75 540.105 534.752 540.604 532.757C541.103 532.259 541.602 531.76 541.103 531.261C541.103 531.261 541.103 530.762 540.604 530.762C540.604 529.765 541.103 528.768 541.103 527.77C548.583 531.76 556.563 534.253 565.041 534.253C570.028 534.253 574.516 533.755 579.504 532.259C592.47 528.269 603.941 519.292 610.922 507.323C617.904 495.354 619.899 480.891 616.907 467.426C613.915 453.961 605.437 442.989 593.966 436.506C596.959 433.514 599.951 431.519 601.447 431.519C626.881 447.477 633.365 482.886 617.406 510.315ZM577.509 577.143C568.532 586.618 555.565 590.608 541.602 589.112C547.586 574.649 548.583 558.192 543.098 543.23C550.08 545.724 557.062 547.22 564.044 547.22C572.023 547.22 580.501 545.724 587.982 542.732C589.977 555.698 585.987 568.166 577.509 577.143ZM510.681 617.04C482.753 632.998 447.844 626.016 430.887 601.081C430.887 600.083 431.885 599.086 432.882 597.59C433.381 597.59 433.88 597.091 434.378 596.592V596.094C434.877 595.595 435.875 594.598 436.373 593.6C442.856 605.071 454.327 613.05 467.293 616.541C471.283 617.538 475.273 618.037 479.761 618.037C489.237 618.037 498.712 615.544 507.19 610.556C532.625 596.094 541.602 564.675 528.136 540.737C532.126 539.739 535.617 539.241 537.113 540.238C550.08 567.168 538.609 601.081 510.681 617.04ZM442.857 654.942C430.389 658.433 417.422 655.939 405.952 647.461C418.42 637.986 427.396 624.022 430.389 608.562C440.363 620.531 454.327 628.011 469.787 630.505C464.301 642.474 454.826 651.451 442.857 654.942ZM365.057 656.438C332.641 656.438 306.209 632.998 303.716 603.076C304.214 602.577 305.212 601.58 307.207 601.081C307.705 601.58 308.204 601.58 309.202 601.081L309.7 600.582C310.698 600.083 311.695 600.083 312.693 599.585C312.693 627.014 336.631 649.456 365.556 649.456C394.481 649.456 418.42 627.014 418.42 599.585C422.409 601.081 425.9 602.078 426.898 603.574C423.905 632.998 396.975 656.438 365.057 656.438ZM287.258 654.942C274.79 651.95 264.816 642.973 259.33 630.006C274.79 628.011 289.752 620.531 299.726 608.063C302.22 623.523 310.698 636.988 323.166 646.464C312.194 654.942 299.227 657.934 287.258 654.942ZM218.935 617.04C191.007 601.081 179.536 567.168 192.503 540.238C193.5 539.739 194.498 539.739 196.493 540.238C196.991 540.737 197.49 541.235 197.989 540.737C197.989 540.737 198.487 540.737 198.487 540.238C199.485 540.238 200.482 540.737 201.48 540.737C194.997 552.207 193.5 565.672 197.49 579.138C201.48 592.104 210.457 603.574 222.426 610.556C230.904 615.544 240.379 618.037 249.855 618.037C253.845 618.037 257.834 617.538 262.323 616.541C275.788 613.549 286.76 605.071 293.243 593.6C296.235 596.592 298.23 599.585 298.23 601.081C281.772 626.515 246.863 632.998 218.935 617.04ZM152.606 577.143C143.13 568.166 139.141 555.199 140.637 541.235C148.616 544.726 157.094 546.222 165.572 546.222C172.554 546.222 179.536 544.726 186.518 542.233C181.033 556.695 181.531 572.654 187.516 587.117C174.051 589.61 161.583 585.621 152.606 577.143ZM128.169 430.521C129.166 430.521 130.164 431.519 131.66 432.516C131.66 433.015 132.159 433.514 132.657 434.012H133.156C133.655 434.511 134.652 435.508 135.65 436.007C124.179 442.49 116.2 453.961 112.709 466.927C109.717 480.392 111.712 494.356 118.694 506.824C125.675 519.292 136.647 527.77 150.112 531.76C155.1 533.256 159.588 533.755 164.575 533.755C173.053 533.755 181.033 531.76 188.513 527.271C189.511 531.261 190.009 535.251 189.012 536.248C161.583 549.215 128.169 537.744 112.21 509.817C96.2515 482.387 103.233 447.478 128.169 430.521ZM99.7424 469.421C87.2746 464.434 78.2978 454.459 74.8068 442.49C71.3158 430.023 73.8094 417.056 82.2875 405.586C91.7631 418.053 105.727 427.03 121.187 430.023C109.218 439.997 101.737 453.961 99.7424 469.421ZM74.8068 286.892C77.7991 274.424 86.7759 264.45 99.7424 258.964C101.737 274.424 109.218 289.386 121.686 299.36C106.226 301.854 92.7605 310.332 83.285 322.799C74.8068 311.828 71.8146 298.861 74.8068 286.892ZM112.709 218.569C128.668 190.641 162.58 179.17 189.511 192.137C190.009 193.134 190.009 194.132 189.511 196.127C189.012 196.625 188.513 197.124 189.012 197.623C189.012 197.623 189.012 198.121 189.511 198.121C189.511 199.119 189.012 200.116 189.012 201.114C165.074 187.648 134.154 196.625 119.192 222.06C104.73 247.494 112.21 278.913 136.148 292.877C133.156 295.869 130.164 297.864 128.668 297.864C103.233 281.406 96.2515 246.496 112.709 218.569ZM152.606 152.24C161.583 142.764 174.549 138.775 188.513 140.271C182.529 154.733 181.531 171.191 187.017 186.152C172.554 180.666 156.596 181.165 142.133 187.15C140.138 173.684 144.128 161.217 152.606 152.24ZM219.433 111.844C247.361 95.8854 282.271 102.867 299.227 127.803C299.227 128.8 298.23 129.798 297.232 131.294C296.734 131.294 296.235 131.793 295.736 132.291V132.79C295.238 133.289 294.24 134.286 293.742 135.284C287.258 123.813 275.788 115.834 262.821 112.343C249.356 109.351 235.392 111.345 222.924 118.327C210.457 125.309 201.978 136.281 197.989 149.746C193.999 162.713 195.495 176.677 201.978 188.147C197.989 189.145 194.498 189.643 193.002 189.145C180.035 161.715 191.506 128.302 219.433 111.844ZM287.258 74.4408C299.726 70.9498 312.693 73.4434 324.163 81.9215C311.695 91.397 302.718 105.361 299.726 120.821C289.752 108.852 275.788 101.371 260.328 99.3764C265.814 86.9086 275.289 77.9318 287.258 74.4408ZM365.057 72.9446C397.474 72.9446 423.905 96.3841 426.399 126.307C425.9 126.806 424.903 127.803 422.908 128.302C422.409 127.803 421.911 127.803 420.913 128.302L420.414 128.8C419.417 129.299 418.42 129.299 417.422 129.798C417.422 102.369 393.484 79.9266 364.559 79.9266C335.633 79.9266 311.695 102.369 311.695 129.798C307.705 128.302 304.214 127.304 303.217 125.808C306.209 96.3841 333.14 72.9446 365.057 72.9446ZM442.857 74.4408C455.324 77.433 465.299 86.4099 470.784 99.3764C455.324 101.371 440.363 108.852 430.389 121.32C427.895 105.86 419.417 92.3944 406.949 82.9189C417.921 74.4408 430.887 71.4485 442.857 74.4408ZM510.681 112.343C538.609 128.302 550.08 162.214 537.113 189.145C536.116 189.643 535.118 189.643 533.123 189.145C532.625 188.646 532.126 188.147 531.627 188.646C531.627 188.646 531.129 188.646 531.129 189.145C530.131 189.145 529.134 188.646 528.136 188.646C541.602 164.708 532.625 133.788 507.19 118.826C481.756 104.364 450.337 111.844 436.373 135.782C433.381 132.79 431.386 129.798 431.386 128.302C448.342 102.867 483.252 95.8854 510.681 112.343ZM577.509 152.24C586.984 161.217 590.974 174.183 589.478 188.147C575.015 182.163 558.558 181.165 543.596 186.651C549.082 172.188 548.583 156.23 542.599 141.767C556.064 139.772 568.532 143.762 577.509 152.24ZM601.946 298.861C600.948 298.861 599.951 297.864 598.455 296.866C598.455 296.368 597.956 295.869 597.457 295.37H596.959C596.46 294.872 595.462 293.874 594.465 293.375C605.935 286.892 613.915 275.422 617.406 262.455C620.398 248.99 618.403 235.026 611.421 222.558C604.439 210.09 593.468 201.612 580.002 197.623C567.036 193.633 553.072 195.129 541.602 201.612C540.604 197.623 540.105 193.633 541.103 192.636C568.532 179.669 601.946 191.139 617.904 219.067C633.863 246.995 626.881 281.905 601.946 298.861ZM630.372 259.962C642.84 264.949 651.817 274.923 655.308 286.892C658.799 299.36 656.305 312.326 647.827 323.797C638.352 311.329 624.388 302.352 608.928 299.36C620.897 289.386 628.377 275.422 630.372 259.962ZM598.953 316.316C601.447 316.316 603.941 316.815 605.935 316.815C604.439 319.308 602.943 322.799 600.948 326.29C596.46 335.766 591.473 347.236 581.498 354.717C588.979 344.743 592.969 331.278 595.961 319.807C596.46 318.311 596.959 317.314 596.959 315.817C597.956 316.316 598.455 316.316 598.953 316.316ZM583.992 438.999C572.023 450.47 555.565 466.429 539.108 462.439C538.111 460.943 536.614 456.454 535.118 452.465C534.62 450.969 534.121 448.974 533.622 447.478C534.121 447.478 534.62 447.478 534.62 447.478C551.576 446.979 566.038 435.01 570.527 419.051C575.015 402.593 568.033 385.138 553.571 376.162C554.568 375.164 555.067 374.665 556.064 374.167C559.056 371.175 563.046 367.684 564.542 367.185C580.501 372.172 586.984 394.115 591.473 410.074C593.468 417.555 595.462 423.539 597.457 427.03C594.465 429.025 589.977 433.514 583.992 438.999ZM591.473 439.997C593.468 440.994 595.462 442.49 597.457 443.987C594.964 445.483 591.971 447.478 588.48 449.971C580.002 455.956 569.529 463.436 557.56 464.932C569.031 459.945 579.005 449.971 587.483 441.992C588.48 440.994 589.478 439.997 590.475 438.999C590.974 439.498 591.473 439.498 591.473 439.997ZM517.663 538.742C501.206 542.732 479.262 548.217 467.293 536.747C467.293 534.752 468.291 530.264 468.79 526.274C469.288 524.778 469.787 522.783 469.787 520.788C470.286 520.788 470.286 521.287 470.784 521.287C476.27 524.279 482.753 525.775 488.738 525.775C498.712 525.775 508.686 521.786 516.167 514.305C528.136 502.336 530.63 483.883 522.65 468.922C523.648 468.922 524.645 468.423 525.643 468.423C529.632 467.426 534.62 466.429 536.614 466.927C548.085 479.395 542.599 501.338 538.609 517.796C536.614 525.277 535.118 531.261 535.118 535.75C531.627 535.251 525.643 536.747 517.663 538.742ZM427.396 597.59C423.905 595.096 417.921 593.6 410.44 591.605C394.481 587.117 372.538 580.634 367.551 564.675C368.05 563.179 371.541 559.189 374.533 556.197C375.53 555.199 377.026 553.703 378.024 552.207C378.024 552.706 378.523 552.706 378.523 553.204C385.505 564.675 398.471 571.158 411.438 571.158C414.929 571.158 417.921 570.659 421.412 569.662C437.869 565.174 449.34 550.711 449.838 533.755C450.836 534.253 451.833 534.253 452.831 534.752C456.82 536.248 461.808 537.744 462.805 538.742C466.795 555.199 450.836 571.657 438.867 583.626C433.88 589.61 429.391 594.099 427.396 597.59ZM352.59 642.474C352.59 638.484 354.584 632.5 356.579 625.019C358.574 618.037 361.068 610.058 363.063 600.582V643.97C359.073 643.471 355.582 642.973 352.59 642.474ZM302.718 597.59C300.723 593.6 296.734 589.61 290.749 583.626C279.279 571.657 263.32 555.199 267.31 538.742C268.806 537.744 273.294 536.248 277.284 534.752C278.78 534.253 280.775 533.755 282.271 533.256C282.271 533.755 282.271 534.253 282.271 534.253C282.77 551.21 294.739 565.672 310.698 570.161C314.189 571.158 317.181 571.657 320.672 571.657C333.639 571.657 346.106 565.174 353.587 553.703C354.584 554.701 355.083 555.199 355.582 556.197C358.574 559.189 362.065 563.179 362.564 564.675C357.577 580.634 335.633 587.117 319.675 591.605C312.194 593.6 306.209 595.595 302.718 597.59ZM194.498 535.251C194.498 531.261 193.002 525.277 191.506 517.297C187.516 500.84 182.03 478.896 193.5 466.927C195.495 466.927 199.984 467.925 203.973 468.423C205.469 468.922 207.464 469.421 209.459 469.421C209.459 469.92 208.96 469.92 208.96 470.418C200.981 485.38 203.973 503.832 215.942 515.801C223.423 523.282 233.397 527.271 243.372 527.271C249.356 527.271 255.839 525.775 261.325 522.783C261.325 523.78 261.824 524.778 261.824 525.775C262.821 529.765 263.819 534.752 263.32 536.747C250.852 548.217 228.909 542.732 212.451 538.742C204.971 536.747 198.487 535.251 194.498 535.251ZM131.161 413.066C128.668 413.066 126.174 412.568 124.179 412.568C125.675 410.074 127.172 406.583 129.166 403.092C133.655 393.617 138.642 382.146 148.616 374.665C141.136 384.64 137.146 398.105 134.154 409.575C133.655 411.072 133.156 412.568 133.156 413.565C132.159 413.066 131.66 413.066 131.161 413.066ZM146.123 290.383C158.092 278.913 174.549 262.954 191.007 266.944C192.004 268.44 193.5 272.928 194.996 276.918C195.495 278.414 195.994 280.409 196.493 281.905C195.994 281.905 195.495 281.905 195.495 281.905C178.539 282.404 164.076 294.373 159.588 310.332C155.1 326.789 162.081 344.244 176.544 353.221C175.547 354.218 175.048 354.717 174.051 355.216C171.058 358.208 167.069 361.699 165.572 362.198C149.614 357.211 143.13 335.267 138.642 319.308C136.647 311.828 134.652 305.843 132.657 302.352C135.65 300.357 140.138 295.869 146.123 290.383ZM138.642 289.386C136.647 288.388 134.652 286.892 132.657 285.396C135.151 283.9 138.143 281.905 141.634 279.411C150.112 273.427 160.585 265.946 172.554 264.45C161.084 269.437 150.611 279.411 142.632 287.391C141.634 288.388 140.637 289.386 139.639 290.383C139.141 289.884 138.642 289.884 138.642 289.386ZM212.451 190.641C228.909 186.651 250.852 181.165 262.821 192.636C262.821 194.63 261.824 199.119 261.325 203.109C260.827 204.605 260.328 206.6 260.328 208.594C259.829 208.594 259.829 208.096 259.33 208.096C244.369 200.116 225.917 203.109 213.948 215.078C201.978 227.047 199.485 245.499 207.464 260.46C206.467 260.46 205.469 260.959 204.472 260.959C200.482 261.957 195.495 262.954 193.5 262.455C182.03 249.987 187.516 228.044 191.506 211.587C193.5 204.106 194.996 198.121 194.996 193.633C198.487 194.132 204.472 192.636 212.451 190.641ZM302.718 131.793C306.209 134.286 312.194 135.782 319.675 137.777C335.633 142.266 357.577 148.749 362.564 164.708C362.065 166.204 358.574 170.193 355.582 173.186C354.584 174.183 353.088 175.679 352.091 177.175C352.091 176.677 351.592 176.677 351.592 176.178C342.615 161.715 325.16 154.733 308.703 159.222C292.245 163.71 280.775 178.173 280.276 195.129C279.279 194.63 278.281 194.63 277.284 194.132C273.294 192.636 268.307 191.139 267.31 190.142C263.32 173.684 279.279 157.227 291.248 145.258C296.235 139.772 300.723 135.284 302.718 131.793ZM377.525 86.9086C377.525 90.8983 375.53 96.8828 373.535 104.364C371.541 111.345 369.047 119.325 367.052 128.8V85.4124C371.042 85.9112 374.533 86.4099 377.525 86.9086ZM427.396 131.793C429.391 135.782 433.381 139.772 439.365 145.757C450.836 157.726 466.795 174.183 462.805 190.641C461.309 191.638 456.82 193.134 452.831 194.63C451.335 195.129 449.34 195.628 447.844 196.127C447.844 195.628 447.844 195.129 447.844 195.129C447.345 178.173 435.875 163.71 419.417 159.222C402.96 154.733 385.505 161.715 376.528 176.178C375.53 175.181 375.032 174.682 374.533 173.684C371.541 170.692 368.05 166.703 367.551 165.206C372.538 149.248 394.481 142.764 410.44 138.276C417.921 135.782 423.905 133.788 427.396 131.793ZM514.671 130.297C512.676 133.788 508.188 137.777 502.702 143.263C497.715 148.25 491.73 153.736 485.247 161.217L507.19 123.813C509.684 125.808 512.177 128.302 514.671 130.297ZM535.617 194.132C535.617 198.121 537.113 204.106 538.609 212.085C542.599 228.543 548.085 250.486 536.614 262.455C534.62 262.455 530.131 261.458 526.141 260.959C524.645 260.46 522.65 259.962 520.656 259.962C520.656 259.463 521.154 259.463 521.154 258.964C529.134 244.003 526.141 225.551 514.172 213.581C502.203 201.612 483.751 199.119 468.79 207.098C468.79 206.101 468.291 205.103 468.291 204.106C467.293 200.116 466.296 195.129 466.795 193.134C479.262 181.664 501.206 187.15 517.663 191.139C525.144 192.636 531.129 194.132 535.617 194.132ZM597.956 302.352C595.462 305.843 593.966 311.828 591.971 319.308C587.483 335.267 581 357.211 565.041 362.198C563.545 361.699 559.555 358.208 556.563 355.216C555.565 354.218 554.069 352.722 552.573 351.725C553.072 351.725 553.072 351.226 553.571 351.226C568.033 342.249 575.015 324.794 570.527 308.337C566.038 291.879 551.576 280.409 534.62 279.91C535.118 278.913 535.118 277.915 535.617 276.918C537.113 272.928 538.609 267.941 539.607 266.944C556.064 262.954 572.522 278.913 584.491 290.882C589.977 295.869 594.465 300.357 597.956 302.352ZM551.077 379.653C564.044 387.133 570.527 403.092 566.537 417.555C562.547 432.017 549.581 441.992 535.118 442.49C534.121 442.49 533.123 442.49 532.625 442.49C532.126 440.994 531.627 439.997 531.129 438.501C532.126 438.501 533.123 438.501 534.121 438.501C539.108 438.501 544.095 437.005 548.583 434.511C555.565 430.521 561.051 424.537 563.046 416.557C565.041 409.077 564.044 401.097 560.553 394.115C557.56 388.629 553.072 384.64 547.586 381.647C548.085 381.647 549.581 380.151 551.077 379.653C550.578 379.653 551.077 379.653 551.077 379.653ZM518.661 470.418C526.141 483.385 523.648 500.341 513.175 510.814C502.702 521.287 486.244 523.78 473.278 516.798C472.281 516.3 471.782 515.801 470.784 515.302C471.283 513.806 471.283 512.31 471.283 510.814C476.27 514.305 481.756 516.3 488.239 516.3C488.738 516.3 488.738 516.3 489.237 516.3C497.216 516.3 504.198 513.307 509.684 508.32C515.17 502.835 518.661 495.354 518.661 487.374C518.661 481.39 516.666 475.405 513.175 470.418C515.17 470.917 516.666 470.418 518.661 470.418ZM464.301 524.778C463.304 528.269 462.805 531.261 462.805 533.256C460.81 532.259 457.818 531.261 454.327 530.264C444.851 527.271 431.885 523.282 421.412 514.804C425.9 516.3 429.89 516.798 433.88 516.798C439.864 516.798 445.35 515.302 450.337 512.31C458.815 507.323 464.8 498.845 466.795 488.372C469.288 502.336 466.296 515.302 464.301 524.778ZM445.35 533.256C445.35 548.217 434.877 561.683 420.414 565.672C405.952 569.662 390.492 563.179 383.011 550.711C382.512 549.714 382.014 549.215 381.515 548.217C382.512 547.22 383.51 546.223 384.507 544.726C389.494 555.698 400.466 562.68 411.936 562.68C414.43 562.68 416.425 562.181 418.918 561.683C432.882 558.192 442.358 544.726 440.862 530.762C442.358 531.261 443.854 531.76 445.35 532.259C444.851 532.757 445.35 533.256 445.35 533.256ZM365.057 559.688C363.561 557.693 361.566 555.698 359.073 553.204C352.59 545.724 343.114 535.75 338.626 523.282C346.106 531.261 355.083 535.75 365.057 535.75C375.032 535.75 384.008 531.261 391.489 523.282C386.502 536.248 377.525 546.223 371.042 553.204C368.548 555.698 366.553 557.693 365.057 559.688ZM196.493 444.984C181.531 444.984 168.066 434.511 164.076 420.048C160.087 405.586 166.57 390.126 179.038 382.645C179.536 382.146 180.534 381.647 181.531 381.149C182.529 382.146 183.526 383.144 185.022 384.141C172.056 390.126 164.575 404.588 168.066 418.552C171.557 432.017 183.526 440.994 196.493 440.994C197.49 440.994 197.989 440.994 198.986 440.994C198.487 442.49 197.989 443.987 197.49 445.483C196.991 444.485 196.493 444.984 196.493 444.984ZM179.038 349.73C166.071 342.249 159.588 326.29 163.578 311.828C167.567 297.365 180.534 287.391 194.996 286.892C195.994 286.892 196.991 286.892 197.49 286.892C197.989 288.388 198.487 289.386 198.986 290.882C185.022 289.386 171.058 298.363 167.069 312.326C163.079 326.29 170.061 340.753 183.027 347.236C182.03 347.735 180.534 348.732 179.038 349.73C179.536 349.73 179.038 349.73 179.038 349.73ZM211.454 258.964C203.973 245.998 206.467 229.042 216.94 218.569C227.413 208.096 243.87 205.602 256.837 212.584C257.834 213.083 258.333 213.581 259.33 214.08C258.832 215.576 258.832 217.072 258.832 218.569C247.361 210.589 230.904 211.088 220.431 221.062C209.958 231.036 208.96 247.494 216.94 258.964C214.945 258.466 213.449 258.964 211.454 258.964ZM265.814 204.605C266.811 201.114 267.31 198.121 267.31 196.127C269.305 197.124 272.297 198.121 275.788 199.119C285.263 202.111 298.23 206.101 308.703 214.579C298.23 211.088 287.757 212.085 279.279 217.072C270.801 222.06 264.816 230.538 262.821 241.011C260.827 227.047 263.819 214.08 265.814 204.605ZM284.765 196.127C284.765 181.165 295.238 167.7 309.7 163.71C324.163 159.721 339.623 166.204 347.104 178.672C347.602 179.669 348.101 180.168 348.6 181.165C347.602 182.163 346.605 183.16 345.608 184.656C343.114 179.17 339.124 174.682 333.639 171.191C326.657 166.703 318.677 165.705 311.196 167.7C304.214 169.196 297.731 174.183 293.742 180.666C290.749 186.152 289.253 192.137 289.752 198.121C288.256 197.623 286.76 197.124 285.263 196.625C284.765 196.625 284.765 196.127 284.765 196.127ZM365.057 169.695C366.553 171.69 368.548 173.684 371.042 176.178C377.525 183.659 387.001 193.633 391.489 206.101C384.008 198.121 375.032 193.633 365.057 193.633C355.083 193.633 346.106 198.121 338.626 206.101C343.613 193.134 352.59 183.16 359.073 176.178C361.566 173.684 363.561 171.191 365.057 169.695ZM533.622 284.399C548.583 284.399 562.049 294.872 566.038 309.334C570.028 323.797 563.545 339.257 551.077 346.738C550.08 347.236 549.581 347.735 548.583 348.234C547.586 347.236 546.589 346.239 545.093 345.242C550.578 342.748 555.067 338.758 558.558 333.272C563.046 326.29 564.044 318.311 562.049 310.83C560.054 303.35 555.067 296.866 548.583 292.877C543.098 289.884 537.113 288.388 531.129 288.887C531.627 287.391 532.126 285.895 532.625 284.399C533.123 284.399 533.622 284.399 533.622 284.399ZM527.139 431.02C522.152 421.544 515.17 411.57 503.699 405.087C499.211 402.593 494.224 400.1 489.237 398.105C494.224 398.604 499.71 399.102 505.196 399.102C519.159 399.102 530.63 393.617 540.105 387.133C546.09 388.629 550.578 392.619 553.571 397.606C556.563 403.092 557.062 409.077 555.565 414.562C554.069 420.547 550.08 425.035 544.594 428.028C539.607 431.519 533.123 432.516 527.139 431.02ZM511.679 487.873C511.679 493.858 509.185 499.344 504.697 503.832C500.208 507.822 494.723 510.315 488.239 509.817C482.255 509.817 476.27 507.323 471.782 502.835C472.28 491.863 470.784 479.894 464.301 468.922C461.808 464.434 458.815 459.945 455.324 455.457C459.314 458.449 463.802 461.94 468.79 464.434C478.764 469.92 488.738 471.914 498.712 471.914C500.707 471.914 503.201 471.914 505.196 471.416C509.684 476.403 511.679 481.889 511.679 487.873ZM416.425 555.199C404.456 558.192 391.988 550.212 388.497 538.243C394.481 529.266 399.469 518.295 399.469 504.829C399.469 499.344 398.97 493.858 398.471 488.871C400.466 493.858 402.96 498.346 405.453 503.333C412.435 515.302 422.908 522.783 433.381 527.77C435.875 539.739 428.893 552.207 416.425 555.199ZM298.729 526.773C308.204 521.786 318.178 514.804 324.662 503.333C327.155 498.845 329.649 493.858 331.644 488.871C331.145 493.858 330.646 499.344 330.646 504.829C330.646 518.793 336.132 530.264 342.615 539.739C339.124 551.708 326.657 558.69 314.687 555.199C302.718 552.207 295.238 539.241 298.729 526.773ZM226.415 471.914C227.912 471.914 229.408 471.914 230.904 471.914C240.379 471.914 250.852 469.92 260.827 464.434C265.315 461.94 269.803 458.948 274.292 455.457C271.299 459.447 267.808 463.935 265.315 468.922C258.333 480.891 257.336 493.858 258.333 505.328C253.845 509.318 248.359 511.811 242.374 511.811C236.39 511.811 230.904 509.318 226.415 504.829C222.426 500.341 219.932 494.855 220.431 488.372C219.932 482.387 222.426 476.403 226.415 471.914ZM201.978 432.516C190.009 435.508 177.542 428.028 174.549 416.059C171.557 404.09 179.536 391.622 191.506 388.131C200.482 394.115 211.454 399.102 224.919 399.102C230.405 399.102 235.891 398.604 240.878 398.105C235.891 400.1 231.402 402.593 226.415 405.087C213.948 412.069 206.966 422.542 201.978 432.516ZM202.976 298.363C207.963 307.838 214.945 317.812 226.415 324.296C230.904 326.789 235.891 329.283 240.878 331.278C235.891 330.779 230.405 330.28 224.919 330.28C210.955 330.28 199.485 335.766 190.009 342.249C178.04 338.758 171.058 326.29 174.549 314.321C177.542 302.352 190.508 294.872 202.976 298.363ZM224.919 225.551C233.896 217.072 248.857 217.571 257.336 226.548C256.837 237.52 258.333 249.489 264.816 260.46C267.31 264.949 270.302 269.437 273.793 273.926C269.803 270.933 265.315 267.442 260.328 264.949C248.359 257.967 235.392 256.969 223.922 257.967C215.942 248.491 215.942 234.029 224.919 225.551ZM299.726 184.157C302.718 179.17 307.705 175.181 313.69 173.684C319.675 172.188 325.659 173.186 331.145 176.677C336.631 179.669 340.122 185.155 341.618 190.641C335.633 199.618 330.646 210.589 330.646 224.054C330.646 229.54 331.145 235.026 331.644 240.013C329.649 235.026 327.155 230.538 324.662 225.551C317.68 213.581 307.207 206.101 296.734 201.114C295.736 195.628 296.734 189.643 299.726 184.157ZM431.386 202.61C421.911 207.597 411.936 214.579 405.453 226.049C402.96 230.538 400.466 235.525 398.471 240.512C398.97 235.525 399.469 230.039 399.469 224.553C399.469 210.589 393.983 199.119 387.499 189.643C388.996 183.659 392.985 179.17 397.972 176.178C403.458 173.186 409.443 172.687 414.929 174.183C427.396 177.175 434.877 190.142 431.386 202.61ZM503.699 257.468C492.728 256.969 480.759 258.466 469.787 264.949C465.299 267.442 460.81 270.435 456.322 273.926C459.314 269.936 462.805 265.448 465.299 260.46C472.281 248.491 473.278 235.525 472.28 224.054C476.769 220.065 482.255 217.571 488.239 217.571C494.224 217.571 499.71 220.065 504.198 224.553C508.188 229.042 510.681 234.527 510.183 241.011C510.183 246.995 507.689 252.98 503.699 257.468ZM457.319 450.968C453.828 447.976 450.836 445.483 447.844 442.49C452.332 443.987 457.319 444.984 461.808 444.984C462.805 444.984 464.301 444.984 465.299 444.984C473.777 443.987 480.26 439.997 483.751 434.012C489.735 423.539 485.247 408.578 473.278 398.604C477.268 399.601 481.257 400.599 485.247 402.095C496.219 414.562 499.71 429.025 493.226 439.498C487.741 449.971 473.777 454.459 457.319 450.968ZM439.365 493.858C428.893 499.842 413.931 496.85 401.962 485.878C400.466 481.889 398.97 477.899 398.471 473.909C405.453 482.387 414.929 487.374 423.407 487.374C426.898 487.374 430.389 486.377 433.88 484.881C444.353 478.896 447.844 463.436 442.358 448.974C445.35 451.966 448.342 454.958 450.836 458.449C454.826 473.411 450.337 487.374 439.365 493.858ZM409.443 501.338C407.947 498.845 406.949 496.85 405.952 494.356C407.947 495.853 410.44 496.85 412.435 497.847L410.44 502.835C409.941 502.336 409.941 501.837 409.443 501.338ZM413.931 506.824L416.425 499.344C417.422 499.842 418.42 499.842 418.918 499.842L416.923 508.32C415.926 507.822 414.929 507.323 413.931 506.824ZM365.057 513.806C352.59 513.806 341.618 503.832 336.631 487.873C337.129 483.385 338.127 479.395 339.623 475.405C342.615 490.865 352.59 502.336 365.057 502.336C377.525 502.336 387.499 490.865 390.492 475.405C391.489 479.395 392.487 483.385 393.484 487.873C388.497 503.333 377.525 513.806 365.057 513.806ZM290.749 493.858C280.276 487.873 275.788 473.411 279.279 457.452C282.271 453.961 284.765 450.968 287.757 447.976C282.271 462.938 285.762 477.899 296.235 483.883C299.227 485.878 302.718 486.377 306.708 486.377C315.186 486.377 324.662 481.39 331.644 472.912C330.646 476.902 329.649 480.891 328.153 484.881C315.685 496.85 301.222 499.842 290.749 493.858ZM235.891 438.999C229.906 428.526 232.899 413.565 243.87 401.596C247.86 400.1 251.85 398.604 255.839 398.105C243.87 408.079 238.883 423.041 245.366 433.514C249.356 440.994 257.834 444.485 267.808 444.485C272.297 444.485 276.785 443.488 281.772 441.992C278.78 444.984 275.788 447.976 272.297 450.47C256.338 454.459 241.875 449.971 235.891 438.999ZM219.433 421.046L228.41 423.041C228.41 424.038 228.41 425.035 228.41 425.534H217.937C218.436 424.038 218.935 422.542 219.433 421.046ZM272.796 278.414C276.287 281.406 279.279 283.9 282.271 286.892C267.31 281.406 252.348 284.897 246.364 295.37C240.379 305.843 244.868 320.805 256.837 330.779C252.847 329.781 248.857 328.784 244.868 327.288C233.896 314.82 230.405 300.357 236.888 289.884C241.875 279.411 256.338 274.923 272.796 278.414ZM290.749 235.525C301.222 229.54 316.184 232.533 328.153 243.504C329.649 247.494 331.145 251.484 331.644 255.473C321.669 243.504 306.708 238.517 296.235 245C290.251 248.491 286.261 254.975 285.263 263.453C284.765 268.939 285.762 274.923 287.757 280.908C284.765 277.915 281.772 274.923 279.279 271.432C275.289 255.972 279.778 241.509 290.749 235.525ZM320.672 228.044C322.168 230.538 323.166 232.533 324.163 235.026C322.168 233.53 319.675 232.533 317.68 231.535L319.675 226.548C320.173 227.047 320.173 227.545 320.672 228.044ZM316.184 222.558L313.69 230.039C312.693 229.54 311.695 229.54 311.196 229.042L313.191 220.563C314.189 221.561 315.186 222.06 316.184 222.558ZM365.057 215.576C377.525 215.576 388.497 225.551 393.484 241.509C392.985 245.998 391.988 249.987 390.492 253.977C387.499 238.517 377.525 227.047 365.057 227.047C352.59 227.047 342.615 238.517 339.623 253.977C338.626 249.987 337.628 245.998 336.631 241.509C341.618 226.049 352.59 215.576 365.057 215.576ZM439.365 235.525C449.838 241.509 454.327 255.972 450.836 271.931C447.844 275.422 445.35 278.414 442.358 281.406C444.353 275.422 445.35 269.437 444.851 263.951C443.854 255.473 439.864 248.99 433.88 245.499C427.895 242.008 419.916 242.008 412.435 245.499C407.448 247.993 402.461 251.484 398.471 256.471C399.469 252.481 400.466 248.491 401.962 244.502C414.43 232.533 428.893 229.54 439.365 235.525ZM494.224 290.383C500.208 300.856 497.216 315.817 486.244 327.787C482.255 329.283 478.265 330.779 474.275 331.278C478.764 327.288 482.753 322.301 485.247 317.314C488.738 309.334 488.738 301.854 485.247 295.869C481.756 289.884 475.273 285.895 466.795 284.897C461.309 284.399 455.324 285.396 449.34 287.391C452.332 284.399 455.324 281.406 458.815 278.913C473.777 274.923 487.741 279.411 494.224 290.383ZM510.681 308.337L501.705 306.342C501.705 305.345 501.705 304.347 501.705 303.848H512.177C511.679 304.846 511.18 306.841 510.681 308.337ZM507.19 315.817L499.71 313.324C500.208 312.327 500.208 311.329 500.707 310.83L509.185 312.825C508.188 313.823 507.689 314.82 507.19 315.817ZM512.676 298.861H501.705C501.705 297.864 501.705 297.365 501.206 296.368L512.676 293.375C512.676 295.37 512.676 296.866 512.676 298.861ZM514.172 364.691C514.172 377.159 504.198 388.131 488.239 393.118C483.751 392.619 479.761 391.622 475.771 390.126C491.232 387.133 502.702 377.159 502.702 364.691C502.702 352.223 491.232 342.249 475.771 339.257C479.761 338.26 483.751 337.262 488.239 336.265C503.699 341.252 514.172 352.223 514.172 364.691ZM394.98 505.328C394.98 505.827 394.98 506.824 394.98 507.323L390.99 503.832C392.487 501.837 393.484 499.842 394.98 497.349C394.98 499.842 394.98 502.336 394.98 505.328ZM215.942 364.691C215.942 352.223 225.917 341.252 241.875 336.265C246.364 336.763 250.354 337.761 254.343 339.257C238.883 342.249 227.413 352.223 227.413 364.691C227.413 377.159 238.883 387.133 254.343 390.126C250.354 391.123 246.364 392.12 241.875 393.118C226.415 388.131 215.942 377.159 215.942 364.691ZM335.135 224.054C335.135 223.556 335.135 222.558 335.135 222.06L339.124 225.551C337.628 227.545 336.631 229.54 335.135 232.034C335.135 229.54 335.135 227.047 335.135 224.054ZM469.787 343.247C485.746 344.244 498.214 353.221 498.214 364.691C498.214 376.162 485.746 385.637 469.787 386.136C471.283 379.154 471.782 372.172 471.782 364.691C471.782 357.211 471.283 350.229 469.787 343.247ZM467.293 364.691C467.293 421.046 421.412 466.927 365.057 466.927C308.703 466.927 262.821 421.046 262.821 364.691C262.821 308.337 308.703 262.455 365.057 262.455C421.412 262.455 467.293 308.337 467.293 364.691ZM260.328 386.136C244.369 385.138 231.901 376.162 231.901 364.691C231.901 353.221 244.369 343.745 260.328 343.247C258.832 350.229 258.333 357.211 258.333 364.691C258.333 372.172 258.832 379.154 260.328 386.136ZM444.851 293.874C451.335 290.383 458.815 288.887 465.299 289.884C472.281 290.383 477.766 293.874 480.26 298.363C483.252 303.35 483.252 309.334 480.26 315.817C477.766 321.802 472.779 327.288 466.296 331.278C461.808 317.314 454.327 304.347 444.851 293.874ZM435.875 284.897C424.903 275.422 412.435 267.941 398.471 263.453C402.461 256.969 407.947 252.481 413.931 249.489C420.414 246.496 426.399 246.496 431.386 249.489C436.373 252.481 439.365 257.468 439.864 264.45C440.862 270.933 439.366 278.414 435.875 284.897ZM365.057 257.967C357.577 257.967 350.595 258.964 343.613 259.962C344.61 244.003 353.587 231.535 365.057 231.535C376.528 231.535 386.003 244.003 386.502 259.962C379.52 258.466 372.538 257.967 365.057 257.967ZM294.24 284.897C290.749 278.414 289.253 270.933 290.251 264.45C290.749 257.468 294.24 251.982 298.729 249.489C308.703 244.003 323.166 249.987 331.644 263.453C317.68 267.941 304.713 275.422 294.24 284.897ZM263.819 331.278C250.354 322.799 244.369 308.337 249.855 298.363C255.341 288.388 271.299 286.892 285.263 293.874C275.788 304.347 268.307 317.314 263.819 331.278ZM285.263 435.508C271.299 442.49 255.341 440.994 249.855 431.02C244.369 421.046 250.354 406.583 263.819 398.105C268.307 412.069 275.788 425.035 285.263 435.508ZM294.24 444.485C305.212 453.961 317.68 461.441 331.644 465.93C323.166 479.395 308.703 485.38 298.729 479.894C288.754 473.909 286.76 458.449 294.24 444.485ZM365.057 471.416C372.538 471.416 379.52 470.418 386.502 469.421C385.505 485.38 376.528 497.847 365.057 497.847C353.587 497.847 344.111 485.38 343.613 469.421C350.595 470.917 357.577 471.416 365.057 471.416ZM435.875 444.485C442.856 458.449 441.36 474.408 431.386 479.894C421.412 485.38 406.949 479.395 398.471 465.93C412.435 461.441 425.402 453.961 435.875 444.485ZM466.296 398.105C479.761 406.583 485.746 421.046 480.26 431.02C477.268 436.007 472.281 438.999 465.299 439.498C458.815 439.997 451.833 438.501 444.851 435.508C454.327 425.035 461.808 412.069 466.296 398.105ZM477.268 273.427L478.764 265.946C480.26 265.946 481.257 265.946 482.255 265.946L479.761 273.926C478.764 273.926 477.766 273.926 477.268 273.427ZM472.28 272.928C469.787 272.928 467.293 272.43 464.8 272.928C466.795 271.432 469.288 269.936 471.283 268.939C471.782 268.44 472.281 268.44 472.779 267.941L472.28 272.928ZM456.82 257.468L461.808 256.471C461.309 256.969 461.309 257.468 460.81 257.967C459.314 260.46 458.317 262.455 456.82 264.45C456.82 261.957 456.82 259.463 456.82 257.468ZM463.802 251.484L456.322 252.98C456.322 251.982 455.823 250.985 455.823 250.486L463.802 247.993C463.802 248.99 463.802 249.987 463.802 251.484ZM416.425 230.039L413.931 222.558C414.929 222.06 415.926 221.561 417.422 221.062L418.918 229.042C418.42 229.042 417.422 229.54 416.425 230.039ZM409.443 228.044C409.941 227.545 409.941 227.047 410.44 226.548L412.435 231.535C410.44 232.533 407.947 233.53 405.952 235.026C406.949 232.533 407.947 230.538 409.443 228.044ZM394.98 224.054C394.98 226.548 394.98 229.54 394.481 232.034C393.484 229.54 391.988 227.545 390.492 225.551L394.481 222.06C394.98 223.057 394.98 223.556 394.98 224.054ZM393.983 217.072L387.998 222.06C387.499 221.561 387.001 220.563 386.003 220.065L391.988 214.08C392.487 215.078 392.985 216.075 393.983 217.072ZM342.117 222.06L336.132 217.072C336.631 216.075 337.628 215.078 338.127 214.08L344.111 220.065C343.613 220.563 342.615 221.561 342.117 222.06ZM273.793 252.481L266.312 250.985C266.312 249.489 266.312 248.491 266.312 247.494L274.292 249.987C274.292 250.985 274.292 251.982 273.793 252.481ZM273.294 257.468C273.294 259.962 272.796 262.455 273.294 264.949C271.798 262.954 270.302 260.46 269.305 258.466C268.806 257.967 268.806 257.468 268.307 256.969L273.294 257.468ZM257.834 272.928L256.837 267.941C257.336 268.44 257.834 268.44 258.333 268.939C260.827 270.435 262.821 271.432 264.816 272.928C262.323 272.43 259.829 272.928 257.834 272.928ZM251.85 265.946L253.346 273.427C252.348 273.427 251.351 273.926 250.852 273.926L248.359 265.946C249.356 265.946 250.354 265.946 251.85 265.946ZM228.41 298.861H217.439C217.439 296.866 217.439 295.37 217.439 293.375L228.909 296.368C228.909 296.866 228.41 297.864 228.41 298.861ZM217.937 303.35H228.41C228.41 304.347 228.41 305.345 228.41 305.843L219.433 308.337C218.935 306.841 218.436 304.846 217.937 303.35ZM229.408 310.332C229.408 311.329 229.906 312.326 230.405 312.825L222.924 315.319C222.426 314.321 221.927 313.324 221.428 311.828L229.408 310.332ZM231.901 317.314C232.899 319.308 233.896 321.802 235.392 323.797C232.899 322.799 230.904 321.303 228.41 320.306C227.911 319.807 227.413 319.807 226.914 319.308L231.901 317.314ZM225.917 338.758L222.426 334.769C222.924 334.769 223.922 334.769 224.421 334.769C226.914 334.769 229.906 334.769 232.4 335.267C230.405 336.265 227.911 337.761 225.917 338.758ZM217.439 335.766L222.426 341.75C221.927 342.249 220.93 342.748 220.431 343.745L214.446 337.761C215.444 337.262 216.441 336.763 217.439 335.766ZM222.426 387.632L217.439 393.617C216.441 393.118 215.444 392.12 214.446 391.622L220.431 385.637C220.93 386.136 221.927 387.133 222.426 387.632ZM225.917 390.624C227.911 392.12 229.906 393.118 232.4 394.614C229.906 394.614 227.413 395.113 224.421 395.113C223.922 395.113 222.924 395.113 222.426 395.113L225.917 390.624ZM231.901 412.069L226.914 410.074C227.413 409.575 227.911 409.575 228.41 409.077C230.904 407.581 232.899 406.583 235.392 405.586C233.896 407.581 232.899 409.575 231.901 412.069ZM222.924 413.565L230.405 416.059C229.906 417.056 229.408 418.053 229.408 418.552L220.93 416.557C221.927 415.56 222.426 414.562 222.924 413.565ZM217.439 430.521H228.41C228.41 431.519 228.41 432.017 228.909 433.015L217.439 436.007C216.94 434.012 216.94 432.017 217.439 430.521ZM252.847 455.956L251.85 463.436C250.354 463.436 249.356 463.436 248.359 463.436L250.852 455.457C251.351 455.457 252.348 455.457 252.847 455.956ZM257.834 456.454C259.33 456.454 260.827 456.454 262.323 456.454C263.32 456.454 264.318 456.454 265.315 456.454C263.32 457.95 260.827 459.447 258.832 460.444C258.333 460.943 257.834 460.943 257.336 461.441L257.834 456.454ZM273.294 471.914L268.307 472.912C268.806 472.413 268.806 471.914 269.305 471.416C270.801 468.922 271.798 466.927 273.294 464.932C272.796 467.426 273.294 469.92 273.294 471.914ZM266.312 477.899L273.793 476.403C273.793 477.4 274.292 478.398 274.292 478.896L266.312 481.39C266.312 480.392 266.312 479.395 266.312 477.899ZM313.69 499.344L316.184 506.824C315.186 507.323 314.189 507.822 312.693 508.32L310.698 499.842C311.695 499.842 312.693 499.842 313.69 499.344ZM320.672 501.338C320.173 501.837 320.173 502.336 319.675 502.835L317.68 497.847C319.675 496.85 322.168 495.853 324.163 494.356C323.166 496.351 322.168 498.845 320.672 501.338ZM335.135 505.328C335.135 502.835 335.135 499.842 335.633 497.349C336.631 499.842 338.127 501.837 339.623 503.832L335.633 507.323C335.135 506.326 335.135 505.827 335.135 505.328ZM336.132 512.31L342.117 507.323C342.615 507.822 343.114 508.819 344.111 509.318L338.127 515.302C337.628 514.305 337.129 513.307 336.132 512.31ZM387.998 507.323L393.983 512.31C393.484 513.307 392.487 514.305 391.988 515.302L386.003 509.318C386.502 508.32 387.499 507.822 387.998 507.323ZM456.322 476.901L463.802 478.398C463.802 479.894 463.802 480.891 463.802 481.889L455.823 479.395C455.823 478.398 455.823 477.4 456.322 476.901ZM456.82 471.914C456.82 469.421 457.319 466.927 456.82 464.434C458.317 466.429 459.813 468.922 460.81 470.917C461.309 471.416 461.309 471.914 461.808 472.413L456.82 471.914ZM472.28 456.454L473.278 461.441C472.779 460.943 472.28 460.943 471.782 460.444C469.288 458.948 467.293 457.95 465.299 456.454C466.296 456.454 467.293 456.454 468.291 456.454C469.288 456.454 470.784 456.454 472.28 456.454ZM478.265 463.436L476.769 455.956C477.766 455.956 478.764 455.457 479.262 455.457L481.756 463.436C480.759 463.436 479.761 463.436 478.265 463.436ZM501.705 430.521H512.676C512.676 432.516 512.676 434.012 512.676 436.007L501.206 433.015C501.206 432.017 501.705 431.519 501.705 430.521ZM512.177 426.033H501.705C501.705 425.035 501.705 424.038 501.705 423.539L510.681 421.544C511.18 422.542 511.679 424.038 512.177 426.033ZM500.707 418.552C500.707 417.555 500.208 416.557 499.71 416.059L507.19 413.565C507.689 414.562 508.188 415.56 508.686 417.056L500.707 418.552ZM498.214 412.069C497.216 410.074 496.219 407.581 494.723 405.586C497.216 406.583 499.211 408.079 501.705 409.077C502.203 409.575 502.702 409.575 503.201 410.074L498.214 412.069ZM504.198 390.624L507.689 394.614C507.19 394.614 506.193 394.614 505.694 394.614C503.201 394.614 500.208 394.614 497.715 394.115C499.71 393.118 502.203 391.622 504.198 390.624ZM512.676 393.617L507.689 387.632C508.188 387.133 509.185 386.635 509.684 385.637L515.668 391.622C514.671 392.12 513.674 392.619 512.676 393.617ZM507.689 341.75L512.676 335.766C513.674 336.265 514.671 337.262 515.668 337.761L509.684 343.745C508.686 343.247 508.188 342.249 507.689 341.75ZM503.699 338.758C501.705 337.262 499.71 336.265 497.216 334.769C499.71 334.769 502.203 334.27 505.196 334.27C505.694 334.27 506.692 334.27 507.19 334.27L503.699 338.758ZM498.214 317.314L503.201 319.308C502.702 319.807 502.203 319.807 501.705 320.306C499.211 321.802 497.216 322.799 494.723 323.797C496.219 321.802 497.216 319.807 498.214 317.314ZM499.71 291.879C499.71 291.381 499.211 290.383 498.712 289.884L509.684 283.401C510.681 284.897 511.18 286.892 511.679 288.887L499.71 291.879ZM496.717 285.895C496.219 285.396 495.72 284.897 495.221 284.399L503.699 275.422C505.196 276.918 506.193 278.414 507.689 279.91L496.717 285.895ZM492.229 280.908C491.73 280.409 491.232 279.91 490.234 279.411L495.72 269.437C497.216 270.435 498.712 270.933 500.208 271.931L492.229 280.908ZM486.743 276.918C485.746 276.419 485.247 275.921 484.25 275.921L486.743 266.944C488.239 267.442 489.735 267.442 491.232 267.941L486.743 276.918ZM453.828 245.499C453.329 244.502 453.329 244.003 452.831 243.005L461.808 238.018C462.306 239.514 462.805 241.011 462.805 242.507L453.828 245.499ZM450.337 239.514C449.838 239.016 449.34 238.018 448.841 237.52L457.319 229.54C458.317 231.036 459.314 232.533 459.813 234.029L450.337 239.514ZM445.35 234.029C444.851 233.53 444.353 233.031 443.854 232.533L450.337 221.561C451.833 222.558 453.329 224.054 454.826 225.551L445.35 234.029ZM439.864 230.538C439.365 230.039 438.368 230.039 437.869 229.54L440.862 217.571C442.856 218.07 444.353 218.569 446.347 219.566L439.864 230.538ZM433.381 228.543C432.384 228.543 431.885 228.044 430.887 228.044V217.072C432.882 217.072 434.378 217.072 436.373 217.072L433.381 228.543ZM426.399 217.571V228.044C425.402 228.044 424.404 228.044 423.905 228.044L421.412 219.067C422.908 218.569 424.404 218.07 426.399 217.571ZM382.512 217.072C382.014 216.574 381.016 216.075 380.517 215.576L386.003 206.6C387.001 207.597 388.497 208.594 389.494 210.09L382.512 217.072ZM376.029 213.581C375.53 213.083 374.533 213.083 373.535 212.584L377.026 201.114C378.523 202.111 380.019 202.61 381.515 204.106L376.029 213.581ZM369.546 211.587C369.047 211.587 368.05 211.587 367.551 211.088V198.121C369.546 198.121 371.541 198.62 373.037 199.119L369.546 211.587ZM362.564 211.088C362.065 211.088 361.068 211.088 360.569 211.587L357.078 199.618C359.073 199.119 360.569 198.62 362.564 198.62V211.088ZM352.59 201.114L356.081 212.584C355.083 213.083 354.584 213.083 354.086 213.581L348.101 204.106C349.597 202.61 351.093 202.111 352.59 201.114ZM344.61 206.6L350.096 215.576C349.597 216.075 348.6 216.574 348.101 217.072L341.618 210.09C342.117 209.093 343.114 208.096 344.61 206.6ZM306.209 228.044C305.212 228.044 304.214 228.044 303.716 228.044V217.571C305.212 218.07 306.708 218.569 308.204 219.067L306.209 228.044ZM299.227 228.044C298.23 228.044 297.731 228.044 296.734 228.543L293.742 217.072C295.736 217.072 297.233 217.072 299.227 217.072V228.044ZM289.253 217.571L292.245 229.54C291.747 229.54 290.749 230.039 290.251 230.538L283.767 219.566C285.762 218.569 287.258 218.07 289.253 217.571ZM279.778 221.561L286.261 232.533C285.762 233.031 285.263 233.53 284.765 234.029L275.788 225.551C276.785 224.054 278.281 223.057 279.778 221.561ZM272.796 229.042L281.274 237.021C280.775 237.52 280.276 238.018 279.778 239.016L269.803 233.53C270.801 232.034 271.798 230.538 272.796 229.042ZM268.307 238.018L277.284 243.005C276.785 244.003 276.287 244.502 276.287 245.499L267.31 243.005C267.31 241.509 267.808 239.514 268.307 238.018ZM243.372 266.944L245.865 275.921C244.868 276.419 244.369 276.419 243.372 276.918L238.384 267.941C240.379 267.442 241.875 266.944 243.372 266.944ZM234.395 269.437L239.881 279.411C239.382 279.91 238.384 280.409 237.886 280.908L229.408 272.43C230.904 271.432 232.4 270.435 234.395 269.437ZM225.917 275.422L234.395 284.399C233.896 284.897 233.397 285.396 232.899 285.895L221.927 279.411C223.423 277.915 224.421 276.419 225.917 275.422ZM219.932 283.401L230.904 289.884C230.405 290.383 230.405 291.381 229.906 291.879L217.937 288.887C218.436 286.892 218.935 285.396 219.932 283.401ZM210.457 340.753L217.439 347.236C216.94 347.735 216.441 348.732 215.942 349.231L206.966 343.745C208.462 342.748 209.459 341.751 210.457 340.753ZM204.472 347.735L213.948 353.72C213.449 354.218 213.449 355.216 212.95 356.213L201.48 352.722C202.477 350.727 202.976 349.231 204.472 347.735ZM199.984 356.712L211.953 360.203C211.953 360.702 211.953 361.699 211.454 362.198H198.487C198.986 360.203 199.485 358.707 199.984 356.712ZM211.454 367.185C211.454 367.684 211.454 368.681 211.953 369.18L199.984 372.671C199.485 370.676 198.986 369.18 198.986 367.185H211.454ZM212.95 373.668C213.449 374.666 213.449 375.164 213.948 375.663L204.472 381.647C203.475 380.151 202.477 378.655 201.978 377.159L212.95 373.668ZM215.942 380.151C216.441 380.65 216.94 381.647 217.439 382.146L210.457 388.629C208.96 387.632 207.963 386.635 206.966 385.138L215.942 380.151ZM229.906 437.503C229.906 438.002 230.405 438.999 230.904 439.498L219.932 445.981C218.935 444.485 218.436 442.49 217.937 440.496L229.906 437.503ZM233.397 443.488C233.896 443.987 234.395 444.485 234.395 444.984L225.917 453.961C224.421 452.465 223.423 450.968 221.927 449.472L233.397 443.488ZM237.886 448.475C238.384 448.974 238.883 449.472 239.881 449.971L234.395 459.945C232.899 458.948 231.402 458.449 229.906 457.452L237.886 448.475ZM243.372 452.465C244.369 452.963 244.868 453.462 245.865 453.462L243.372 462.439C241.875 461.94 240.379 461.94 238.883 461.441L243.372 452.465ZM276.287 483.883C276.785 484.881 276.785 485.38 277.284 486.377L268.307 491.364C267.808 489.868 267.31 488.372 267.31 486.876L276.287 483.883ZM279.778 489.868C280.276 490.367 280.775 491.364 281.274 491.863L272.796 499.842C271.798 498.346 270.801 496.85 270.302 495.354L279.778 489.868ZM284.765 495.354C285.263 495.853 285.762 496.351 286.261 496.85L279.778 507.822C278.281 506.824 276.785 505.328 275.289 503.832L284.765 495.354ZM290.251 498.845C290.749 499.344 291.747 499.344 292.245 499.842L289.253 511.811C287.258 511.313 285.762 510.814 283.767 509.817L290.251 498.845ZM296.734 500.84C297.731 500.84 298.23 501.338 299.227 501.338V512.31C297.233 512.31 295.736 512.31 293.742 512.31L296.734 500.84ZM303.716 511.811V501.338C304.713 501.338 305.711 501.338 306.209 501.338L308.204 510.315C307.207 510.814 305.212 511.313 303.716 511.811ZM347.602 512.31C348.101 512.809 349.099 513.307 349.597 513.806L344.111 522.783C343.114 521.786 341.618 520.788 340.62 519.292L347.602 512.31ZM354.086 515.801C354.584 516.3 355.582 516.3 356.579 516.798L353.088 528.269C351.592 527.271 350.096 526.773 348.6 525.277L354.086 515.801ZM360.569 517.796C361.068 517.796 362.065 517.796 362.564 518.295V531.261C360.569 531.261 358.574 530.762 357.078 530.264L360.569 517.796ZM367.551 518.295C368.05 518.295 369.047 518.295 369.546 517.796L373.037 529.765C371.042 530.264 369.546 530.762 367.551 530.762V518.295ZM377.525 528.269L374.034 516.798C375.032 516.3 375.53 516.3 376.029 515.801L381.515 525.277C380.517 526.274 379.021 527.271 377.525 528.269ZM385.505 522.284L380.019 513.307C380.517 512.809 381.515 512.31 382.014 511.811L388.497 518.793C387.998 520.289 386.502 521.287 385.505 522.284ZM423.905 501.338C424.903 501.338 425.9 501.338 426.399 501.338V511.811C424.903 511.313 423.407 510.814 421.911 510.315L423.905 501.338ZM430.887 501.338C431.885 501.338 432.384 501.338 433.381 500.84L436.373 512.31C434.378 512.31 432.882 512.31 430.887 512.31V501.338ZM440.862 511.811L437.869 499.842C438.368 499.842 439.365 499.344 439.864 498.845L446.347 509.817C444.353 510.814 442.856 511.313 440.862 511.811ZM450.337 507.323L443.854 496.351C444.353 495.853 444.851 495.354 445.35 494.855L454.327 503.333C453.329 505.328 451.833 506.326 450.337 507.323ZM457.319 500.341L448.841 491.863C449.34 491.364 449.838 490.865 450.337 489.868L460.311 495.354C459.314 497.349 458.317 498.845 457.319 500.341ZM461.808 490.865L452.831 485.878C453.329 484.881 453.828 484.382 453.828 483.385L462.805 485.878C462.805 487.873 462.306 489.369 461.808 490.865ZM486.743 462.439L484.25 453.462C485.247 452.963 485.746 452.963 486.743 452.465L491.73 461.441C489.735 461.94 488.239 462.439 486.743 462.439ZM495.72 459.945L490.234 449.971C490.733 449.472 491.73 448.974 492.229 448.475L500.208 456.953C499.211 457.95 497.715 458.948 495.72 459.945ZM504.198 453.961L495.72 444.984C496.219 444.485 496.717 443.987 497.216 443.488L508.188 449.971C506.692 451.467 505.694 452.963 504.198 453.961ZM510.183 445.981L499.211 439.498C499.71 438.999 499.71 438.002 500.208 437.503L512.177 440.496C511.679 442.49 511.18 443.987 510.183 445.981ZM519.159 388.629L512.177 382.146C512.676 381.647 513.175 380.65 513.674 380.151L522.65 385.637C521.653 386.136 520.656 387.632 519.159 388.629ZM525.643 381.647L516.167 375.663C516.666 375.164 516.666 374.167 517.165 373.169L528.635 376.66C527.638 378.655 526.64 380.151 525.643 381.647ZM530.131 372.671L518.162 369.18C518.162 368.681 518.162 367.684 518.661 367.185H531.627C531.129 368.681 530.63 370.676 530.131 372.671ZM518.661 362.198C518.661 361.699 518.661 360.702 518.162 360.203L530.131 356.712C530.63 358.707 531.129 360.203 531.129 362.198H518.661ZM517.165 355.714C516.666 354.717 516.666 354.218 516.167 353.72L525.643 348.234C526.64 349.73 527.638 351.226 528.136 352.722L517.165 355.714ZM514.172 349.231C513.674 348.732 513.175 347.735 512.676 347.236L519.658 340.753C521.154 341.751 522.152 342.748 523.149 344.244L514.172 349.231ZM505.196 330.28C499.71 330.28 494.224 330.779 489.237 331.278C494.224 329.283 498.712 326.789 503.699 324.296C515.668 317.314 523.149 306.841 528.136 296.368C534.121 294.872 540.105 295.869 545.093 298.861C550.08 301.854 554.069 306.841 555.565 312.825C557.062 318.81 556.064 324.794 552.573 330.28C549.581 335.766 544.095 339.257 538.609 340.753C529.632 334.769 518.661 330.28 505.196 330.28ZM531.129 275.422C528.136 284.897 524.147 297.864 515.668 308.337C519.159 297.864 518.162 287.89 513.175 278.913C508.188 270.435 499.71 264.45 489.237 262.455C502.702 260.46 515.668 262.954 525.643 265.448C529.134 266.445 532.126 266.944 534.121 266.944C533.123 269.437 532.126 271.931 531.129 275.422ZM516.167 258.964C514.671 258.964 513.175 258.466 511.679 258.466C515.17 253.478 517.165 247.993 517.165 241.509C517.165 233.53 514.671 225.551 509.185 220.065C503.699 214.579 496.219 211.088 488.239 211.088C481.756 211.088 476.27 213.083 471.283 216.574C470.784 215.078 470.784 213.083 470.286 211.587C470.286 211.587 470.784 211.587 470.784 211.088C483.751 203.607 500.707 206.101 511.18 216.574C521.653 227.047 524.147 243.504 517.165 256.471C517.165 257.468 516.666 257.967 516.167 258.964ZM464.301 204.605C466.296 214.08 469.288 227.545 467.293 241.011C464.8 230.538 459.314 221.561 450.836 217.072C442.358 212.085 431.885 211.587 421.412 214.579C431.885 206.101 444.851 202.111 454.327 199.119C457.818 198.121 460.81 197.124 462.805 196.127C462.805 198.121 463.304 200.615 464.301 204.605ZM442.857 197.623C441.36 198.121 440.363 198.62 438.867 199.119C440.363 185.155 431.386 171.191 417.422 167.201C409.941 165.206 401.962 166.204 394.98 169.695C389.494 172.687 385.505 177.175 382.512 182.661C381.515 181.165 380.517 180.168 379.52 178.672C379.52 178.672 379.52 178.173 380.019 178.173C387.499 165.206 403.458 158.723 417.921 162.713C432.384 166.703 442.358 179.669 442.857 194.132C442.857 195.628 442.857 196.625 442.857 197.623ZM240.878 262.455C229.906 264.949 221.428 270.435 216.94 278.913C211.953 287.391 211.454 297.864 214.446 308.337C205.968 297.864 201.978 284.897 198.986 275.422C197.989 271.931 196.991 268.939 195.994 266.944C198.487 266.445 200.981 265.946 204.472 265.448C214.446 263.453 227.413 260.46 240.878 262.455ZM206.467 338.26C198.487 345.74 193.999 354.717 193.999 364.691C193.999 374.665 198.487 383.642 206.467 391.123C193.5 386.136 183.526 377.159 176.544 370.676C174.051 368.182 171.557 366.187 170.061 364.691C172.056 363.195 174.051 361.2 176.544 358.707C184.025 352.223 193.999 343.247 206.467 338.26ZM198.986 453.961C201.978 444.485 205.968 431.519 214.446 421.046C210.955 431.519 211.953 441.493 216.94 450.47C221.927 458.948 230.405 464.932 240.878 466.927C227.413 468.922 214.446 466.429 204.472 463.935C200.981 462.938 197.989 462.439 195.994 462.439C196.991 459.945 197.989 457.452 198.986 453.961ZM213.948 470.418C215.444 470.418 216.94 470.917 218.436 470.917C214.945 475.904 212.95 481.39 212.95 487.873C212.95 495.853 215.444 503.832 220.93 509.318C226.415 514.804 233.896 518.295 241.875 518.295H242.374C248.359 518.295 254.343 516.3 259.33 512.809C259.829 514.305 259.829 516.3 260.328 517.796C260.328 517.796 259.829 517.796 259.829 518.295C246.863 525.775 229.906 523.282 219.433 512.809C208.96 502.336 206.467 485.878 213.449 472.912C212.95 471.914 213.449 471.416 213.948 470.418ZM265.814 524.778C263.819 515.302 260.827 501.837 262.821 488.372C265.315 498.845 270.801 507.822 279.279 512.31C284.266 515.302 289.752 516.798 295.736 516.798C299.726 516.798 304.214 516.3 308.204 514.804C297.731 523.282 284.765 527.271 275.289 530.264C271.798 531.261 268.806 532.259 266.811 533.256C267.31 531.261 266.312 528.269 265.814 524.778ZM287.258 531.76C288.754 531.261 289.752 530.762 291.248 530.264C289.752 544.228 298.729 558.192 312.693 562.181C315.186 563.179 318.178 563.179 320.672 563.179C332.142 563.179 342.615 556.695 347.602 546.222C348.6 547.719 349.597 548.716 350.595 550.212C350.595 550.212 350.595 550.711 350.096 550.711C342.615 563.677 326.657 570.161 312.194 566.171C297.731 562.181 287.757 549.215 287.258 534.752C286.76 533.755 287.258 532.757 287.258 531.76ZM489.237 466.927C499.71 464.434 508.188 458.948 513.175 450.47C518.162 441.992 518.661 431.519 515.668 421.046C524.147 431.519 528.136 444.485 531.129 453.961C532.126 457.452 533.123 460.444 534.121 462.439C531.627 462.938 529.134 463.436 525.643 463.935C515.668 465.93 502.702 468.922 489.237 466.927ZM523.648 391.123C531.627 383.642 536.116 374.665 536.116 364.691C536.116 354.717 531.627 345.74 523.648 338.26C536.614 343.247 546.589 352.223 553.571 358.707C556.064 361.2 558.558 363.195 560.054 364.691C558.059 366.187 556.064 368.182 553.571 370.676C546.09 377.159 536.116 386.136 523.648 391.123ZM613.416 252.481C610.424 252.98 605.437 252.98 599.452 252.98C590.974 252.98 579.504 252.98 567.535 254.476C578.506 250.486 587.982 248.491 595.462 246.496C602.943 244.502 608.429 243.005 612.419 241.509C613.416 245 613.915 248.99 613.416 252.481ZM590.475 290.383C589.478 289.386 588.48 288.388 587.483 287.391C579.504 279.411 570.028 270.435 559.056 264.949C570.527 267.442 580.501 274.424 588.48 279.91C591.971 282.404 594.465 284.399 597.457 285.895C595.462 287.391 593.966 288.887 591.971 289.884C591.473 289.884 590.974 289.884 590.475 290.383ZM600.948 282.404C597.956 280.908 594.964 278.913 590.974 275.921C584.99 271.432 578.008 266.445 569.529 263.453C579.504 264.949 588.979 267.941 596.46 270.435C600.948 271.931 604.439 272.928 607.432 273.926C605.437 276.918 603.442 279.91 600.948 282.404ZM609.426 269.437C606.434 268.939 602.444 267.442 597.956 265.946C590.475 263.453 581.498 260.46 571.026 258.466C581.997 257.468 591.971 257.468 599.452 257.468C604.938 257.468 609.426 257.468 612.917 256.969C612.917 258.466 612.419 259.463 612.419 260.959C611.92 264.45 610.922 266.944 609.426 269.437ZM594.465 242.008C587.483 243.504 579.504 245.499 570.028 248.99L607.93 227.545C609.426 230.538 610.922 234.029 611.92 237.021C608.429 238.517 602.444 240.013 594.465 242.008ZM569.031 244.003C576.013 237.52 581.498 232.034 585.987 227.047C591.473 221.561 595.462 217.072 598.953 215.078C601.447 217.571 603.442 220.065 605.437 223.057L569.031 244.003ZM582.995 224.054C577.509 229.54 570.527 236.522 562.049 244.502C569.529 234.527 575.015 225.052 579.504 217.571C582.496 212.584 584.989 208.096 586.984 205.602C590.475 207.098 593.468 209.592 596.46 212.085C591.971 214.579 587.982 218.569 582.995 224.054ZM575.015 215.078C571.026 222.06 566.038 230.538 560.054 239.016C564.044 229.54 565.54 219.566 567.036 212.085C568.033 207.098 569.031 203.109 570.028 200.116C573.02 200.615 575.514 201.114 578.506 201.612C580.002 202.111 581 202.61 582.496 203.109C580.002 206.101 578.008 210.09 575.015 215.078ZM562.547 211.587C561.051 219.067 559.056 229.042 555.565 238.517C556.563 229.54 556.064 221.062 555.067 213.581C554.568 209.093 554.069 205.103 554.568 201.612C558.059 200.615 561.55 200.116 565.041 200.116C564.044 203.109 563.545 207.098 562.547 211.587ZM550.08 203.109C550.08 206.101 550.578 210.09 550.578 214.08C551.576 224.054 552.573 237.021 548.085 248.491C549.581 236.024 546.09 222.558 543.098 211.088C542.599 209.592 542.599 208.096 542.1 207.098C542.599 207.098 542.599 206.6 543.098 206.6C545.591 204.605 547.586 203.607 550.08 203.109ZM519.159 186.152C508.188 183.659 495.221 180.168 483.252 181.165C494.224 177.175 506.193 178.672 516.167 179.17C520.157 179.669 523.648 179.669 526.64 179.669C525.643 181.664 525.144 184.157 523.648 186.152C523.648 186.651 523.149 186.651 523.149 187.15C521.653 187.15 520.157 186.651 519.159 186.152ZM528.136 175.181C525.144 175.181 521.154 175.181 516.666 174.682C509.185 174.183 500.707 173.186 491.73 174.183C501.206 170.194 510.681 168.199 518.661 167.201C523.149 166.204 526.64 165.705 529.632 164.708C529.632 168.199 529.134 172.188 528.136 175.181ZM517.663 162.713C510.183 164.209 500.208 166.204 490.733 169.695C499.71 163.212 508.188 158.224 514.671 154.733C519.658 151.741 523.648 149.746 526.141 147.751C527.638 151.741 528.635 155.731 529.134 160.219C526.64 161.217 522.152 161.715 517.663 162.713ZM512.676 150.744C505.196 155.232 495.72 160.718 485.746 168.199C493.226 159.222 500.208 152.739 506.193 147.253C511.679 141.767 515.668 137.777 518.661 134.286C521.154 137.279 523.149 140.271 525.144 143.762C522.152 145.258 517.663 147.751 512.676 150.744ZM481.756 158.224C484.748 149.248 486.743 141.767 488.239 135.284C490.234 127.803 491.73 121.818 493.725 118.327C496.717 119.325 500.208 120.322 503.201 122.317L481.756 158.224ZM483.252 133.788C481.257 141.268 478.764 150.744 475.273 161.715C476.769 149.248 476.769 138.276 476.769 129.798C476.769 123.813 476.769 118.826 477.268 115.834C480.759 115.834 484.748 115.834 488.738 116.831C486.743 120.821 485.247 126.806 483.252 133.788ZM472.28 130.297C472.28 138.276 472.281 147.751 471.283 158.723C469.787 148.25 466.795 139.273 463.802 131.793C462.306 127.304 460.81 123.315 460.311 120.322C464.301 118.826 468.291 117.33 472.28 116.831C472.28 119.824 472.28 124.312 472.28 130.297ZM456.322 122.317C456.82 125.309 458.317 128.8 459.813 133.289C462.306 140.77 465.299 149.746 466.795 160.219C463.304 152.24 458.317 144.759 454.327 138.775C451.833 134.785 449.34 131.793 447.844 128.8C450.337 126.307 452.831 123.813 456.322 122.317ZM444.353 132.291C445.849 134.785 447.844 137.777 450.337 141.268C456.322 149.746 463.802 160.219 465.299 172.188C460.311 160.718 450.337 150.245 442.358 142.266C441.36 141.268 440.363 140.271 439.365 139.273C439.365 138.775 439.864 138.276 439.864 138.276C441.36 135.782 442.856 134.286 444.353 132.291ZM409.443 133.289C398.97 136.281 385.505 139.772 376.029 146.754C384.008 137.777 394.98 132.79 403.458 128.8C406.949 127.304 410.44 125.808 412.934 123.813C413.432 126.307 413.432 128.302 413.432 130.795C413.432 131.294 413.432 131.793 413.432 131.793C411.936 132.291 410.44 132.79 409.443 133.289ZM401.463 124.312C394.98 127.304 387.001 131.294 380.019 136.281C386.502 128.302 393.983 121.818 399.469 116.831C402.96 113.839 405.952 111.345 407.947 109.351C409.941 112.343 410.939 115.834 411.936 119.325C408.944 120.821 405.453 122.816 401.463 124.312ZM396.476 113.34C390.492 118.327 383.011 124.811 376.528 132.79C381.016 122.816 386.003 114.338 389.993 107.356C392.985 102.369 394.98 98.8777 396.476 95.3867C399.967 97.8802 402.96 100.873 405.453 104.364C402.96 107.356 399.967 110.348 396.476 113.34ZM386.003 105.86C381.515 113.34 376.029 122.816 371.042 134.286C373.037 122.816 376.029 113.839 378.024 105.86C380.019 98.379 381.515 92.8931 382.014 88.4047C385.505 89.9008 388.996 91.397 391.988 93.3918C391.489 96.3841 388.996 100.374 386.003 105.86ZM362.564 127.803C360.569 118.826 358.574 110.847 356.579 104.364C354.584 96.8828 352.59 90.8983 352.59 86.9086C355.582 85.9112 359.073 85.4124 362.564 85.4124V127.803ZM348.101 88.4047C348.6 92.8931 350.096 98.379 352.091 105.86C354.086 113.34 357.078 122.816 359.073 134.286C354.086 122.816 348.6 113.34 344.111 105.86C341.119 100.873 338.626 96.3841 337.628 93.3918C341.119 91.397 344.61 89.4021 348.101 88.4047ZM334.137 95.8854C335.633 98.8777 337.628 102.867 340.62 107.854C344.61 114.338 349.597 123.315 354.086 133.289C347.602 125.309 340.122 118.826 334.137 113.839C330.646 110.847 327.155 107.854 325.16 105.361C327.654 101.87 330.646 98.8777 334.137 95.8854ZM322.667 109.351C324.662 111.844 327.654 114.338 331.145 117.33C337.129 122.317 344.61 128.8 350.595 136.78C343.613 131.294 335.633 127.803 329.15 124.811C325.16 122.816 321.171 121.32 318.677 119.325C319.675 115.335 320.672 112.343 322.667 109.351ZM316.682 130.795C316.682 128.302 317.181 125.808 317.181 123.813C319.675 125.309 323.166 126.806 326.657 128.8C336.132 133.289 347.602 138.276 355.083 148.25C345.109 140.77 331.644 136.78 320.173 133.788C318.677 133.289 317.68 132.79 316.184 132.79C316.682 131.793 316.682 131.294 316.682 130.795ZM287.757 142.266C279.778 150.245 270.801 159.721 265.315 170.692C267.808 159.222 274.79 149.248 280.276 141.268C282.77 137.777 284.765 135.284 286.261 132.291C287.757 134.286 289.253 135.782 290.251 137.777C290.251 138.276 290.749 138.276 290.749 138.775C289.752 140.271 288.754 141.268 287.757 142.266ZM276.287 138.775C271.798 144.759 266.811 151.741 263.819 160.219C265.315 150.245 268.307 140.77 270.801 133.289C272.297 128.8 273.294 125.309 274.292 122.317C277.284 124.312 280.276 126.307 282.77 128.8C281.274 131.294 279.279 134.785 276.287 138.775ZM266.312 131.793C263.819 139.273 260.827 148.25 258.832 158.723C257.834 147.751 257.834 137.777 257.834 130.297C257.834 124.811 257.834 120.322 257.336 116.831C258.832 116.831 259.829 117.33 261.325 117.33C264.318 117.829 266.811 118.826 269.305 120.322C269.305 122.816 268.307 126.806 266.312 131.793ZM252.847 115.834C253.346 118.826 253.346 123.813 253.346 129.798C253.346 138.276 253.346 149.746 254.842 161.715C250.852 150.744 248.857 141.268 246.863 133.788C244.868 126.307 243.372 120.821 241.875 116.831C245.366 116.333 249.356 115.834 252.847 115.834ZM237.387 117.829C239.382 121.32 240.878 127.304 242.873 134.785C244.369 141.767 246.364 149.746 249.855 159.222L228.41 121.32C230.405 120.322 233.896 118.826 237.387 117.829ZM223.423 123.813L244.369 160.219C237.886 153.237 232.4 147.751 227.413 143.263C221.927 137.777 217.439 133.788 215.444 130.297C217.937 127.803 220.431 125.808 223.423 123.813ZM212.451 133.788C214.945 137.279 219.433 141.767 224.421 146.754C229.906 152.24 236.888 159.222 244.868 167.7C234.893 160.219 225.418 154.733 217.937 150.245C212.95 147.253 208.462 144.759 205.968 142.764C207.464 139.772 209.958 136.78 212.451 133.788ZM202.477 151.242C202.976 149.746 203.475 148.749 203.973 147.253C206.467 149.248 210.457 151.741 215.444 154.235C222.426 158.224 230.904 163.212 239.382 169.196C229.906 165.206 219.932 163.71 212.451 162.214C207.464 161.217 203.475 160.219 200.482 159.222C200.981 157.227 201.48 154.235 202.477 151.242ZM211.953 167.201C219.433 168.697 229.408 170.692 238.883 174.183C229.906 173.186 221.428 173.684 213.948 174.682C209.459 175.181 205.469 175.679 201.978 175.181C200.981 171.69 200.482 168.199 200.482 164.708C203.475 165.705 207.464 166.204 211.953 167.201ZM206.467 186.152C205.469 184.157 204.472 181.664 203.475 179.669C206.467 179.669 210.457 179.17 214.446 179.17C224.421 178.173 237.387 177.175 248.857 181.664C236.39 180.168 222.924 183.659 211.454 186.651C209.958 187.15 208.462 187.15 207.464 187.648C206.966 187.15 206.467 186.651 206.467 186.152ZM117.197 241.011C121.187 243.005 127.172 244.502 134.154 245.998C141.634 247.993 151.11 250.486 162.081 253.977C149.614 252.481 138.642 252.481 130.164 252.481C124.179 252.481 119.192 252.481 116.2 251.982C116.2 248.491 116.699 245 117.197 241.011ZM186.518 210.589C184.025 221.561 180.534 234.527 181.531 246.496C177.542 235.525 179.038 223.556 179.536 213.581C180.035 209.592 180.035 206.101 180.035 203.109C182.03 204.106 184.524 204.605 186.518 206.101C187.017 206.101 187.017 206.6 187.516 206.6C187.516 208.096 187.017 209.093 186.518 210.589ZM175.547 201.612C175.547 204.605 175.547 208.594 175.048 213.083C174.549 220.563 173.552 229.042 174.549 238.018C170.56 228.543 168.565 219.067 167.567 211.088C166.57 206.6 166.071 203.109 165.074 200.116C168.565 200.116 172.554 200.615 175.547 201.612ZM160.585 200.116C161.583 203.109 162.58 207.098 163.578 211.587C165.074 219.067 167.069 229.042 170.56 238.517C164.076 229.54 159.089 221.062 155.598 214.579C152.606 209.592 150.611 205.602 148.616 203.109C152.107 201.612 156.097 200.615 160.585 200.116ZM143.629 205.103C145.624 207.597 148.118 211.587 151.11 217.072C155.598 224.553 161.084 234.029 168.565 244.003C159.588 236.522 153.105 229.54 147.619 223.556C142.133 218.07 138.143 214.08 134.652 211.088C137.146 209.093 140.637 207.098 143.629 205.103ZM130.663 215.078C134.154 217.072 138.143 221.561 143.629 227.047C148.616 232.034 154.102 238.018 161.583 244.502L124.678 223.057C126.174 220.065 128.668 217.571 130.663 215.078ZM122.185 227.047L158.59 247.993C149.614 245 142.133 243.005 135.65 241.509C128.169 239.515 122.185 238.018 118.694 236.024C119.192 233.031 120.688 230.039 122.185 227.047ZM130.663 257.468C138.642 257.468 148.118 257.468 159.089 258.466C148.616 259.962 139.639 262.954 132.159 265.946C127.67 267.442 123.681 268.939 120.688 269.437C119.192 265.448 117.696 261.458 117.197 257.468C120.19 257.468 124.678 257.468 130.663 257.468ZM133.655 269.936C141.136 267.442 150.112 264.45 160.585 262.954C152.606 266.445 145.125 271.432 139.141 275.422C135.151 277.915 132.159 280.409 129.166 281.905C126.673 279.411 124.678 276.419 122.683 273.427C125.675 272.928 129.166 271.432 133.655 269.936ZM132.657 316.316C133.156 317.812 133.655 319.308 133.655 320.306C136.647 330.779 140.138 344.244 147.12 353.72C138.143 345.74 133.156 334.769 129.166 326.29C127.67 322.799 126.174 319.308 124.179 316.815C126.673 316.316 128.668 316.316 131.161 316.316C131.66 316.316 132.159 316.316 132.657 316.316ZM119.691 317.812C121.187 320.306 123.182 324.296 125.177 328.285C128.169 334.769 132.159 342.748 137.146 349.73C129.166 343.247 122.683 335.766 117.696 330.28C114.704 326.789 112.21 323.797 110.215 321.802C112.709 320.306 116.2 318.81 119.691 317.812ZM105.727 324.794C108.221 326.789 110.714 329.781 114.205 333.771C119.192 339.756 125.675 347.236 133.655 353.72C123.681 349.231 115.203 344.244 108.221 340.254C103.233 337.262 99.7424 335.267 96.2515 333.771C99.2437 330.28 102.236 327.288 105.727 324.794ZM93.7579 337.262C96.7502 338.259 100.74 340.753 106.226 343.745C113.706 348.234 123.182 353.72 134.652 358.707C123.182 356.712 114.205 353.72 106.226 351.725C98.745 349.73 93.2592 348.234 88.7708 347.735C90.2669 343.745 91.7631 340.254 93.7579 337.262ZM87.2746 352.223C91.2643 352.223 97.2489 354.218 104.73 356.213C111.712 358.208 119.691 360.702 129.166 362.696H85.7785C86.2772 358.707 86.7759 355.216 87.2746 352.223ZM128.169 367.185C119.192 369.18 111.213 371.175 104.73 373.169C97.2489 375.164 91.2643 377.159 87.2746 377.159C86.2772 374.167 85.7785 370.676 85.7785 367.185H128.169ZM106.226 377.658C113.706 375.663 123.182 372.671 134.652 370.676C123.182 375.663 113.706 381.149 106.226 385.637C101.239 388.629 96.7502 391.123 93.7579 392.12C91.7631 389.128 90.2669 385.637 88.7708 382.146C93.2592 381.149 98.745 379.653 106.226 377.658ZM108.221 389.128C114.704 385.138 123.681 380.151 133.655 375.663C125.675 382.146 119.192 389.627 114.205 395.611C111.213 399.102 108.221 402.593 105.727 404.588C102.236 402.095 99.2437 399.102 96.7502 395.611C99.7424 394.115 103.233 392.12 108.221 389.128ZM117.197 398.604C122.185 392.619 128.668 385.138 136.647 379.154C131.161 386.136 127.67 394.115 124.678 400.599C122.683 404.588 121.187 408.578 119.192 411.072C115.701 410.074 112.21 408.578 109.218 407.082C111.712 405.087 114.205 402.095 117.197 398.604ZM132.159 427.03C134.652 423.539 136.148 417.555 138.143 410.074C142.632 394.115 149.115 372.172 165.074 367.185C166.57 367.684 170.56 371.175 173.552 374.167C174.549 375.164 176.045 376.66 177.542 377.658C177.043 377.658 177.043 378.156 176.544 378.156C162.081 387.133 155.1 404.09 159.588 421.046C164.076 437.503 178.539 448.974 195.495 449.472C194.996 450.47 194.996 451.467 194.498 452.465C193.002 456.454 191.506 461.441 190.508 462.439C174.051 466.429 157.593 450.47 145.624 438.501C140.138 433.514 135.65 429.025 132.159 427.03ZM116.2 476.403C119.192 475.904 124.179 475.904 130.164 475.904C138.642 475.904 150.112 475.904 162.081 474.408C151.11 478.398 141.634 480.393 134.154 482.387C126.673 484.382 121.187 485.878 117.197 487.374C116.699 484.382 116.2 480.392 116.2 476.403ZM139.639 438.999C140.637 439.997 141.634 440.994 142.632 441.992C150.611 449.472 160.087 458.948 171.058 464.434C159.588 461.94 149.614 454.958 141.634 449.472C138.143 446.979 135.65 444.984 132.657 443.488C134.652 441.992 136.148 440.496 138.143 439.498C138.642 439.498 139.141 439.498 139.639 438.999ZM129.166 446.979C132.159 448.475 135.151 450.47 139.141 453.462C145.125 457.95 152.107 462.938 160.585 465.93C150.611 464.434 141.136 461.441 133.655 458.948C129.166 457.452 125.675 456.454 122.683 455.457C124.179 452.465 126.673 449.472 129.166 446.979ZM120.19 459.447C123.182 459.945 127.172 461.441 131.66 462.938C139.141 465.431 148.616 468.423 158.59 470.418C147.619 471.416 137.645 471.416 130.164 471.416C124.678 471.416 120.19 471.416 116.699 471.914C116.699 470.418 117.197 469.421 117.197 467.925C118.195 464.932 119.192 462.439 120.19 459.447ZM135.65 487.374C142.632 485.878 150.611 483.883 160.087 480.393L122.185 501.837C120.688 498.845 119.192 495.354 118.195 492.362C121.686 490.367 127.67 489.369 135.65 487.374ZM161.084 485.38C154.102 491.863 148.616 497.349 144.128 502.336C138.642 507.822 134.652 512.31 131.161 514.305C128.668 511.811 126.673 509.318 124.678 506.326L161.084 485.38ZM147.12 505.328C152.606 499.842 159.588 492.86 168.066 484.881C160.585 494.855 155.1 504.331 150.611 511.811C147.619 516.798 145.125 521.287 143.13 523.78C139.639 522.284 136.647 519.791 133.655 517.297C137.645 514.804 142.133 510.814 147.12 505.328ZM155.1 514.305C159.089 507.323 164.076 498.845 170.061 490.367C166.071 499.842 164.575 509.817 163.079 517.297C162.081 522.284 161.084 526.274 160.087 529.266C157.094 528.768 154.601 528.269 151.609 527.77C150.112 527.271 149.115 526.773 147.619 526.274C149.614 522.783 152.107 519.292 155.1 514.305ZM167.567 517.796C169.063 510.315 171.058 500.341 174.549 490.865C173.552 499.842 174.051 508.32 175.048 515.801C175.547 520.289 176.045 524.279 175.547 527.77C172.056 528.768 168.565 529.266 165.074 529.266C166.071 526.274 166.57 522.284 167.567 517.796ZM180.035 526.274C180.035 523.282 179.536 519.292 179.536 515.302C178.539 505.328 177.542 492.362 182.03 480.891C180.534 493.359 184.025 506.824 187.017 518.295C187.516 519.791 187.516 521.287 188.015 522.284C187.516 522.284 187.516 522.783 187.017 522.783C184.524 524.778 182.529 525.277 180.035 526.274ZM210.955 542.732C220.431 545.225 231.402 548.217 242.374 548.217C243.87 548.217 245.366 548.217 246.863 548.217C235.891 552.207 223.423 550.711 213.948 550.212C209.958 549.714 206.467 549.714 203.475 549.714C204.472 547.719 205.469 545.225 206.467 543.23C206.467 542.732 206.966 542.732 206.966 542.233C208.462 542.233 209.459 542.732 210.955 542.732ZM201.978 553.703C204.971 553.703 208.96 553.703 213.449 554.202C217.937 554.701 223.423 555.199 228.41 555.199C231.402 555.199 234.893 555.199 237.886 554.701C228.41 558.69 218.935 560.186 210.955 561.683C206.467 562.68 202.976 563.179 199.984 564.176C200.482 560.685 200.981 557.194 201.978 553.703ZM212.451 566.67C219.932 565.174 229.906 563.179 239.382 559.688C230.405 566.171 221.927 571.158 215.444 574.649C210.457 577.641 206.467 579.636 203.973 581.631C203.475 580.135 202.976 579.138 202.477 577.641C201.48 574.649 200.981 572.156 200.981 569.163C203.475 568.166 207.464 567.667 212.451 566.67ZM217.439 578.639C224.919 574.15 234.395 568.665 244.369 561.184C236.888 570.161 229.906 576.644 223.922 582.13C218.436 587.616 214.446 591.605 211.454 595.096C208.96 592.104 206.966 589.112 204.971 585.621C207.963 584.125 212.451 581.631 217.439 578.639ZM227.413 585.621C232.4 580.634 238.384 575.148 244.868 567.667L222.924 605.071C219.932 603.076 217.439 601.081 214.945 598.587C217.439 595.096 221.927 591.107 227.413 585.621ZM248.359 571.158C245.366 580.135 243.372 587.616 241.875 594.099C239.881 601.58 238.384 607.564 236.39 611.055C233.397 610.058 229.906 609.06 226.914 607.065L248.359 571.158ZM246.364 595.096C248.359 587.616 250.852 578.14 254.343 567.168C252.847 579.636 252.847 590.608 252.847 599.086C252.847 605.071 252.847 610.058 252.348 613.05C248.359 613.05 244.868 613.05 240.878 612.053C243.372 608.063 244.868 602.577 246.364 595.096ZM257.834 599.086C257.834 591.107 257.834 581.631 258.832 570.659C260.328 581.132 263.32 590.109 266.312 597.59C267.809 602.078 269.305 606.068 269.803 609.06C267.31 610.058 264.816 611.055 261.824 611.554C260.328 612.052 258.832 612.053 257.834 612.551C257.834 609.559 257.834 605.071 257.834 599.086ZM273.793 607.065C273.294 604.073 271.798 600.582 270.302 596.094C267.808 588.613 264.816 579.636 263.32 569.163C266.811 577.143 271.798 584.623 275.788 590.608C278.281 594.598 280.775 597.59 282.271 600.582C279.778 603.076 277.284 605.569 273.793 607.065ZM285.762 597.091C284.266 594.598 282.271 591.605 279.778 588.114C273.793 579.636 266.312 569.163 264.816 557.194C269.803 568.665 279.778 579.138 287.757 587.117C288.754 588.114 289.752 589.112 290.749 590.109C290.749 590.608 290.251 591.107 290.251 591.107C288.754 593.101 287.258 595.096 285.762 597.091ZM320.672 596.094C331.145 593.101 344.61 589.61 354.086 582.629C346.106 591.605 335.135 596.592 326.657 600.582C323.166 602.078 319.675 603.574 317.181 605.569C316.682 603.076 316.682 601.081 316.682 598.587C316.682 598.089 316.682 597.59 316.682 597.59C318.178 597.091 319.675 596.592 320.672 596.094ZM328.651 604.572C335.135 601.58 343.114 597.59 350.096 592.603C343.613 600.582 336.132 607.065 330.646 612.053C327.155 615.045 324.163 617.538 322.168 619.533C320.173 616.541 319.176 613.05 318.178 609.559C320.672 608.562 324.662 606.567 328.651 604.572ZM333.639 615.544C339.623 610.556 347.104 604.073 353.587 596.094C349.099 606.068 344.111 614.546 340.122 621.528C337.129 626.515 335.135 630.006 333.639 633.497C330.148 631.004 327.155 628.011 324.662 624.52C327.155 621.528 330.148 619.034 333.639 615.544ZM344.111 623.523C348.6 616.042 354.086 606.567 359.073 595.096C357.078 606.567 354.086 615.544 352.091 623.523C350.096 631.004 348.6 636.49 348.101 640.978C344.61 639.482 341.119 637.986 338.127 635.991C338.626 632.998 341.119 629.009 344.111 623.523ZM367.551 601.58C369.546 610.556 371.541 618.536 373.535 625.019C375.53 632.5 377.525 638.484 377.525 642.474C374.533 643.471 371.042 643.97 367.551 643.97V601.58ZM382.014 640.978C381.515 636.49 380.019 631.004 378.024 623.523C376.029 616.042 373.037 606.567 371.042 595.096C376.029 606.567 381.515 616.042 386.003 623.523C388.996 628.51 391.489 632.998 392.487 635.991C388.996 637.986 385.505 639.482 382.014 640.978ZM395.978 633.497C394.481 630.505 392.487 626.515 389.494 621.528C385.505 615.045 380.517 606.068 376.029 596.094C382.512 604.073 389.993 610.556 395.978 615.544C399.469 618.536 402.959 621.528 404.954 624.022C402.461 627.513 399.469 630.505 395.978 633.497ZM407.448 620.032C405.453 617.538 402.461 615.045 398.97 612.053C392.985 607.065 385.505 600.582 379.52 592.603C386.502 598.089 394.481 601.58 400.965 604.572C404.954 606.567 408.944 608.063 411.438 610.058C410.44 614.047 408.944 617.04 407.448 620.032ZM413.432 598.587C413.432 601.081 412.934 603.574 412.934 605.569C410.44 604.073 406.949 602.577 403.458 600.582C393.983 596.094 382.512 591.107 375.032 581.132C385.006 588.613 398.471 592.603 409.941 595.595C411.438 596.094 412.435 596.592 413.931 596.592C413.432 597.59 413.432 598.089 413.432 598.587ZM442.358 587.117C450.337 579.138 459.314 569.662 464.8 558.69C462.306 570.161 455.324 580.135 449.838 588.114C447.345 591.605 445.35 594.099 443.854 597.091C442.358 595.096 440.862 593.6 439.864 591.605C439.864 591.107 439.365 591.107 439.365 590.608C440.363 589.112 441.36 588.114 442.358 587.117ZM453.828 590.608C458.317 584.623 463.304 577.641 466.296 569.163C464.8 579.138 461.808 588.613 459.314 596.094C457.818 600.582 456.82 604.073 455.823 607.065C452.831 605.071 449.838 603.076 447.345 600.582C448.841 598.089 450.836 594.598 453.828 590.608ZM463.304 597.59C465.797 590.109 468.79 581.132 470.784 570.659C471.782 581.631 471.782 591.605 471.782 599.086C471.782 604.572 471.782 609.06 472.28 612.551C470.784 612.551 469.787 612.053 468.291 612.053C465.299 611.554 462.805 610.556 460.311 609.06C460.81 606.567 461.808 602.577 463.304 597.59ZM476.769 613.05C476.27 610.058 476.27 605.071 476.27 599.086C476.27 590.608 476.27 579.138 474.774 567.168C478.764 578.14 480.759 587.616 482.753 595.096C484.748 602.577 486.244 608.063 487.741 612.053C484.748 613.05 480.759 613.549 476.769 613.05ZM492.728 611.554C490.733 608.063 489.237 602.078 487.242 594.598C485.746 587.616 483.751 579.636 480.26 570.161L501.705 608.063C499.211 609.06 496.219 610.556 492.728 611.554ZM506.692 605.071L485.746 568.665C492.229 575.647 497.715 581.132 502.702 585.621C508.188 591.107 512.676 595.096 514.671 598.587C512.177 601.081 509.684 603.574 506.692 605.071ZM517.663 595.595C515.17 592.104 510.681 587.616 505.694 582.629C500.208 577.143 493.226 570.161 485.247 561.683C495.221 569.163 504.697 574.649 512.177 579.138C517.165 582.13 521.653 584.623 524.147 586.618C522.152 589.61 520.157 592.603 517.663 595.595ZM526.141 581.631C523.648 579.636 519.658 577.143 514.671 574.649C507.689 570.659 499.211 565.672 490.733 559.688C500.208 563.677 510.183 565.174 517.663 566.67C522.65 567.667 526.64 568.665 529.632 569.662C528.635 573.652 527.638 578.14 526.141 581.631ZM518.162 562.181C510.681 560.685 500.707 558.69 491.232 555.199C494.224 555.698 497.715 555.698 500.707 555.698C506.193 555.698 511.18 555.199 515.668 554.701C520.157 554.202 524.147 553.703 527.638 554.202C528.635 557.693 529.134 561.184 529.134 564.675C526.64 563.677 522.65 563.179 518.162 562.181ZM523.648 543.23C524.645 545.225 525.643 547.719 526.64 549.714C523.648 549.714 520.157 550.212 515.668 550.212C505.694 551.21 492.728 552.207 481.257 547.719C483.252 548.217 485.247 548.217 487.741 548.217C498.214 548.217 509.185 545.225 518.661 543.23C520.157 542.732 521.653 542.732 522.65 542.233C523.149 542.233 523.648 542.732 523.648 543.23ZM612.917 488.372C608.928 486.377 602.943 484.881 595.961 483.385C588.48 481.39 579.005 478.896 568.033 475.405C580.501 476.902 591.473 476.901 599.951 476.901C605.935 476.901 610.922 476.902 613.915 477.4C613.915 480.891 613.416 484.382 612.917 488.372ZM543.098 518.793C545.591 507.822 549.082 494.855 548.085 482.886C552.074 493.858 550.578 505.827 550.08 515.801C549.581 519.791 549.581 523.282 549.581 526.274C547.586 525.277 545.093 524.279 543.098 523.282C542.599 523.282 542.599 522.783 542.1 522.783C542.599 521.287 543.098 519.791 543.098 518.793ZM554.069 527.77C554.069 524.778 554.069 520.788 554.568 516.3C555.067 508.819 556.064 500.341 555.067 491.364C559.056 500.84 561.051 510.315 562.049 518.295C563.046 522.783 563.545 526.274 564.542 529.266C561.051 529.266 557.56 528.768 554.069 527.77ZM569.529 528.768C568.532 525.775 567.535 521.786 566.537 517.297C565.041 509.817 563.046 499.842 559.555 490.367C566.038 499.344 571.026 507.822 574.516 514.305C577.509 519.292 579.504 523.282 581.498 525.775C580.002 526.274 579.005 526.773 577.509 527.271C575.514 528.269 572.522 528.768 569.529 528.768ZM586.486 523.78C584.491 521.287 581.997 517.297 579.005 511.811C574.516 504.331 569.031 494.855 561.55 484.881C570.527 492.362 577.01 499.344 582.496 505.328C587.982 510.814 591.971 514.804 595.462 517.796C592.969 520.289 589.478 522.284 586.486 523.78ZM598.953 514.305C595.462 512.31 591.473 507.822 585.987 502.336C581 497.349 575.514 491.364 568.033 484.881L605.437 506.824C603.442 509.318 601.447 511.811 598.953 514.305ZM607.93 502.336L571.524 481.39C580.501 484.382 587.982 486.377 594.465 487.873C601.946 489.868 607.93 491.364 611.421 493.359C610.922 496.351 609.426 499.344 607.93 502.336ZM599.452 471.914C591.473 471.914 581.997 471.914 571.026 470.917C581.498 469.421 590.475 466.429 597.956 463.436C602.444 461.94 606.434 460.444 609.426 459.945C610.424 462.439 611.421 464.932 611.92 467.925C612.419 469.421 612.419 470.917 612.917 471.914C609.925 471.914 605.437 471.914 599.452 471.914ZM596.46 458.948C588.979 461.441 580.002 464.434 569.529 465.93C577.509 462.439 584.99 457.452 590.974 453.462C594.964 450.968 597.956 448.475 600.948 446.979C603.442 449.472 605.437 452.465 607.432 455.457C604.439 456.454 600.948 457.452 596.46 458.948ZM597.457 413.066C596.959 411.57 596.46 410.074 596.46 409.077C593.468 398.604 589.977 385.138 582.995 375.663C591.971 383.642 596.959 394.614 600.948 403.092C602.444 406.583 603.941 410.074 605.935 412.568C603.442 413.066 601.447 413.066 598.953 413.066C598.455 413.066 597.956 413.066 597.457 413.066ZM610.424 411.57C608.928 409.077 606.933 405.087 604.938 401.097C601.946 394.614 597.956 386.635 592.969 379.653C600.948 386.136 607.432 393.617 612.419 399.102C615.411 402.593 617.904 405.586 619.899 407.581C617.406 409.077 613.915 410.573 610.424 411.57ZM624.388 404.588C621.894 402.593 619.401 399.601 615.91 395.611C610.922 389.627 604.439 382.146 596.46 375.663C606.434 380.151 614.912 385.138 621.894 389.128C626.881 392.12 630.372 394.115 633.863 395.611C630.871 399.102 627.879 402.095 624.388 404.588ZM636.357 392.12C633.365 391.123 629.375 388.629 623.889 385.637C616.408 381.149 606.933 375.663 595.462 370.676C606.933 372.671 615.91 375.663 623.889 377.658C631.37 379.653 636.856 381.149 641.344 381.647C639.848 385.637 638.352 388.629 636.357 392.12ZM642.84 377.159C638.85 377.159 632.866 375.164 625.385 373.169C618.403 371.175 610.424 368.681 600.948 366.686H644.336C643.838 370.676 643.339 374.167 642.84 377.159ZM601.946 362.198C610.922 360.203 618.902 358.208 625.385 356.213C632.866 354.218 638.85 352.223 642.84 352.223C643.837 355.216 644.336 358.707 644.336 362.198H601.946ZM623.889 351.725C616.408 353.72 606.933 356.712 595.462 358.707C606.933 353.72 616.408 348.234 623.889 343.745C628.876 340.753 633.365 338.259 636.357 337.262C638.352 340.254 639.848 343.745 641.344 347.236C636.856 348.234 631.37 349.73 623.889 351.725ZM621.894 340.254C615.411 344.244 606.434 349.231 596.46 353.72C604.439 347.236 610.922 339.756 615.91 333.771C618.902 330.28 621.894 326.789 624.388 324.794C627.879 327.288 630.871 330.28 633.365 333.771C630.372 335.267 626.881 337.262 621.894 340.254ZM612.917 330.779C607.93 336.763 601.447 344.244 593.468 350.229C598.953 343.247 602.444 335.267 605.437 328.784C607.432 324.794 608.928 320.805 610.922 318.311C614.414 319.308 617.904 320.805 620.897 322.301C618.403 324.296 615.91 327.288 612.917 330.779ZM127.172 303.35C127.67 303.848 128.668 304.846 129.166 306.841C128.668 307.339 128.668 307.838 129.166 308.836L129.665 309.334C130.164 310.332 130.164 311.329 130.663 312.326C103.233 312.326 80.7914 336.265 80.7914 365.19C80.7914 394.115 103.233 418.053 130.663 418.053C129.166 422.043 128.169 425.534 126.673 426.532C96.7502 424.038 73.3107 397.606 73.3107 365.19C73.3107 332.275 96.7502 305.843 127.172 303.35ZM602.943 426.033C602.444 425.534 601.447 424.537 600.948 422.542C601.447 422.043 601.447 421.544 600.948 420.547L600.45 420.048C599.951 419.051 599.951 418.053 599.452 417.056C626.881 417.056 649.323 393.118 649.323 364.193C649.323 335.267 626.881 311.329 599.452 311.329C600.948 307.339 601.946 303.848 603.442 302.851C633.365 305.345 656.804 331.776 656.804 364.193C656.804 397.108 633.365 423.539 602.943 426.033ZM594.964 101.371C607.432 103.366 618.403 105.361 625.385 103.865C623.889 110.847 625.884 121.818 627.879 134.785C632.367 160.718 637.853 193.134 619.401 214.08C613.416 204.605 605.437 197.124 596.46 192.137L611.421 193.633C611.421 194.132 611.92 194.63 611.92 195.129C613.915 198.121 617.904 199.618 621.395 197.623C624.388 195.628 625.884 191.638 623.889 188.147C621.894 185.155 617.904 183.659 614.413 185.654C612.917 186.152 612.419 187.648 611.421 188.646L592.969 186.651C592.969 183.659 593.468 180.666 592.969 178.173L613.915 175.181C615.91 178.173 619.899 179.669 622.892 177.674C625.884 175.679 626.881 171.69 625.385 168.697C623.39 165.705 619.401 164.209 616.408 166.204C614.414 167.201 613.416 169.196 613.416 170.692L592.969 173.684C592.47 170.194 591.473 166.703 589.977 163.212L612.419 152.739C614.414 154.733 617.904 155.232 620.398 153.736C623.39 151.741 624.886 147.751 622.892 144.26C620.897 141.268 616.907 139.772 613.416 141.767C610.922 143.263 609.925 145.757 609.925 148.25L588.48 159.222C586.984 156.23 584.491 153.237 582.496 150.744L605.935 127.304C608.429 128.8 611.421 128.8 614.413 127.304C618.403 124.811 619.899 119.824 617.406 115.834C614.912 111.844 609.925 110.348 605.935 112.842C601.946 115.335 600.45 120.322 602.943 124.312L579.005 147.751C576.511 145.757 574.018 143.762 571.026 142.266L581.498 119.325C583.992 119.325 586.486 118.327 587.982 115.834C589.977 112.842 588.48 108.353 585.488 106.358C582.496 104.364 578.008 105.86 576.013 108.852C574.517 111.345 575.015 114.836 577.01 116.831L566.537 139.772C563.046 138.276 560.054 137.279 556.064 136.78L559.056 115.834C561.051 115.335 562.547 114.338 563.545 112.842C565.54 109.849 564.044 105.86 561.051 103.865C558.059 101.87 553.571 102.867 552.074 106.358C550.08 109.351 551.576 113.34 554.568 115.335L551.077 136.78C548.085 136.78 545.591 136.78 542.599 136.78L540.604 117.829C541.602 117.33 543.098 116.333 543.596 114.836C545.591 111.844 544.095 107.356 541.103 105.361C538.111 103.366 533.622 104.862 531.627 107.854C529.632 110.847 531.129 115.335 534.121 117.33C534.62 117.829 535.118 117.829 535.617 117.829L537.113 133.289C531.627 123.813 524.147 115.834 514.172 109.351C536.614 91.397 569.031 96.8828 594.964 101.371ZM432.384 21.5773C444.353 17.0889 454.826 13.0992 460.311 8.61076C462.805 15.5927 469.787 24.0708 477.766 34.0451C494.723 54.4923 515.668 79.4279 510.183 106.857C500.208 101.87 489.735 99.3764 479.262 99.3764L493.226 93.3918C493.725 93.8905 494.224 94.3893 494.723 94.3893C497.715 96.3841 502.203 95.3867 504.198 91.8957C506.193 88.9034 505.195 84.415 501.705 82.4202C498.712 80.4253 494.224 81.4227 492.229 84.9137C491.73 86.4099 491.232 87.4073 491.232 88.9034L474.275 96.3841C473.278 93.8905 471.782 91.397 469.787 88.9034L486.244 75.4382C489.237 77.433 493.725 76.4356 495.221 72.9446C497.216 69.9524 495.72 65.9627 492.728 63.9678C489.735 61.973 485.247 62.9704 483.751 66.4614C482.753 68.4562 482.753 70.4511 483.252 71.9472L466.795 84.9137C464.301 81.9215 461.808 79.4279 458.815 77.433L473.278 56.9858C476.27 57.9833 479.262 56.4871 480.759 53.9936C482.753 51.0013 481.756 46.5129 478.265 44.518C475.273 42.5232 470.784 43.5206 468.79 47.0116C468.79 49.5052 468.79 52.4974 470.286 54.4923L455.823 74.9395C452.831 72.9446 449.838 71.9472 446.347 70.4511L454.826 38.0348C457.818 38.0348 460.311 36.5386 461.808 34.0451C464.301 30.0554 462.805 24.5695 458.815 22.5747C454.826 20.0811 449.34 21.5773 447.345 25.567C444.851 29.5567 446.347 34.5438 450.337 37.0374L441.859 69.4536C438.867 68.9549 435.376 68.4562 432.384 68.9549L429.89 43.5206C432.384 42.5232 433.88 40.0296 433.88 37.5361C433.88 34.0451 430.887 30.5541 426.898 30.5541C423.407 30.5541 419.916 33.5464 419.916 37.5361C419.916 40.5283 421.911 43.5206 424.903 44.0193L427.396 68.9549C423.905 69.4536 420.414 70.4511 416.923 71.4485L408.944 51.5C410.44 50.5026 411.438 48.5077 411.438 46.5129C411.438 43.0219 408.445 40.0296 404.456 40.0296C400.965 40.0296 397.474 43.0219 397.474 46.5129C397.474 50.0039 400.466 52.9961 403.957 52.9961L411.936 73.4433C409.443 74.4408 406.949 75.9369 404.954 77.9318L393.484 62.4717C394.481 61.4743 394.481 59.9781 394.481 58.482C394.481 54.991 391.489 51.5 387.499 51.5C384.008 51.5 380.517 54.4923 380.517 58.482C380.517 61.973 383.51 65.464 387.499 65.464C387.998 65.464 388.497 65.464 388.996 65.464L397.972 77.9318C388.497 72.4459 378.024 69.4536 366.553 68.9549C377.026 42.0245 407.947 30.5541 432.384 21.5773ZM251.85 33.5464C260.328 23.5721 267.31 15.094 269.305 8.11205C274.79 13.0992 285.263 16.5902 297.232 21.0786C322.168 30.0554 352.59 41.5258 361.566 67.9575C350.595 68.4562 340.122 71.4485 330.646 76.9343L339.623 64.4665C340.122 64.4665 340.62 64.4665 341.119 64.4665C344.61 64.4665 348.101 61.4743 348.101 57.4846C348.101 53.9936 345.109 50.5026 341.119 50.5026C337.129 50.5026 334.137 53.4949 334.137 57.4846C334.137 58.9807 334.636 60.4768 335.633 61.4743L324.662 76.4356C322.168 74.9395 319.675 73.4433 317.181 71.9472L324.662 51.9987C328.153 51.9987 331.145 49.0064 331.145 45.5155C331.145 42.0245 328.153 39.0322 324.163 39.0322C320.173 39.0322 317.181 42.0245 317.181 45.5155C317.181 47.5103 318.178 49.5052 319.675 50.5026L312.194 69.9524C308.703 68.4562 305.212 67.9575 301.721 67.4588L304.214 42.5232C307.207 41.5258 309.202 39.0322 309.202 36.0399C309.202 32.5489 306.209 29.058 302.22 29.058C298.729 29.058 295.238 32.0502 295.238 36.0399C295.238 38.5335 296.734 41.0271 299.227 42.0245L296.734 66.9601C293.243 66.9601 289.752 67.4588 286.261 67.9575L277.783 35.5412C280.276 34.0451 281.772 31.5515 281.772 28.0605C281.772 23.5721 277.783 19.5824 273.294 19.5824C268.806 19.5824 264.816 23.5721 264.816 28.0605C264.816 32.5489 268.307 36.5386 273.294 36.5386L281.772 68.9549C278.78 69.9524 275.788 71.4485 273.294 72.9446L258.333 52.4974C259.829 50.5026 259.829 47.5103 258.832 45.5155C256.837 42.5232 252.847 41.0271 249.356 43.0219C246.364 45.0167 244.868 49.0064 246.863 52.4974C248.359 54.991 251.85 56.4871 254.343 55.4897L268.806 75.9369C265.814 77.9318 263.32 80.4253 261.325 83.4176L244.369 69.9524C244.868 67.9575 244.868 65.9627 243.87 64.4665C241.875 61.4743 237.886 60.4768 234.893 61.973C231.901 63.9678 230.405 67.9575 232.4 70.9498C234.395 73.9421 238.384 74.9395 241.377 73.4433L258.333 86.9086C256.837 89.4021 255.341 91.8957 254.343 94.3893L239.382 88.4047C239.382 86.9086 239.382 85.9112 238.384 84.415C236.39 81.4227 232.4 79.9266 228.909 81.9215C225.917 83.9163 224.421 87.906 226.415 91.397C228.41 94.3893 232.4 95.8854 235.891 93.8905C236.39 93.3918 236.888 93.3918 237.387 92.8931L251.85 99.3764C241.377 99.3764 230.405 101.87 219.932 107.356C213.948 79.4279 234.893 53.9936 251.85 33.5464ZM101.737 134.785C103.732 122.317 105.727 111.345 104.231 104.364C111.213 105.86 122.185 103.865 135.151 101.87C161.084 97.3815 193.5 91.8957 214.446 110.348C204.971 116.333 197.49 124.312 192.503 133.289L193.999 118.327C194.498 118.327 194.996 117.829 195.495 117.829C198.487 115.834 199.984 111.844 197.989 108.353C195.994 105.361 192.004 103.865 188.513 105.86C185.521 107.854 184.025 111.844 186.02 115.335C186.518 116.831 188.015 117.33 189.012 118.327L187.017 136.78C184.025 136.78 181.033 136.281 178.539 136.78L175.547 115.834C178.539 113.839 180.035 109.849 178.04 106.857C176.045 103.865 172.056 102.867 169.063 104.364C166.071 106.358 164.575 110.348 166.57 113.34C167.567 115.335 169.562 116.333 171.058 116.333L174.051 136.78C170.56 137.279 167.069 138.276 163.578 139.772L153.105 117.33C155.1 115.335 155.598 111.844 154.102 109.351C152.107 106.358 148.118 104.862 144.627 106.857C141.634 108.852 140.138 112.842 142.133 116.333C143.629 118.826 146.123 119.824 148.616 119.824L159.089 142.764C156.097 144.26 153.105 146.754 150.611 148.749L127.172 125.309C128.668 122.816 128.668 119.824 127.172 116.831C124.678 112.842 119.691 111.345 115.701 113.839C111.712 116.333 110.215 121.32 112.709 125.309C115.203 129.299 120.19 130.795 124.179 128.302L147.619 152.24C145.624 154.733 143.629 157.227 142.133 160.219L119.192 149.746C119.192 147.253 118.195 144.759 115.701 143.263C112.709 141.268 108.221 142.764 106.226 145.757C104.231 148.749 105.727 153.237 108.719 155.232C111.213 156.728 114.704 156.23 116.699 154.235L139.639 164.708C138.143 168.199 137.146 171.191 136.647 175.181L115.701 172.188C115.203 170.193 114.205 168.697 112.709 167.7C109.717 165.705 105.727 167.201 103.732 170.194C101.737 173.186 102.735 177.674 106.226 179.17C109.218 181.165 113.208 179.669 115.203 176.677L136.647 180.168C136.647 183.16 136.647 185.654 136.647 188.646L117.696 190.641C117.197 189.643 116.2 188.147 114.704 187.648C111.712 185.654 107.223 187.15 105.228 190.142C103.233 193.134 104.73 197.623 107.722 199.618C110.714 201.612 115.203 200.116 117.197 197.124C117.696 196.625 117.696 196.127 117.696 195.628L133.156 194.132C124.678 196.625 116.2 204.106 110.215 214.08C91.7631 193.134 97.2489 160.718 101.737 134.785ZM21.9433 296.866C17.4549 284.897 13.4652 274.424 8.97682 268.939C15.9588 266.445 24.4369 259.463 34.4111 251.484C54.8583 234.527 79.794 213.581 107.223 219.067C102.236 229.042 99.7424 239.515 99.7424 249.987L93.7579 236.024C94.2566 235.525 94.7553 235.026 94.7553 234.527C96.7502 231.535 95.7528 227.047 92.2618 225.052C89.2695 223.057 84.7811 224.054 82.7862 227.545C80.7914 230.538 81.7888 235.026 85.2798 237.021C86.7759 237.52 87.7734 238.018 89.2695 238.018L96.7502 254.975C94.2566 255.972 91.7631 257.468 89.2695 259.463L75.8043 243.005C77.7991 240.013 76.8017 235.525 73.3107 234.029C70.3184 232.034 66.3287 233.53 64.3339 236.522C62.339 239.515 63.3365 244.003 66.8274 245.499C68.8223 246.496 70.8171 246.496 72.3133 245.998L85.2798 262.455C82.2875 264.949 79.794 267.442 77.7991 270.435L57.3519 255.972C58.3493 252.98 56.8532 249.987 54.3596 248.491C51.3674 246.496 46.879 247.494 44.8841 250.985C42.8893 253.977 43.8867 258.466 47.3777 260.46C49.8712 261.957 52.3648 261.458 54.3596 259.962L74.8068 274.424C72.812 277.417 71.8146 280.409 70.3184 283.9L37.9021 275.422C37.9021 272.43 36.406 269.936 33.9124 268.44C29.9227 265.946 24.4369 267.442 22.4421 271.432C19.9485 275.422 21.4446 280.908 25.4343 282.902C29.424 285.396 34.4111 283.9 36.9047 279.91L69.321 288.887C68.8223 291.879 68.3236 295.37 68.8223 298.363L43.388 300.856C42.3905 298.363 39.897 296.866 37.4034 296.866C33.9124 296.866 30.4214 299.859 30.4214 303.848C30.4214 307.339 33.4137 310.83 37.4034 310.83C40.3957 310.83 43.388 308.836 43.8867 305.843L68.8223 303.35C69.321 306.841 70.3184 310.332 71.3159 313.823L51.3674 321.802C50.3699 320.306 48.3751 319.308 46.3802 319.308C42.8893 319.308 39.897 322.301 39.897 326.29C39.897 329.781 42.8893 333.272 46.3802 333.272C49.8712 333.272 52.8635 330.28 52.8635 326.789L73.3107 318.81C74.3081 321.303 75.8043 323.797 77.7991 325.792L62.339 337.262C61.3416 336.265 59.8455 336.265 58.3493 336.265C54.8583 336.265 51.3674 339.257 51.3674 343.247C51.3674 346.738 54.3596 350.229 58.3493 350.229C61.8403 350.229 65.3313 347.236 65.3313 343.247C65.3313 342.748 65.3313 342.249 65.3313 341.75L77.7991 332.774C72.3133 342.249 69.321 352.722 68.8223 364.193C42.3905 352.722 30.9202 321.802 21.9433 296.866ZM33.9124 477.899C23.9382 469.421 15.4601 462.439 8.47811 460.444C13.4652 454.958 16.9562 444.485 21.4446 432.516C30.4214 407.581 41.8918 377.159 68.3236 368.182C68.8223 379.154 71.8146 389.627 77.3004 399.102L64.8326 390.126C64.8326 389.627 64.8326 389.128 64.8326 388.629C64.8326 385.138 61.8403 381.647 57.8506 381.647C54.3596 381.647 50.8686 384.64 50.8686 388.629C50.8686 392.12 53.8609 395.611 57.8506 395.611C59.3468 395.611 60.8429 395.113 61.8403 394.115L76.8017 405.087C75.3055 407.581 73.8094 410.074 72.3133 412.568L52.3648 405.087C52.3648 401.596 49.3725 398.604 45.8815 398.604C42.3905 398.604 39.3983 401.596 39.3983 405.586C39.3983 409.575 42.3905 412.568 45.8815 412.568C47.8764 412.568 49.8712 411.57 50.8686 410.074L70.3184 417.555C68.8223 421.046 68.3236 424.537 67.8249 428.028L42.8893 425.534C41.8918 422.542 39.3983 420.547 36.406 420.547C32.915 420.547 29.424 423.539 29.424 427.529C29.424 431.519 32.4163 434.511 36.406 434.511C38.8996 434.511 41.3931 433.015 42.3905 430.521L67.3262 433.015C67.3262 436.506 67.8249 439.997 68.3236 443.488L35.9073 451.966C34.4111 449.472 31.9176 447.976 28.4266 447.976C23.9382 447.976 19.9485 451.966 19.9485 456.454C19.9485 460.943 23.9382 464.932 28.4266 464.932C32.915 464.932 36.9047 461.441 36.9047 456.454L69.321 447.976C70.3184 450.968 71.8146 453.961 73.3107 456.454L52.8635 471.416C50.8687 469.92 47.8764 469.92 45.8815 470.917C44.3854 470.917 42.8893 474.907 44.8841 478.398C46.879 481.39 50.8686 482.886 54.3596 480.891C56.8532 479.395 58.3493 475.904 57.3519 473.411L77.7991 458.948C79.794 461.94 82.2875 464.434 85.2798 466.429L71.8146 483.385C69.8197 482.886 67.8249 482.886 66.3287 483.883C63.3365 485.878 62.339 489.868 63.8352 492.86C65.83 495.853 69.8197 497.349 72.812 495.354C75.8043 493.359 76.8017 489.369 75.3055 486.377L88.7708 469.421C91.2643 470.917 93.7579 472.413 96.2515 473.411L88.2721 490.865C86.7759 490.865 85.7785 490.865 84.2824 491.863C81.2901 493.858 79.794 497.847 81.7888 501.338C83.7837 504.331 87.7734 505.827 91.2643 503.832C94.2566 501.837 95.7527 497.847 93.7579 494.356C93.2592 493.858 93.2592 493.359 92.7605 492.86L99.2437 478.398C99.2437 488.871 101.737 499.842 107.223 510.315C79.794 515.801 54.3596 494.855 33.9124 477.899ZM135.151 628.011C122.683 626.016 111.712 624.022 104.73 625.518C106.226 618.536 104.231 607.564 102.236 594.598C97.7476 568.665 92.2618 536.248 110.714 515.302C116.699 524.778 124.678 532.259 133.655 537.246L118.694 535.75C118.694 535.251 118.195 534.752 118.195 534.253C116.2 531.261 112.21 529.765 108.719 531.76C105.727 533.755 104.231 537.744 106.226 541.235C108.221 544.228 112.21 545.724 115.701 543.729C117.197 543.23 117.696 541.734 118.694 540.737L137.146 542.732C136.647 545.724 136.647 548.716 137.146 551.21L116.2 554.202C114.205 551.21 110.215 549.714 107.223 551.708C104.231 553.703 103.233 557.693 104.73 560.685C106.724 563.677 110.714 565.174 113.706 563.179C115.701 562.181 116.699 560.186 116.699 558.69L137.146 555.698C137.645 559.189 138.642 562.68 140.138 566.171L117.696 576.644C115.701 574.649 112.21 574.15 109.717 575.647C106.724 577.641 105.228 581.631 107.223 585.122C109.218 588.114 113.208 589.61 116.699 587.616C119.192 586.12 120.19 583.626 120.19 581.132L143.13 570.659C144.627 573.652 147.12 576.644 149.115 579.138L125.675 602.577C123.182 601.081 120.19 601.081 117.197 602.577C113.208 605.071 111.712 610.058 114.205 614.047C116.699 618.037 121.686 619.533 125.675 617.04C129.665 614.546 131.161 609.559 128.668 605.569L152.606 582.13C155.1 584.125 157.593 586.12 160.585 587.616L150.112 610.556C147.619 610.556 145.125 611.554 143.629 614.047C141.634 617.04 143.13 621.528 146.123 623.523C149.115 625.518 153.603 624.022 155.598 621.029C157.094 618.536 156.596 615.045 154.601 613.05L165.074 590.109C168.565 591.605 171.557 592.603 175.547 593.101L172.554 614.546C170.56 615.045 169.063 616.042 168.066 617.538C166.071 620.531 167.567 624.52 170.56 626.515C173.552 628.51 178.04 627.513 179.536 624.022C181.531 621.029 180.035 617.04 177.043 615.045L180.534 593.6C181.531 593.6 182.529 593.6 183.526 593.6C185.022 593.6 187.017 593.6 189.012 593.101L191.007 612.053C190.009 612.551 188.513 613.549 188.015 615.045C186.02 618.037 187.516 622.526 190.508 624.52C193.5 626.515 197.989 625.019 199.984 622.027C201.978 619.034 200.482 614.546 197.49 612.551C196.991 612.053 196.493 612.053 195.994 612.053L194.498 596.592C199.984 606.068 207.464 614.047 217.439 620.531C193.5 637.986 161.084 632.5 135.151 628.011ZM297.232 707.805C285.263 712.294 274.79 716.283 269.305 720.772C266.811 713.79 259.829 705.312 251.85 695.338C234.893 674.89 213.948 649.955 219.433 622.526C229.408 627.513 239.881 630.006 250.354 630.505L236.39 636.489C235.891 635.991 235.392 635.492 234.893 635.492C231.901 633.497 227.413 634.495 225.418 637.986C223.423 640.978 224.421 645.466 227.911 647.461C230.904 649.456 235.392 648.458 237.387 644.968C237.886 643.471 238.384 642.474 238.384 640.978L255.341 633.497C256.338 635.991 257.834 638.484 259.829 640.978L243.372 654.443C240.379 652.448 235.891 653.446 234.395 656.937C232.4 659.929 233.896 663.919 236.888 665.914C239.881 667.908 244.369 666.911 245.865 663.42C246.863 661.425 246.863 659.43 246.364 657.934L262.821 644.968C265.315 647.96 267.808 650.453 270.801 652.448L256.338 672.895C253.346 671.898 250.354 673.394 248.857 675.888C246.863 678.88 247.86 683.368 251.351 685.363C254.343 687.358 258.832 686.361 260.827 682.87C262.323 680.376 261.824 677.883 260.328 675.888L274.79 655.441C277.783 657.435 280.775 658.433 284.266 659.929L275.788 692.345C272.796 692.345 270.302 693.841 268.806 696.335C266.312 700.325 267.808 705.81 271.798 707.805C275.788 710.299 281.274 708.803 283.269 704.813C285.762 700.823 284.266 695.836 280.276 693.343L289.253 660.926C291.747 661.425 294.739 661.924 297.232 661.924C297.731 661.924 298.23 661.924 298.729 661.924L301.222 687.358C298.729 688.355 297.232 690.849 297.232 693.343C297.232 696.834 300.225 700.325 304.214 700.325C307.705 700.325 311.196 697.332 311.196 693.343C311.196 690.35 309.202 687.358 306.209 686.859L303.716 661.924C307.207 661.425 310.698 660.428 314.189 659.43L322.168 679.379C320.672 680.376 319.675 682.371 319.675 684.366C319.675 687.857 322.667 690.849 326.657 690.849C330.148 690.849 333.639 687.857 333.639 684.366C333.639 680.875 330.646 677.883 327.155 677.883L319.176 657.435C321.669 656.438 324.163 654.942 326.158 652.947L337.628 668.407C336.631 669.404 336.631 670.901 336.631 672.397C336.631 675.888 339.623 679.379 343.613 679.379C347.104 679.379 350.595 676.386 350.595 672.397C350.595 668.906 347.602 665.415 343.613 665.415C343.114 665.415 342.615 665.415 342.117 665.415L333.14 652.947C342.615 658.433 353.088 661.425 364.559 661.924C353.088 687.358 322.168 698.33 297.232 707.805ZM478.265 695.338C469.787 705.312 462.805 713.79 460.81 720.772C455.324 715.785 444.851 712.294 432.882 707.805C407.947 698.828 377.525 687.358 368.548 660.926C379.52 660.428 389.993 657.435 399.469 651.95L390.492 664.417C389.993 664.417 389.494 664.417 388.996 664.417C385.505 664.417 382.014 667.41 382.014 671.399C382.014 674.89 385.006 678.381 388.996 678.381C392.985 678.381 395.978 675.389 395.978 671.399C395.978 669.903 395.479 668.407 394.481 667.41L405.453 652.448C407.947 653.944 410.44 655.441 412.934 656.937L405.453 676.885C401.962 676.885 398.97 679.877 398.97 683.368C398.97 686.859 401.962 689.852 405.952 689.852C409.443 689.852 412.934 686.859 412.934 683.368C412.934 681.374 411.936 679.379 410.44 678.381L417.921 658.932C421.412 660.428 424.903 660.926 428.394 661.425L425.9 686.361C422.908 687.358 420.913 689.852 420.913 692.844C420.913 696.335 423.905 699.826 427.895 699.826C431.885 699.826 434.877 696.834 434.877 692.844C434.877 690.35 433.381 687.857 430.887 686.859L433.381 661.924H433.88C437.371 661.924 440.363 661.425 443.854 660.926L452.332 693.343C449.838 694.839 448.342 697.332 448.342 700.823C448.342 705.312 452.332 709.301 456.82 709.301C461.309 709.301 465.299 705.312 465.299 700.823C465.299 696.335 461.808 692.345 456.82 692.345L448.342 659.929C451.335 658.931 454.327 657.435 456.82 655.939L471.782 676.386C470.286 678.381 470.286 681.374 471.283 683.368C473.278 686.361 477.268 687.857 480.759 685.862C483.751 683.867 485.247 679.877 483.252 676.386C481.756 673.893 478.265 672.397 475.771 673.394L461.309 652.947C464.301 650.952 466.795 648.459 468.79 645.466L485.746 658.932C485.247 660.926 485.247 662.921 486.244 664.417C488.239 667.41 492.229 668.407 495.221 666.911C498.214 664.916 499.71 660.926 497.715 657.934C495.72 654.942 491.73 653.944 488.738 655.441L471.782 641.975C473.278 639.482 474.774 636.988 475.771 634.495L493.226 642.474C493.226 643.97 493.226 644.968 494.224 646.464C496.219 649.456 500.208 650.952 503.699 648.957C506.692 646.962 508.188 642.973 506.193 639.482C504.198 636.49 500.208 634.993 496.717 636.988C496.219 637.487 495.72 637.487 495.221 637.986L480.759 631.502C491.232 631.502 502.203 629.009 512.177 623.523C516.167 649.955 495.221 675.389 478.265 695.338ZM628.377 594.598C626.383 607.065 624.388 618.037 625.884 625.019C618.902 623.523 607.93 625.518 594.964 627.513C569.031 632.001 536.614 637.487 515.668 619.034C525.144 613.05 532.625 605.071 537.612 596.094L536.116 611.055C535.617 611.055 535.118 611.554 534.62 611.554C531.627 613.549 530.131 617.538 532.126 621.029C534.121 624.022 538.111 625.518 541.602 623.523C544.594 621.528 546.09 617.538 544.095 614.047C543.596 612.551 542.1 612.052 541.103 611.055L543.098 592.603C544.594 592.603 546.09 592.603 547.586 592.603C549.082 592.603 550.08 592.603 551.576 592.603L554.568 613.549C551.576 615.544 550.08 619.533 552.074 622.526C554.069 625.518 558.059 626.515 561.051 625.019C564.044 623.024 565.54 619.034 563.545 616.042C562.547 614.047 560.553 613.05 559.056 613.05L556.064 592.603C559.555 592.104 563.046 591.107 566.537 589.61L577.01 612.053C575.015 614.047 574.517 617.538 576.013 620.032C578.008 623.024 581.997 624.52 585.488 622.526C588.48 620.531 589.977 616.541 587.982 613.05C586.486 610.556 583.992 609.559 581.498 609.559L571.026 586.618C574.018 585.122 577.01 582.628 579.504 580.634L602.943 604.073C601.447 606.567 601.447 609.559 602.943 612.551C605.437 616.541 610.424 618.037 614.413 615.544C618.403 613.05 619.899 608.063 617.406 604.073C614.912 600.083 609.925 598.587 605.935 601.081L582.496 577.143C584.491 574.649 586.486 572.156 587.982 569.163L610.922 579.636C610.922 582.13 611.92 584.623 614.413 586.12C617.406 588.114 621.894 586.618 623.889 583.626C625.884 580.634 624.388 576.145 621.395 574.15C618.902 572.654 615.411 573.153 613.416 575.148L590.475 564.675C591.971 561.184 592.969 558.192 593.468 554.202L614.413 557.194C614.912 559.189 615.91 560.685 617.406 561.683C620.398 563.677 624.388 562.181 626.383 559.189C628.377 556.197 627.38 551.708 623.889 550.212C620.897 548.217 616.907 549.714 614.912 552.706L593.468 549.215C593.468 546.222 593.468 543.729 593.468 540.737L612.419 538.742C612.917 539.739 613.915 541.235 615.411 541.734C618.403 543.729 622.892 542.233 624.886 539.241C626.881 536.248 625.385 531.76 622.393 529.765C619.401 527.77 614.912 529.266 612.917 532.259C612.419 532.757 612.419 533.256 612.419 533.755L596.959 535.251C606.434 529.765 614.414 522.284 620.398 512.31C638.352 536.248 632.866 568.665 628.377 594.598ZM695.704 477.4C675.256 494.356 650.321 515.302 622.892 509.817C627.879 499.842 630.372 489.369 630.372 478.896L636.357 492.86C635.858 493.359 635.359 493.858 635.359 494.356C633.365 497.349 634.362 501.837 637.853 503.832C640.845 505.827 645.334 504.829 647.328 501.338C649.323 498.346 648.326 493.858 644.835 491.863C643.339 491.364 642.341 490.865 640.845 490.865L633.365 473.909C635.858 472.912 638.352 471.416 640.845 469.421L654.31 485.878C652.316 488.871 653.313 493.359 656.804 494.855C659.796 496.85 663.786 495.354 665.781 492.362C667.776 489.369 666.778 484.881 663.287 483.385C661.292 482.387 659.298 482.387 657.801 482.886L644.835 466.429C647.827 463.935 650.321 461.441 652.316 458.449L672.763 472.912C671.765 475.904 673.262 478.896 675.755 480.393C678.747 482.387 683.236 481.39 685.231 477.899C687.225 474.907 686.228 470.418 682.737 468.423C680.243 466.927 677.75 467.426 675.755 468.922L655.308 454.459C657.303 451.467 658.3 448.475 659.796 444.984L692.213 453.462C692.213 456.454 693.709 458.948 696.202 460.444C700.192 462.938 705.678 461.441 707.673 457.452C710.166 453.462 708.67 447.976 704.68 445.981C700.691 443.488 695.704 444.984 693.21 448.974L660.794 439.997C661.292 437.005 661.791 433.514 661.292 430.521L686.727 428.028C687.724 430.521 690.218 432.017 692.711 432.017C696.202 432.017 699.693 429.025 699.693 425.035C699.693 421.544 696.701 418.053 692.711 418.053C689.719 418.053 686.727 420.048 686.228 423.041L661.292 425.534C660.794 422.043 659.796 418.552 658.799 415.061L678.747 407.082C679.745 408.578 681.74 409.575 683.735 409.575C687.226 409.575 690.218 406.583 690.218 402.593C690.218 399.102 687.226 395.611 683.735 395.611C680.244 395.611 677.251 398.604 677.251 402.095L656.804 410.074C655.807 407.581 654.31 405.087 652.316 403.092L667.776 391.622C668.773 392.619 670.269 392.619 671.765 392.619C675.256 392.619 678.747 389.627 678.747 385.637C678.747 382.146 675.755 378.655 671.765 378.655C668.274 378.655 664.783 381.647 664.783 385.637C664.783 386.136 664.783 386.635 664.783 387.133L652.316 396.11C657.801 386.635 660.794 376.162 661.292 364.691C687.724 373.169 699.195 404.09 708.171 429.025C712.66 440.994 716.65 451.467 721.138 456.953C714.156 462.439 705.678 469.421 695.704 477.4Z",
    fill: "url(#paint242_linear_58_4)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_58_4",
    x1: 49.6028,
    y1: 364.683,
    x2: 477.257,
    y2: 364.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_58_4",
    x1: 103.985,
    y1: 364.185,
    x2: 459.267,
    y2: 364.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_58_4",
    x1: 394.611,
    y1: 86.9939,
    x2: 401.534,
    y2: 86.9939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_58_4",
    x1: 401.503,
    y1: 92.4566,
    x2: 407.534,
    y2: 92.4566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_58_4",
    x1: 388.021,
    y1: 82.3167,
    x2: 394.412,
    y2: 82.3167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_58_4",
    x1: 308.679,
    y1: 106.504,
    x2: 315.164,
    y2: 106.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_58_4",
    x1: 304.189,
    y1: 122.566,
    x2: 310.103,
    y2: 122.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_58_4",
    x1: 313.321,
    y1: 99.7503,
    x2: 320.244,
    y2: 99.7503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_58_4",
    x1: 412.02,
    y1: 105.86,
    x2: 417.315,
    y2: 105.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_58_4",
    x1: 414.564,
    y1: 113.34,
    x2: 421.143,
    y2: 113.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_58_4",
    x1: 407.411,
    y1: 98.3788,
    x2: 413.348,
    y2: 98.3788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_58_4",
    x1: 304.711,
    y1: 114.24,
    x2: 312.151,
    y2: 114.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_58_4",
    x1: 339.757,
    y1: 79.9264,
    x2: 346.336,
    y2: 79.9264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_58_4",
    x1: 332.166,
    y1: 83.5636,
    x2: 338.557,
    y2: 83.5636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_58_4",
    x1: 325.682,
    y1: 87.8027,
    x2: 332.074,
    y2: 87.8027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_58_4",
    x1: 319.215,
    y1: 93.4541,
    x2: 325.246,
    y2: 93.4541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_58_4",
    x1: 348.379,
    y1: 77.5844,
    x2: 354.292,
    y2: 77.5844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_58_4",
    x1: 355.716,
    y1: 76.4355,
    x2: 362.295,
    y2: 76.4355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_58_4",
    x1: 416.339,
    y1: 121.471,
    x2: 423.349,
    y2: 121.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_58_4",
    x1: 372.816,
    y1: 77.3706,
    x2: 378.729,
    y2: 77.3706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_58_4",
    x1: 364.194,
    y1: 76.4355,
    x2: 370.773,
    y2: 76.4355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_58_4",
    x1: 379.934,
    y1: 79.4278,
    x2: 386.943,
    y2: 79.4278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_58_4",
    x1: 288.347,
    y1: 126.12,
    x2: 294.276,
    y2: 126.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_58_4",
    x1: 281.393,
    y1: 119.886,
    x2: 288.246,
    y2: 119.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_58_4",
    x1: 275.055,
    y1: 115.169,
    x2: 281.713,
    y2: 115.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_58_4",
    x1: 191.529,
    y1: 142.412,
    x2: 197.92,
    y2: 142.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_58_4",
    x1: 267.224,
    y1: 110.998,
    x2: 274.234,
    y2: 110.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_58_4",
    x1: 260.107,
    y1: 108.602,
    x2: 266.02,
    y2: 108.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_58_4",
    x1: 187.711,
    y1: 158.474,
    x2: 193.193,
    y2: 158.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_58_4",
    x1: 189.207,
    y1: 150.494,
    x2: 194.689,
    y2: 150.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_58_4",
    x1: 190.471,
    y1: 183.16,
    x2: 196.408,
    y2: 183.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_58_4",
    x1: 186.652,
    y1: 166.702,
    x2: 193.232,
    y2: 166.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_58_4",
    x1: 235.171,
    y1: 107.605,
    x2: 241.084,
    y2: 107.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_58_4",
    x1: 195.75,
    y1: 135.118,
    x2: 201.687,
    y2: 135.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_58_4",
    x1: 212.475,
    y1: 117.141,
    x2: 218.866,
    y2: 117.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_58_4",
    x1: 219.457,
    y1: 113.091,
    x2: 225.848,
    y2: 113.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_58_4",
    x1: 206.559,
    y1: 122.629,
    x2: 212.488,
    y2: 122.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_58_4",
    x1: 227.048,
    y1: 109.448,
    x2: 233.628,
    y2: 109.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_58_4",
    x1: 243.007,
    y1: 106.358,
    x2: 249.586,
    y2: 106.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_58_4",
    x1: 200.522,
    y1: 128.239,
    x2: 206.553,
    y2: 128.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_58_4",
    x1: 251.485,
    y1: 107.106,
    x2: 258.064,
    y2: 107.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_58_4",
    x1: 188.293,
    y1: 174.931,
    x2: 194.206,
    y2: 174.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_58_4",
    x1: 130.419,
    y1: 199.429,
    x2: 136.356,
    y2: 199.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_58_4",
    x1: 137.152,
    y1: 195.774,
    x2: 143.577,
    y2: 195.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_58_4",
    x1: 144.761,
    y1: 192.988,
    x2: 151.34,
    y2: 192.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_58_4",
    x1: 123.72,
    y1: 204.604,
    x2: 129.751,
    y2: 204.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_58_4",
    x1: 102.37,
    y1: 248.741,
    x2: 108.949,
    y2: 248.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_58_4",
    x1: 176.957,
    y1: 194.283,
    x2: 183.967,
    y2: 194.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_58_4",
    x1: 161.218,
    y1: 191.389,
    x2: 167.797,
    y2: 191.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_58_4",
    x1: 153.383,
    y1: 191.139,
    x2: 159.296,
    y2: 191.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_58_4",
    x1: 104.011,
    y1: 240.263,
    x2: 109.924,
    y2: 240.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_58_4",
    x1: 170.339,
    y1: 191.888,
    x2: 176.252,
    y2: 191.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_58_4",
    x1: 116.239,
    y1: 286.892,
    x2: 122.27,
    y2: 286.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_58_4",
    x1: 104.864,
    y1: 264.699,
    x2: 111.443,
    y2: 264.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_58_4",
    x1: 122.723,
    y1: 292.479,
    x2: 128.754,
    y2: 292.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_58_4",
    x1: 102.869,
    y1: 256.471,
    x2: 109.448,
    y2: 256.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_58_4",
    x1: 117.736,
    y1: 210.589,
    x2: 123.767,
    y2: 210.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_58_4",
    x1: 111.468,
    y1: 280.159,
    x2: 117.405,
    y2: 280.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_58_4",
    x1: 107.229,
    y1: 272.928,
    x2: 113.654,
    y2: 272.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_58_4",
    x1: 104.864,
    y1: 232.034,
    x2: 111.443,
    y2: 232.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_58_4",
    x1: 108.486,
    y1: 224.304,
    x2: 115.143,
    y2: 224.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_58_4",
    x1: 112.476,
    y1: 216.823,
    x2: 119.133,
    y2: 216.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_58_4",
    x1: 74.9408,
    y1: 344.146,
    x2: 81.5201,
    y2: 344.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_58_4",
    x1: 77.9328,
    y1: 337.013,
    x2: 84.5121,
    y2: 337.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_58_4",
    x1: 73.5052,
    y1: 352.223,
    x2: 78.988,
    y2: 352.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_58_4",
    x1: 71.9484,
    y1: 360.701,
    x2: 78.5277,
    y2: 360.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_58_4",
    x1: 101.871,
    y1: 416.058,
    x2: 108.451,
    y2: 416.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_58_4",
    x1: 95.7512,
    y1: 411.656,
    x2: 101.954,
    y2: 411.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_58_4",
    x1: 83.2832,
    y1: 329.867,
    x2: 89.4862,
    y2: 329.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_58_4",
    x1: 71.9484,
    y1: 369.18,
    x2: 78.5277,
    y2: 369.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_58_4",
    x1: 88.1718,
    y1: 323.485,
    x2: 94.4769,
    y2: 323.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_58_4",
    x1: 93.8918,
    y1: 318.061,
    x2: 100.471,
    y2: 318.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_58_4",
    x1: 83.6835,
    y1: 399.85,
    x2: 89.9887,
    y2: 399.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_58_4",
    x1: 79.0515,
    y1: 392.869,
    x2: 84.9885,
    y2: 392.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_58_4",
    x1: 73.5892,
    y1: 377.007,
    x2: 79.5021,
    y2: 377.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_58_4",
    x1: 75.4394,
    y1: 385.138,
    x2: 82.0187,
    y2: 385.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_58_4",
    x1: 101.932,
    y1: 313.823,
    x2: 107.415,
    y2: 313.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_58_4",
    x1: 118.473,
    y1: 421.295,
    x2: 124.386,
    y2: 421.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_58_4",
    x1: 109.851,
    y1: 419.051,
    x2: 116.43,
    y2: 419.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_58_4",
    x1: 108.853,
    y1: 310.331,
    x2: 115.432,
    y2: 310.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_58_4",
    x1: 89.1696,
    y1: 406.084,
    x2: 95.4747,
    y2: 406.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_58_4",
    x1: 117.476,
    y1: 308.239,
    x2: 123.389,
    y2: 308.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_58_4",
    x1: 119.153,
    y1: 519.02,
    x2: 124.361,
    y2: 519.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_58_4",
    x1: 114.683,
    y1: 443.09,
    x2: 121.81,
    y2: 443.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_58_4",
    x1: 106.98,
    y1: 457.208,
    x2: 112.917,
    y2: 457.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_58_4",
    x1: 122.644,
    y1: 437.503,
    x2: 127.852,
    y2: 437.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_58_4",
    x1: 101.871,
    y1: 481.888,
    x2: 108.451,
    y2: 481.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_58_4",
    x1: 103.292,
    y1: 489.716,
    x2: 109.635,
    y2: 489.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_58_4",
    x1: 108.743,
    y1: 505.577,
    x2: 115.134,
    y2: 505.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_58_4",
    x1: 112.732,
    y1: 512.62,
    x2: 119.124,
    y2: 512.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_58_4",
    x1: 110.293,
    y1: 449.722,
    x2: 117.318,
    y2: 449.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_58_4",
    x1: 105.69,
    y1: 498.243,
    x2: 111.627,
    y2: 498.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_58_4",
    x1: 138.398,
    y1: 533.505,
    x2: 144.335,
    y2: 533.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_58_4",
    x1: 103.866,
    y1: 465.182,
    x2: 110.445,
    y2: 465.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_58_4",
    x1: 162.216,
    y1: 538.492,
    x2: 168.795,
    y2: 538.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_58_4",
    x1: 154.796,
    y1: 537.994,
    x2: 160.278,
    y2: 537.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_58_4",
    x1: 146.378,
    y1: 536.497,
    x2: 152.315,
    y2: 536.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_58_4",
    x1: 171.117,
    y1: 536.991,
    x2: 177.46,
    y2: 536.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_58_4",
    x1: 178.673,
    y1: 534.898,
    x2: 185.252,
    y2: 534.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_58_4",
    x1: 103.013,
    y1: 473.41,
    x2: 108.926,
    y2: 473.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_58_4",
    x1: 130.498,
    y1: 529.516,
    x2: 137.257,
    y2: 529.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_58_4",
    x1: 123.161,
    y1: 524.778,
    x2: 130.288,
    y2: 524.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_58_4",
    x1: 219.955,
    y1: 616.291,
    x2: 226.347,
    y2: 616.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_58_4",
    x1: 275.811,
    y1: 613.79,
    x2: 282.202,
    y2: 613.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_58_4",
    x1: 261.238,
    y1: 620.78,
    x2: 267.013,
    y2: 620.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_58_4",
    x1: 268.441,
    y1: 617.78,
    x2: 275.021,
    y2: 617.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_58_4",
    x1: 288.794,
    y1: 602.723,
    x2: 294.825,
    y2: 602.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_58_4",
    x1: 282.809,
    y1: 608.473,
    x2: 288.84,
    y2: 608.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_58_4",
    x1: 213.205,
    y1: 612.302,
    x2: 219.142,
    y2: 612.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_58_4",
    x1: 205.588,
    y1: 607.398,
    x2: 212.442,
    y2: 607.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_58_4",
    x1: 200.574,
    y1: 601.656,
    x2: 206.503,
    y2: 601.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_58_4",
    x1: 244.004,
    y1: 622.525,
    x2: 250.583,
    y2: 622.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_58_4",
    x1: 195.89,
    y1: 594.763,
    x2: 201.553,
    y2: 594.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_58_4",
    x1: 228.046,
    y1: 619.435,
    x2: 234.625,
    y2: 619.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_58_4",
    x1: 236.584,
    y1: 621.181,
    x2: 242.067,
    y2: 621.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_58_4",
    x1: 188.975,
    y1: 580.135,
    x2: 194.912,
    y2: 580.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_58_4",
    x1: 188.209,
    y1: 555.449,
    x2: 193.692,
    y2: 555.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_58_4",
    x1: 191.529,
    y1: 587.858,
    x2: 197.92,
    y2: 587.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_58_4",
    x1: 187.296,
    y1: 563.179,
    x2: 193.208,
    y2: 563.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_58_4",
    x1: 190.265,
    y1: 546.97,
    x2: 196.202,
    y2: 546.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_58_4",
    x1: 186.652,
    y1: 572.004,
    x2: 193.232,
    y2: 572.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_58_4",
    x1: 252.482,
    y1: 622.276,
    x2: 259.061,
    y2: 622.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_58_4",
    x1: 364.693,
    y1: 652.947,
    x2: 371.272,
    y2: 652.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_58_4",
    x1: 411.869,
    y1: 622.878,
    x2: 418.354,
    y2: 622.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_58_4",
    x1: 303.435,
    y1: 607.911,
    x2: 310.444,
    y2: 607.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_58_4",
    x1: 414.428,
    y1: 615.142,
    x2: 421.868,
    y2: 615.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_58_4",
    x1: 406.58,
    y1: 629.632,
    x2: 413.503,
    y2: 629.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_58_4",
    x1: 417.201,
    y1: 606.816,
    x2: 423.114,
    y2: 606.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_58_4",
    x1: 402.002,
    y1: 635.928,
    x2: 408.033,
    y2: 635.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_58_4",
    x1: 388.52,
    y1: 645.819,
    x2: 394.911,
    y2: 645.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_58_4",
    x1: 380.652,
    y1: 649.456,
    x2: 387.231,
    y2: 649.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_58_4",
    x1: 395.004,
    y1: 641.58,
    x2: 401.395,
    y2: 641.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_58_4",
    x1: 332.665,
    y1: 647.066,
    x2: 339.056,
    y2: 647.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_58_4",
    x1: 339.841,
    y1: 649.955,
    x2: 346.85,
    y2: 649.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_58_4",
    x1: 348.575,
    y1: 651.7,
    x2: 354.488,
    y2: 651.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_58_4",
    x1: 356.215,
    y1: 652.947,
    x2: 362.794,
    y2: 652.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_58_4",
    x1: 373.012,
    y1: 651.798,
    x2: 378.925,
    y2: 651.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_58_4",
    x1: 325.29,
    y1: 642.388,
    x2: 332.213,
    y2: 642.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_58_4",
    x1: 309.724,
    y1: 623.377,
    x2: 316.115,
    y2: 623.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_58_4",
    x1: 313.447,
    y1: 630.505,
    x2: 319.384,
    y2: 630.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_58_4",
    x1: 305.845,
    y1: 616.042,
    x2: 312.424,
    y2: 616.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_58_4",
    x1: 319.215,
    y1: 636.926,
    x2: 325.246,
    y2: 636.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_58_4",
    x1: 445.238,
    y1: 614.213,
    x2: 451.895,
    y2: 614.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_58_4",
    x1: 485.721,
    y1: 621.777,
    x2: 491.634,
    y2: 621.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_58_4",
    x1: 468.923,
    y1: 622.276,
    x2: 475.503,
    y2: 622.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_58_4",
    x1: 477.402,
    y1: 623.024,
    x2: 483.981,
    y2: 623.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_58_4",
    x1: 501.229,
    y1: 616.291,
    x2: 507.62,
    y2: 616.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_58_4",
    x1: 493.36,
    y1: 619.533,
    x2: 499.939,
    y2: 619.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_58_4",
    x1: 438.612,
    y1: 609.496,
    x2: 445.465,
    y2: 609.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_58_4",
    x1: 461.284,
    y1: 620.78,
    x2: 467.197,
    y2: 620.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_58_4",
    x1: 508.211,
    y1: 612.241,
    x2: 514.603,
    y2: 612.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_58_4",
    x1: 452.549,
    y1: 618.384,
    x2: 459.559,
    y2: 618.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_58_4",
    x1: 520.695,
    y1: 600.808,
    x2: 526.726,
    y2: 600.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_58_4",
    x1: 533.099,
    y1: 553.953,
    x2: 539.011,
    y2: 553.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_58_4",
    x1: 534.316,
    y1: 570.41,
    x2: 539.798,
    y2: 570.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_58_4",
    x1: 533.756,
    y1: 562.68,
    x2: 540.336,
    y2: 562.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_58_4",
    x1: 433.021,
    y1: 603.263,
    x2: 438.949,
    y2: 603.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_58_4",
    x1: 532.819,
    y1: 578.888,
    x2: 538.302,
    y2: 578.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_58_4",
    x1: 514.809,
    y1: 606.754,
    x2: 520.738,
    y2: 606.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_58_4",
    x1: 525.167,
    y1: 594.264,
    x2: 531.558,
    y2: 594.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_58_4",
    x1: 529.157,
    y1: 586.971,
    x2: 535.549,
    y2: 586.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_58_4",
    x1: 530.885,
    y1: 545.822,
    x2: 536.822,
    y2: 545.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_58_4",
    x1: 607.818,
    y1: 512.061,
    x2: 614.475,
    y2: 512.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_58_4",
    x1: 597.497,
    y1: 524.778,
    x2: 603.528,
    y2: 524.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_58_4",
    x1: 583.485,
    y1: 533.505,
    x2: 589.909,
    y2: 533.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_58_4",
    x1: 590.937,
    y1: 529.619,
    x2: 596.874,
    y2: 529.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_58_4",
    x1: 603.482,
    y1: 518.793,
    x2: 609.513,
    y2: 518.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_58_4",
    x1: 568.009,
    y1: 538.243,
    x2: 573.922,
    y2: 538.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_58_4",
    x1: 575.648,
    y1: 536.394,
    x2: 582.227,
    y2: 536.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_58_4",
    x1: 558.692,
    y1: 537.994,
    x2: 565.271,
    y2: 537.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_58_4",
    x1: 551.052,
    y1: 537.495,
    x2: 556.965,
    y2: 537.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_58_4",
    x1: 617.54,
    y1: 472.912,
    x2: 624.119,
    y2: 472.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_58_4",
    x1: 617.381,
    y1: 489.12,
    x2: 623.294,
    y2: 489.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_58_4",
    x1: 611.807,
    y1: 505.079,
    x2: 618.465,
    y2: 505.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_58_4",
    x1: 615.545,
    y1: 497.349,
    x2: 622.124,
    y2: 497.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_58_4",
    x1: 598.495,
    y1: 436.904,
    x2: 604.525,
    y2: 436.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_58_4",
    x1: 616.603,
    y1: 464.683,
    x2: 622.086,
    y2: 464.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_58_4",
    x1: 618.038,
    y1: 480.642,
    x2: 624.618,
    y2: 480.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_58_4",
    x1: 604.479,
    y1: 442.49,
    x2: 610.51,
    y2: 442.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_58_4",
    x1: 613.408,
    y1: 456.454,
    x2: 619.832,
    y2: 456.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_58_4",
    x1: 609.888,
    y1: 449.223,
    x2: 615.825,
    y2: 449.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_58_4",
    x1: 542.317,
    y1: 535.099,
    x2: 549.327,
    y2: 535.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_58_4",
    x1: 619.863,
    y1: 415.552,
    x2: 625.8,
    y2: 415.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_58_4",
    x1: 648.46,
    y1: 360.203,
    x2: 655.039,
    y2: 360.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_58_4",
    x1: 626.516,
    y1: 411.26,
    x2: 633.096,
    y2: 411.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_58_4",
    x1: 632.641,
    y1: 405.585,
    x2: 638.946,
    y2: 405.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_58_4",
    x1: 641.805,
    y1: 336.514,
    x2: 647.742,
    y2: 336.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_58_4",
    x1: 637.129,
    y1: 329.532,
    x2: 643.434,
    y2: 329.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_58_4",
    x1: 647.802,
    y1: 352.375,
    x2: 653.715,
    y2: 352.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_58_4",
    x1: 610.558,
    y1: 310.332,
    x2: 617.137,
    y2: 310.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_58_4",
    x1: 644.969,
    y1: 343.843,
    x2: 651.548,
    y2: 343.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_58_4",
    x1: 602.918,
    y1: 308.088,
    x2: 608.831,
    y2: 308.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_58_4",
    x1: 618.537,
    y1: 312.825,
    x2: 625.116,
    y2: 312.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_58_4",
    x1: 625.212,
    y1: 317.727,
    x2: 631.415,
    y2: 317.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_58_4",
    x1: 603.916,
    y1: 421.143,
    x2: 609.829,
    y2: 421.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_58_4",
    x1: 631.643,
    y1: 323.298,
    x2: 637.948,
    y2: 323.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_58_4",
    x1: 611.555,
    y1: 419.051,
    x2: 618.134,
    y2: 419.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_58_4",
    x1: 648.46,
    y1: 368.681,
    x2: 655.039,
    y2: 368.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_58_4",
    x1: 642.476,
    y1: 392.37,
    x2: 649.055,
    y2: 392.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_58_4",
    x1: 637.68,
    y1: 399.412,
    x2: 643.883,
    y2: 399.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_58_4",
    x1: 648.521,
    y1: 376.66,
    x2: 654.003,
    y2: 376.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_58_4",
    x1: 645.467,
    y1: 385.236,
    x2: 652.047,
    y2: 385.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_58_4",
    x1: 614.376,
    y1: 272.175,
    x2: 620.313,
    y2: 272.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_58_4",
    x1: 609.457,
    y1: 279.661,
    x2: 616.483,
    y2: 279.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_58_4",
    x1: 599.787,
    y1: 291.879,
    x2: 604.995,
    y2: 291.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_58_4",
    x1: 604.917,
    y1: 286.292,
    x2: 612.044,
    y2: 286.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_58_4",
    x1: 595.94,
    y1: 204.604,
    x2: 603.067,
    y2: 204.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_58_4",
    x1: 603.278,
    y1: 210.363,
    x2: 608.486,
    y2: 210.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_58_4",
    x1: 618.537,
    y1: 247.494,
    x2: 625.116,
    y2: 247.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_58_4",
    x1: 615.666,
    y1: 231.139,
    x2: 621.603,
    y2: 231.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_58_4",
    x1: 611.943,
    y1: 223.805,
    x2: 618.334,
    y2: 223.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_58_4",
    x1: 617.464,
    y1: 239.167,
    x2: 623.807,
    y2: 239.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_58_4",
    x1: 618.378,
    y1: 255.972,
    x2: 624.291,
    y2: 255.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_58_4",
    x1: 589.876,
    y1: 199.867,
    x2: 596.181,
    y2: 199.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_58_4",
    x1: 617.6,
    y1: 264.201,
    x2: 623.083,
    y2: 264.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_58_4",
    x1: 607.455,
    y1: 216.762,
    x2: 613.846,
    y2: 216.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_58_4",
    x1: 582.958,
    y1: 195.877,
    x2: 588.895,
    y2: 195.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_58_4",
    x1: 557.694,
    y1: 190.89,
    x2: 564.274,
    y2: 190.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_58_4",
    x1: 541.736,
    y1: 194.484,
    x2: 548.315,
    y2: 194.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_58_4",
    x1: 549.64,
    y1: 191.991,
    x2: 555.983,
    y2: 191.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_58_4",
    x1: 567.231,
    y1: 191.389,
    x2: 572.714,
    y2: 191.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_58_4",
    x1: 574.101,
    y1: 192.885,
    x2: 580.779,
    y2: 192.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_58_4",
    x1: 444.875,
    y1: 115.592,
    x2: 451.266,
    y2: 115.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_58_4",
    x1: 467.926,
    y1: 107.106,
    x2: 474.505,
    y2: 107.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_58_4",
    x1: 432.423,
    y1: 126.659,
    x2: 438.454,
    y2: 126.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_58_4",
    x1: 460.506,
    y1: 108.602,
    x2: 465.989,
    y2: 108.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_58_4",
    x1: 451.967,
    y1: 111.602,
    x2: 458.546,
    y2: 111.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_58_4",
    x1: 438.408,
    y1: 120.519,
    x2: 444.439,
    y2: 120.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_58_4",
    x1: 520.99,
    y1: 127.727,
    x2: 526.199,
    y2: 127.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_58_4",
    x1: 525.87,
    y1: 134.12,
    x2: 531.533,
    y2: 134.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_58_4",
    x1: 514.416,
    y1: 121.485,
    x2: 521.269,
    y2: 121.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_58_4",
    x1: 508.151,
    y1: 116.582,
    x2: 514.088,
    y2: 116.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_58_4",
    x1: 532.381,
    y1: 149.247,
    x2: 538.318,
    y2: 149.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_58_4",
    x1: 492.363,
    y1: 109.538,
    x2: 498.942,
    y2: 109.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_58_4",
    x1: 476.404,
    y1: 106.857,
    x2: 482.984,
    y2: 106.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_58_4",
    x1: 531.091,
    y1: 182.412,
    x2: 537.028,
    y2: 182.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_58_4",
    x1: 533.756,
    y1: 157.378,
    x2: 540.336,
    y2: 157.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_58_4",
    x1: 485.442,
    y1: 108.202,
    x2: 490.925,
    y2: 108.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_58_4",
    x1: 533.817,
    y1: 173.934,
    x2: 539.299,
    y2: 173.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_58_4",
    x1: 534.096,
    y1: 166.204,
    x2: 540.009,
    y2: 166.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_58_4",
    x1: 529.157,
    y1: 141.525,
    x2: 535.549,
    y2: 141.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_58_4",
    x1: 500.73,
    y1: 113.091,
    x2: 507.122,
    y2: 113.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_58_4",
    x1: -818.552,
    y1: 364.095,
    x2: 785.701,
    y2: 364.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#966F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#C79B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#EEBD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FDCA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#ECBB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "#BE935B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966F40"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.d6669fe8d138beb480c1fea1aa45b9ca.svg";
export { ForwardRef as ReactComponent };